// Oyen Digital FAQ Data - loaded as asset
window.FAQ_DB_DATA = [
      {
        id: "general_formatting_guide",
        title: "How to Format Your Drive (Mac & Windows)",
        category: "Setup",
        products: ["All"],
        keywords: ["format", "reformat", "disk management", "disk utility", "ntfs", "exfat", "hfs+", "apfs", "initialize disk", "unallocated", "format drive windows", "format drive mac", "how to format", "new volume", "erase drive", "format external drive"],
        issue: "general_formatting",
        response: `If your drive needs to be formatted — whether for first use or to switch operating systems — use the steps below.

**On Windows — Disk Management (Oyen drive):**
1. Connect the Oyen drive.
2. Right-click the Start button and select **Disk Management**. If this is a brand new unformatted drive, skip to step 11.

*To fully wipe the Oyen drive (including EFI/Mac partitions):*
3. Press **Windows key + R** to open the Run box.
4. Type \`cmd\` and press **Ctrl + Shift + Enter** to open Command Prompt as administrator, then approve the prompt.
5. Type \`diskpart\` and press Enter.
6. Type \`list disk\` and press Enter, then identify the Oyen drive by its size.
7. ⚠️ Carefully confirm the correct disk number — running the next command on the wrong disk will erase the wrong drive.
8. Type \`select disk X\` (replace X with the Oyen drive's disk number) and press Enter.
9. Type \`clean\` and press Enter to remove all partitions from that drive.
10. Close Command Prompt and return to **Disk Management**.

*Initialize and format the wiped drive:*
11. Find the now **Unallocated** Oyen disk in the list in the lower half of the window.
12. If prompted, choose **GPT** (recommended) and click OK.
13. Right-click the unallocated space, select **New Simple Volume**, and follow the wizard to format as **NTFS** (Windows-only) or **exFAT** (cross-platform).

**On Mac — Disk Utility (Oyen drive):**
1. Connect the Oyen drive.
2. Open **Disk Utility** (Applications > Utilities > Disk Utility).
3. Select the drive in the left sidebar.
4. Click **Erase**.
5. Choose a name, then select **APFS** or **Mac OS Extended (Journaled)** for Mac-only use, or **exFAT** for cross-platform use.
6. Click **Erase** to confirm.

**Recommended formats by use case:**
| Use Case | Format |
|---|---|
| Windows only | NTFS |
| Mac only | APFS or HFS+ (Mac OS Extended) |
| Windows + Mac | exFAT |

**Note:** Formatting erases all data. Back up any important files before proceeding.`
      },
    {
      id: "random_disconnect_0",
      title: "Random Disconnections",
      category: "Connection",
      products: ["All"],
      keywords: ['random disconnect', 'keeps disconnecting', 'randomly disconnects', 'disconnecting randomly', 'keeps ejecting'],
      issue: "random_disconnect",
      response: `Thanks for contacting us about the random disconnecting issue.

**CAUSE: Inadequate Power or Connection**
The issue is typically related to inadequate power or poor connection quality.

**SOLUTION:**

**1. Connect Directly (Bypass Hubs/Docks/Adapters)**
If your drive is connected through a USB hub, dock, or adapter, please bypass it and connect directly to your computer. Hubs often cannot provide adequate power for external drives.

**2. Use the Included Cable**
Use the cables that came included with your drive. Third-party cables may not support proper power delivery or data transfer speeds.

**3. Try Different USB Ports**
Try more than one port on your computer to see if the results change. Rear motherboard ports typically provide more stable power than front panel ports.

**4. Check for Power Management Settings**
For Windows: Control Panel > Power Options > USB Selective Suspend > Disabled
For Mac: System Preferences > Energy Saver > Prevent hard disks from sleeping

If the issue persists after these steps, please let us know and we can investigate further.`
    },
    {
      id: "trim_support_1",
      title: "TRIM Support",
      category: "Maintenance",
      products: ["All", "U32 Shadow", "U34 Bolt", "U35 Bolt+", "Helix", "MiniPro"],
      keywords: ['trim', 'trim support', 'does it support trim', 'trim command', 'garbage collection'],
      issue: "trim_support",
      response: `Thanks for asking about TRIM support!

**YES - All Oyen Digital SSDs support TRIM commands.**

This includes:
- U32 Shadow
- U35 Bolt+
- U34 Bolt
- Helix
- MiniPro RAID V4 (with SSDs installed)

**IMPORTANT: Format Requirements for TRIM**
The SSD **must be formatted** with the correct file system for the OS to TRIM the SSD:

**For Windows:**
- Format as **NTFS** - Windows can TRIM NTFS drives
- Windows provides manual TRIM tool: "Optimize Drives"

**For Mac:**
- Format as **APFS** - macOS can TRIM APFS drives
- **Note:** Apple does not provide a manual TRIM tool like Windows does
- TRIM happens automatically in the background

**exFAT and TRIM:**
- exFAT does **NOT** support TRIM commands
- If cross-platform compatibility is needed, you'll sacrifice TRIM functionality

For best performance and longevity on your Oyen Digital SSD, use NTFS (Windows) or APFS (Mac).`
    },
    {
      id: "cant_eject_mac_2",
      title: "Cannot Eject Drive on Mac",
      category: "Mac",
      products: ["All"],
      keywords: ['won\'t eject', 'can\'t eject mac', 'eject failed', 'disk in use', 'eject error mac', 'cannot eject'],
      issue: "cant_eject_mac",
      response: `Thanks for contacting us about the macOS ejection issue.

**CAUSE: Spotlight Indexing**
An external drive will sometimes refuse to properly eject in macOS. This is commonly caused by the **Spotlight function** continuously accessing the drive to index its contents.

**SOLUTION: Exclude Drive from Spotlight**

**Step-by-Step:**
1. Go to **System Preferences** (or System Settings on newer macOS)
2. Click **Spotlight**
3. Click the **Privacy** tab
4. Click the **(+)** plus icon at the bottom
5. Select your external drive
6. Click **Choose**

Your drive will no longer be accessed by Spotlight and should eject normally.

**Alternative Solutions:**

**If Spotlight exclusion doesn't work:**
1. **Close all applications** that might be accessing the drive
2. **Check Activity Monitor** (Applications > Utilities) for processes using the drive
3. **Force eject:** Hold Option key and right-click the drive icon, select "Force Eject"
4. **Terminal method:** Open Terminal and type: diskutil eject /Volumes/[DriveName]

**Prevention Tips:**
- Always exclude external drives from Spotlight if they contain large amounts of data
- Close applications before ejecting
- Don't disconnect during file transfers

This solution works for all Oyen Digital products: U34 Bolt, U32 Shadow, Helix, Novus, Mobius, MiniPro, Fortis.`
    },
    {
      id: "ssd_hot_3",
      title: "SSD Feels Hot / Overheating",
      category: "Hardware",
      products: ["All", "U32 Shadow", "U34 Bolt", "U35 Bolt+", "Helix"],
      keywords: ['ssd hot', 'drive hot', 'feels hot', 'too hot', 'overheating', 'warm', 'hot to touch'],
      issue: "ssd_hot",
      response: `Thanks for asking about the temperature of your SSD.

**THIS IS NORMAL BEHAVIOR**

It is completely normal for your Oyen Digital SSD to feel hot to the touch after extended use.

**Why Aluminum Housing is Actually GOOD:**
The specially designed **aluminum housing** protects the flash chips and controller by:
1. **Absorbing heat** generated during prolonged activity
2. **Dissipating heat** through the air via the aluminum
3. **Preventing internal damage** from trapped heat

**Why NOT Plastic:**
If the housing was made of **plastic** (as some competitors use):
- The drive would feel **cooler to the touch**
- BUT the heat would be **trapped inside** the housing
- This causes **poor performance** and **potential damage** to internal components

**The Heat Means It's Working Properly:**
- Aluminum conducts heat away from sensitive components
- Warm exterior = components are being protected
- This design ensures longevity and consistent performance

**When to Be Concerned:**
- If the drive is too hot to touch for more than a few seconds
- If the drive shuts down due to thermal protection
- If performance degrades significantly

Otherwise, a warm SSD is a healthy SSD!

Applies to: U34 Bolt, U35 Bolt+, U32 Shadow, Helix, and all Oyen Digital SSD products.`
    },
    {
      id: "power_4",
      title: "Power Issues / Won't Turn On",
      category: "Power",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['mobius won\'t power', 'lost power', 'no power', 'won\'t turn on mobius', 'mobius not powering'],
      issue: "power",
      response: `Thanks for contacting us about your Mobius power issue. Let's get this resolved.

**SOLUTION: Power Supply Reset**

**STEP 1: 3-4 Minute Reset**
1. Turn off the power switch
2. **Remove the power cord** from both the Mobius and the wall
3. **Let it sit for 3-4 minutes** (not just 30 seconds)
4. Reconnect the power cord
5. Turn on the power switch

**Why 3-4 minutes?** The Mobius has an overcurrent protection circuit that needs time to fully reset.

**STEP 2: Check Results**

**If lights and fan come on:** Problem resolved! The overcurrent protection was triggered and has been reset.

**If NO lights or power at all:** This indicates a **failed power supply**.

**Good News:** The power supply is **user-replaceable** and available in the Accessories section of oyendigital.com.

**IMPORTANT: Normal Handshake Behavior**
Note that the Mobius will shut down after a few seconds if it doesn't receive a handshake from the host computer. The blue lights will remain off if no handshake is received. This is normal behavior, not a defect. Try connecting with a different cable or USB port to establish the handshake.

**If Issues Persist:**
After the 3-4 minute reset, if you still have no power, please contact us for a power supply replacement or RMA if the unit is under warranty.`
    },
    {
      id: "hub_ports_5",
      title: "MiniPro Hub Ports (USB-A & USB-C)",
      category: "Connectivity",
      products: ["MiniPro", "MiniPro RAID"],
      keywords: ['minipro hub', 'usb-a and usb-c', 'both hubs', 'simultaneous ports', 'use both ports'],
      issue: "hub_ports",
      response: `Thanks for asking about the MiniPro RAID V4 hub functionality!

**YES - You can use both hub ports simultaneously!**

The MiniPro RAID V4 allows you to utilize **both the USB-A and USB-C hub ports at the same time**.

**IMPORTANT: Power Recommendation**

If the devices you're connecting to the hub ports are **bus-powered** (drawing power from USB), we **strongly recommend**:

1. **Move the DC/USB switch to the DC position**
2. **Connect the external power adapter**

This ensures adequate power for:
- The MiniPro RAID itself
- Both drives inside
- Any devices connected to the hub ports

**Power Considerations:**
- **DC Mode (with power adapter):** Supports bus-powered devices on both hubs + full RAID performance
- **USB Mode (bus-powered):** May not provide enough power for hub devices + RAID operations

**Best Practices:**
- For maximum stability, always use DC mode with power adapter
- Especially important in RAID mode with 2 drives
- The V4 can handle both USB-A and USB-C simultaneously with 15W hub power in DC mode

This makes the MiniPro V4 a great hub solution for your workspace while also providing RAID storage!`
    },
    {
      id: "power_6",
      title: "Power Issues / Won't Turn On",
      category: "Power",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['power', 'psu', 'not turning on', 'shut down', 'handshake'],
      issue: "power",
      response: `Thanks for contacting us about your Mobius power issue. Let's troubleshoot this step by step.

**STEP 1: Overcurrent Protection Reset**
The Mobius has an overcurrent protection circuit that can get triggered. Turn off the power switch and remove both the power cable and power cord from the Mobius. Let it sit for at least 3-4 minutes (not just 30 seconds). Then reconnect and power on.

**STEP 2: Check for Power Supply Failure**
If there are NO lights or fan activity after the reset, this indicates a failed power supply. The good news is the power supply is user-replaceable and available in the Accessories section of oyendigital.com.

**IMPORTANT: Normal Shutdown Behavior**
Note that the Mobius will shut down after a few seconds if it doesn't receive a handshake from the host computer. The blue lights will remain off if no handshake is received. This is NORMAL behavior, not a defect. Try connecting with a different cable or USB port to establish the handshake.

Please let me know if this resolves your issue or if you need further assistance.`
    },
    {
      id: "exfat_mac_corruption_7",
      title: "exFAT Corruption on Mac",
      category: "Mac",
      products: ["All"],
      keywords: ['exfat mac', 'exfat corruption', 'exfat not mounting', 'greyed out mac', 'grayed out mac', 'exfat sonoma', 'exfat ventura', 'exfat monterey'],
      issue: "exfat_mac_corruption",
      response: `Thanks for contacting us about your exFAT drive issue on Mac. This is a **known compatibility issue** with newer macOS versions, particularly **Sonoma** and **Sequoia**.

**CRITICAL ISSUE: exFAT Corruption on Newer macOS**
Based on 252 support cases, exFAT drives are prone to corruption on macOS Sonoma (14.x) and Sequoia (15.x). This appears as:
- Drive shows as "greyed out" in Disk Utility
- Won't mount or mounts as read-only
- "Disk not readable" errors
- First Aid fails or reports file system errors

**IMMEDIATE SOLUTION 1: Windows Repair (FASTEST & MOST EFFECTIVE)**
Windows has significantly better exFAT repair tools than macOS:
1. Connect the drive to a **Windows computer**
2. Windows will automatically prompt: "You need to scan and fix this drive"
3. Click **"Scan and fix"** (or "Repair drive")
4. Wait for completion (usually 5-30 minutes)
5. Safely eject and reconnect to your Mac
6. The drive should now mount normally

**Why Windows?** Based on 90 cases in our database, Windows exFAT repair has a 95%+ success rate vs. Mac First Aid's ~30% success rate.

**SOLUTION 2: Mac First Aid (If No Windows Access)**
1. Open Disk Utility (Applications > Utilities > Disk Utility)
2. View > Show All Devices
3. Select the **top-level drive** (not the indented partition)
4. Click "First Aid"
5. If it fails, select the **greyed-out partition** below and try First Aid again

**IMPORTANT:** If First Aid completes but drive still won't mount, you'll need Windows repair or reformatting.

**SOLUTION 3: Terminal fsck_exfat (Advanced Mac Users)**
If First Aid fails and you don't have Windows access:
1. Open Terminal (Applications > Utilities > Terminal)
2. Type: diskutil list
3. Find your drive identifier (e.g., disk2s1)
4. Type: sudo fsck_exfat -d /dev/disk2s1 (replace with your disk ID)
5. Enter your Mac password when prompted
6. Wait for completion

**LONG-TERM SOLUTION: Reformat to Better Filesystem**
After recovering your data, we **strongly recommend** reformatting:

**For Mac-Only Use (BEST OPTION):**
- **macOS Sonoma/Sequoia:** Format as **APFS**
  - Most reliable on newer macOS
  - Best performance
  - Least corruption-prone

- **Older macOS (pre-Sonoma):** Format as **Mac OS Extended (Journaled)**
  - Rock-solid reliability
  - Decades of stability
  - No corruption issues

**For Mac + Windows Use:**
- **exFAT** works but requires careful handling:
  - ALWAYS eject properly (never unplug without ejecting)
  - Avoid disconnecting during file transfers
  - Consider Windows repair tools readily available
  - More prone to corruption on macOS Sonoma+

**Why This Happens:**
Apple's exFAT implementation has compatibility issues with newer macOS versions (14.x Sonoma, 15.x Sequoia). Windows' exFAT implementation is more robust and includes better repair tools.

**Prevention Tips for exFAT Users:**
1. Always eject properly before disconnecting
2. Don't disconnect during file transfers
3. Keep Windows computer available for repairs
4. Consider switching to APFS for Mac-only use
5. Backup regularly (exFAT is less stable than APFS/HFS+)

**Statistics from Our Database:**
- 252 exFAT + Mac cases analyzed
- 200 involved corruption/mounting issues
- 90 successfully resolved with Windows repair
- 81 occurred on macOS Sonoma
- 17 occurred on macOS Sequoia

If Windows repair doesn't work or you need help reformatting, please let me know and I can provide detailed steps.`
    },
    {
      id: "detection_mac_8",
      title: "Drive Not Mounting on Mac",
      category: "Mac",
      products: ["All"],
      keywords: ['not mounting mac', 'not recognized mac', 'not detected mac', 'not showing mac', 'disk utility', 'mac not mounting'],
      issue: "detection_mac",
      response: `Thanks for reaching out about your Mac detection issue. Let's get your drive recognized step by step.

**STEP 1: Basic Disk Utility Troubleshooting**
1. Open Disk Utility (Applications > Utilities > Disk Utility)
2. Go to View menu and select "Show All Devices"
3. Look for your drive in the left sidebar - it may appear even if not mounted
4. If you see it: Select the drive and click "Mount"
5. If that fails: Select the drive and click "First Aid" to repair

**STEP 2: If Drive is Greyed Out or First Aid Fails**
Your drive may have data corruption. Try these advanced steps:

**For exFAT Drives (COMMON ISSUE ON SONOMA/SEQUOIA):**
⚠️ **CRITICAL:** If your drive is formatted as exFAT and appears greyed out in Disk Utility, this is a **known macOS Sonoma/Sequoia compatibility issue**.

**BEST FIX:** Connect the drive to a Windows computer - Windows will automatically prompt to repair. This has a 95%+ success rate based on 90 cases in our database.

For detailed exFAT troubleshooting, type: "exfat corruption mac"

**Alternatively:** Consider reformatting as **APFS** (for Sonoma/Sequoia) or **Mac OS Extended (Journaled)** - both are far more stable than exFAT on Mac.

**STEP 3: Recovery Mode Repair (Advanced)**
If First Aid fails or the drive won't mount:
1. Restart your Mac and hold Command + R to enter Recovery Mode
2. Open Disk Utility from the Recovery menu
3. Select View > Show All Devices
4. Find your drive and run First Aid again
5. If there's a greyed-out partition below the drive, select it and run First Aid on that too

**STEP 4: Terminal Commands (For Advanced Users)**
If Recovery Mode First Aid fails:
1. In Recovery Mode, open Terminal (Utilities > Terminal)
2. Type: diskutil list
3. Find your disk identifier (e.g., disk2)
4. For APFS drives: fsck_apfs -y /dev/diskXsX (replace X with your disk number)
5. For HFS+ drives: fsck_hfs -y /dev/diskXsX

**STEP 5: Third-Party Repair Tools**
If the above steps don't work, consider professional repair software:
- DiskWarrior (highly recommended for Mac)
- Drive Genius
- TechTool Pro

**STEP 6: Check Connection**
If the drive doesn't appear in Disk Utility at all:
- Try a different cable (use the included cable if possible)
- Try a different USB port (avoid hubs)
- Check if the drive shows in System Information (Apple menu > About This Mac > System Report > USB)

**Format Recommendations for Mac:**
- **Mac only:** Mac OS Extended (Journaled) - most stable
- **Mac & Windows:** exFAT - but more prone to corruption
- **Avoid:** APFS for external drives with older Macs

If none of these steps work, please let me know what you're seeing and we can investigate further or arrange a replacement.`
    },
    {
      id: "detection_windows_9",
      title: "Drive Not Showing in Windows",
      category: "Windows",
      products: ["MiniPro", "MiniPro RAID"],
      keywords: ['not mounting windows', 'not recognized windows', 'not detected windows', 'minipro not mounting', 'minipro not detected'],
      issue: "detection_windows",
      response: `Thanks for reaching out about your MiniPro RAID V4 Windows detection issue. Let's get your drive recognized.

**IMPORTANT FOR MINIPRO V4: Check Power First**
The MiniPro V4 has a DC/USB switch on the back. For reliable detection:
1. Move the DC/USB switch to the **DC position**
2. Connect the external power adapter
3. This ensures the drive has sufficient power and stable connection

**STEP 1: Check Device Manager (Critical Diagnostic)**
1. Right-click the Windows Start button
2. Select "Device Manager"
3. Expand "Disk Drives" section
4. Is your MiniPro listed there?

**If NO (drive NOT in Device Manager):**
- Verify DC/USB switch is in DC position with power adapter connected
- Try different USB cable (use included cable)
- Try different USB port (rear motherboard ports preferred)
- Try different computer to isolate issue

**If YES (drive appears in Device Manager):**
- Continue to Step 2 (Disk Management)

**STEP 2: Disk Management**
1. Right-click Windows Start > Select "Disk Management"
2. Look in the LOWER half for your MiniPro (shows as "Disk 1", "Disk 2", etc.)

**Common Scenarios:**
- **Offline:** Right-click disk > Select "Online"
- **No drive letter:** Right-click partition > "Change Drive Letter and Paths" > Add
- **Not Initialized:** Right-click > Initialize (⚠️ erases data - only for new drives)
- **RAW/Corrupted:** Try CHKDSK repair (Step 3)

**STEP 3: CHKDSK Repair (For Data Corruption)**
1. Open Command Prompt as Administrator
2. Type: chkdsk E: /f /r (replace E: with your drive letter)
3. Wait for completion (can take 30+ minutes)

**STEP 4: USB Power Management**
For random disconnects:
1. Control Panel > Power Options > Change Plan Settings
2. Change Advanced Power Settings
3. USB Settings > USB Selective Suspend > Disabled

**MiniPro V4 Specific Notes:**
- The DC/USB switch allows bus-powered mode (USB) or external power (DC)
- For RAID mode with 2 drives, DC mode with power adapter is recommended
- The V4 can use both USB-A and USB-C hub ports simultaneously (15W hub power)

If issues persist after these steps, please let me know what you're seeing and we can investigate further.`
    },
    {
      id: "detection_windows_10",
      title: "Drive Not Showing in Windows",
      category: "Windows",
      products: ["All"],
      keywords: ['not mounting windows', 'not recognized windows', 'not detected windows', 'not showing windows', 'disk management', 'windows not mounting', 'pc not detecting'],
      issue: "detection_windows",
      response: `Thanks for reaching out about your Windows detection issue. Let's get your drive recognized with these comprehensive steps.

**STEP 1: Check Device Manager First (Critical Diagnostic)**
This tells us if Windows can communicate with the drive at all:
1. Right-click the Windows Start button
2. Select "Device Manager"
3. Expand "Disk Drives" section
4. Is your Oyen Digital drive listed there?

**If YES (drive appears in Device Manager):**
- Continue to Step 2 (Disk Management)

**If NO (drive NOT in Device Manager):**
- This indicates a connection or power issue
- Try different USB cable (use included cable if possible)
- Try different USB port (avoid front ports, use rear motherboard ports)
- For MiniPro RAID V4: Ensure DC/USB switch is in DC position and power adapter is connected
- Check if other USB devices work in the same port
- Try different computer to isolate issue

**STEP 2: Disk Management (Primary Tool)**
1. Right-click the Windows Start button
2. Select "Disk Management"
3. Look in the LOWER half of the window for your drive
4. The drive may show as "Disk 1", "Disk 2", etc.

**Common Disk Management Scenarios:**

**Scenario A: Disk shows as "Offline"**
- Right-click the disk (left side where it says "Disk 1", "Disk 2")
- Select "Online"
- The disk should now mount

**Scenario B: Disk shows but has no drive letter**
- Right-click the partition (right side, the blue/colored bar)
- Select "Change Drive Letter and Paths"
- Click "Add"
- Assign a drive letter (E:, F:, G:, etc.)
- Click OK

**Scenario C: Disk shows as "Not Initialized"**
- ⚠️ WARNING: Initializing will erase data!
- If this is a NEW drive: Right-click and select "Initialize Disk"
- Choose GPT (recommended for drives >2TB)
- If this is an EXISTING drive with data: DO NOT initialize - try Step 3 instead

**Scenario D: Disk shows as "RAW" or unformatted**
- This indicates data corruption or formatting issue
- Try Step 3 (CHKDSK repair) before reformatting

**STEP 3: CHKDSK Repair (For Data Corruption)**
If the drive shows in Disk Management but won't mount or shows as RAW:
1. Press Windows key + X
2. Select "Command Prompt (Admin)" or "Windows PowerShell (Admin)"
3. Type: chkdsk E: /f /r (replace E: with your drive letter)
4. Press Enter and wait (can take 30min - 2+ hours for large drives)

**For exFAT drives:** Windows has excellent exFAT repair tools and will often prompt automatically to repair when connected.

**STEP 4: USB Power Management (For Random Disconnects)**
If the drive appears but keeps disconnecting:
1. Control Panel > Power Options
2. Click "Change Plan Settings" next to your current plan
3. Click "Change Advanced Power Settings"
4. Expand "USB Settings"
5. Expand "USB Selective Suspend Setting"
6. Set to "Disabled" for both battery and plugged in
7. Also check: Hard Disk > Turn off hard disk after = Never

**STEP 5: Driver Updates**
If Device Manager shows the drive with a yellow exclamation mark:
1. Right-click the device in Device Manager
2. Select "Update Driver"
3. Choose "Search automatically for drivers"
4. Or check your motherboard manufacturer's website for USB controller driver updates

**STEP 6: Check Drive Properties**
If drive appears in Disk Management:
1. Right-click the drive
2. Select "Properties"
3. Check the "Volumes" tab for drive information
4. Check "Hardware" tab for device status

**STEP 7: DISKPART (Advanced - For GPT/MBR Issues)**
If you need to check or convert partition style:
1. Press Windows key, type "diskpart"
2. Right-click and "Run as Administrator"
3. Type: list disk
4. Check if there's an asterisk (*) under the "GPT" column for your disk
5. For drives >2TB, GPT is required

**Format Recommendations for Windows:**
- **Windows only:** NTFS - most stable and supports large files
- **Windows & Mac:** exFAT - cross-platform compatible but more prone to corruption
- **Note:** Drives >2TB must use GPT partition style

**Still Not Working?**
If the drive doesn't appear in Device Manager at all after trying different cables and ports, this may indicate a hardware failure. Please let us know what you're seeing and we can help with next steps or arrange a replacement.`
    },
    {
      id: "detection_11",
      title: "Drive Not Detected",
      category: "Setup",
      products: ["All"],
      keywords: ['not mounting', 'not recognized', 'not detected', 'not showing'],
      issue: "detection",
      response: `Thanks for reaching out about your detection issue. Let's get your drive recognized.

**For Mac Users:**
1. Open Disk Utility (Applications > Utilities > Disk Utility)
2. Go to View menu and select "Show All Devices"
3. Look for your drive in the left sidebar - it may appear even if not mounted
4. If you see it: Select the drive and click "Mount" or run "First Aid"

For advanced Mac troubleshooting including Recovery Mode, exFAT repairs, and Terminal commands, please specify "Mac not mounting" for detailed steps.

**For Windows Users:**
1. Right-click the Windows Start button and select "Disk Management"
2. Look for your drive in the list - it may show as "Unallocated" or "Not Initialized"
3. If it shows as Offline, right-click and select "Online"
4. If it needs a drive letter, right-click and assign one

**Connection Troubleshooting (Both):**
- Try a different cable (use the included cable if possible)
- Try a different USB port (USB 3.0 or higher recommended)
- Connect directly to your computer (avoid USB hubs)

If the drive still doesn't appear, please let me know your operating system and what you're seeing.`
    },
    {
      id: "performance_12",
      title: "Slow Transfer Speeds",
      category: "Performance",
      products: ["All"],
      keywords: ['slow', 'speed', 'performance', 'transfer'],
      issue: "performance",
      response: `Thanks for contacting us about performance. Let's identify the cause of slow speeds.

**Common Causes:**
1. **Cable Quality:** Are you using the included cable? Third-party cables may not support full speeds
2. **Port Type:** Ensure you're connected to USB 3.0+ or Thunderbolt (NOT USB 2.0)
3. **Free Space:** Keep at least 10-15% free space on the drive
4. **File Types:** Many small files transfer slower than large files (this is normal)

**Accurate Speed Testing:**
We recommend using AJA System Test (free) for reliable testing:
- Download: https://www.aja.com/products/aja-system-test
- Set test size to 4GB or larger for accurate results
- Test with the drive connected directly (not through a hub)

**Expected Speeds:**
- USB 3.0: ~500-600 MB/s
- USB 3.2: ~900-1000 MB/s
- Thunderbolt 3/4: ~2000-2700 MB/s

Please run the test and let me know your results. If speeds are significantly below expected, we can investigate further.`
    },
    {
      id: "raid_13",
      title: "RAID Rebuild Time",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay", "MiniPro", "MiniPro RAID"],
      keywords: ['raid', 'rebuild', 'degraded', 'how long'],
      issue: "raid",
      response: `Thanks for asking about RAID rebuild times. Here's what to expect:

**SSD RAID:**
Approximately 1 hour per TB
Example: 2 x 4TB SSDs = ~4 hours

**HDD RAID:**
Approximately 1.5-2 hours per TB
Example: 2 x 4TB HDDs = ~6-8 hours

**MiniPro RAID Specific:**
- HDD: RAID size × 3 hours (Example: 4TB = 12 hours)
- SSD: RAID size × 1 hour (Example: 4TB = 4 hours)

**Important Notes:**
- DO NOT disconnect or power off the unit during rebuild
- The drive LED will blink 2-3 times per second during rebuild
- You CAN disconnect from the computer if using external power
- Performance will be reduced until the rebuild completes
- Times vary based on drive model and specifications

Please let me know if you have other questions about your RAID setup.`
    },
    {
      id: "encryption_password_14",
      title: "Encryption & Password Protection",
      category: "Security",
      products: ["All", "U32 Shadow", "U34 Bolt", "U35 Bolt+", "Helix", "Novus", "Mobius", "MiniPro", "Fortis"],
      keywords: ['encrypt', 'password', 'protect', 'bitlocker', 'filevault', 'security', 'encryption'],
      issue: "encryption_password",
      response: `**How to Encrypt or Password Protect Your Drive:**

You can encrypt your drive using operating system built-in tools. Third-party encryption apps are also available.

**⚠️ NOTE: Encryption can result in slower performance**

**WINDOWS - BitLocker:**
• Built into Windows Pro, Enterprise, and Education editions
• Video Tutorial: https://youtu.be/zeewXPxIN_Y
• Step-by-step visual guide available

**MAC - FileVault:**
• Built into macOS
• Video Tutorial: https://youtu.be/dFJChRl91ss
• Simple setup process

**Third-Party Options:**
There are many third-party encryption and password protection apps available if you need additional features or cross-platform compatibility.

**Performance Impact:**
With modern encryption, you typically won't see more than a 10% performance drop.`
    },
    {
      id: "backup_software_15",
      title: "Backup Software Recommendations",
      category: "Software",
      products: ["All"],
      keywords: ['backup', 'software', 'time machine', 'carbon copy cloner', 'windows backup', 'included software'],
      issue: "backup_software",
      response: `**Backup Software - What's Included:**

Oyen Digital does **NOT** include backup software with drives.

**RECOMMENDED BACKUP SOLUTIONS:**

**For Mac:**
• **Time Machine** (built-in, free)
  - https://support.apple.com/en-us/HT201250
  - Simple, automatic backups
  - Included with macOS

• **Carbon Copy Cloner** (third-party)
  - www.bombich.com
  - Bootable backups
  - Advanced scheduling

**For Windows:**
• **Windows Backup** (built-in, free)
  - https://bit.ly/3AaGx8e
  - File History and System Image
  - Included with Windows

Both operating systems include excellent built-in backup tools. Third-party options provide additional features if needed.`
    },
    {
      id: "shadow_vs_helix_16",
      title: "U32 Shadow vs Helix Comparison",
      category: "Comparison",
      products: ["All", "U32 Shadow", "Helix"],
      keywords: ['shadow', 'helix', 'difference', 'speed', 'nvme', 'sata', 'comparison', 'which is faster'],
      issue: "shadow_vs_helix",
      response: `**U32 Shadow vs Helix - Key Differences:**

**HELIX:**
• Uses **NVMe-based SSD**
• **Speed: Up to 1050 MB/sec**
• Connection: USB 3.2 Gen2 or Thunderbolt required for max speed
• Technology: Latest NVMe technology

**U32 SHADOW:**
• Uses **SATA-based SSD**
• **Speed: Maximum 525 MB/sec**
• Connection: USB 3.0/3.1/3.2 Gen2
• Technology: Proven SATA reliability

**Which Should You Choose?**
• **Helix** if you need maximum speed and have USB 3.2 Gen2 or Thunderbolt
• **Shadow** if you need reliable performance at a better value

Both are excellent drives - the choice depends on your speed requirements and budget.`
    },
    {
      id: "drivers_17",
      title: "Drivers & Software Downloads",
      category: "Software",
      products: ["All"],
      keywords: ['drivers', 'software', 'download', 'install', 'driver needed'],
      issue: "drivers",
      response: `**Drivers for Oyen Digital Drives:**

**NO DRIVERS NEEDED!**

Oyen Digital drives do **NOT** require additional drivers to function with your operating system. They work natively with:
• Windows (all versions)
• macOS (all versions)
• Linux (most distributions)

**If Your Drive Is Not Being Recognized:**
The issue is NOT related to missing drivers. Other factors are responsible:
• Power/connection issues
• Port compatibility
• Drive formatting
• USB power management settings
• Cable problems

Please describe what's happening and I can help troubleshoot the actual issue.`
    },
    {
      id: "create_partitions_mac_18",
      title: "Create Partitions on Mac",
      category: "Mac",
      products: ["All"],
      keywords: ['partition', 'mac', 'disk utility', 'format', 'divide', 'split', 'multiple partitions'],
      issue: "create_partitions_mac",
      response: `**How to Create Multiple Partitions on Mac:**

**Using Disk Utility:**

1. **Open Disk Utility**
   Applications > Utilities > Disk Utility

2. **Select the Disk**
   In the left column, select the disk you want to partition (not a volume under it)

3. **Click Partition Tab**
   Located in the top toolbar

4. **Choose Number of Partitions**
   From the "Volume Scheme" menu, select how many partitions you want

5. **Configure Each Partition:**
   • Click each partition in the pie chart
   • Type a name for it
   • Choose a format (APFS, Mac OS Extended, exFAT)
   • Enter a size

6. **Click Apply**
   Disk Utility will create your partitions

**Tips:**
• Backup data first - partitioning may erase existing data
• APFS is recommended for modern Macs
• Mac OS Extended (Journaled) for older systems`
    },
    {
      id: "delete_partition_windows_19",
      title: "Delete Partitions on Windows",
      category: "Windows",
      products: ["All"],
      keywords: ['delete', 'partition', 'windows', 'diskpart', 'clean', 'remove', 'erase'],
      issue: "delete_partition_windows",
      response: `**How to Delete a Partition in Windows:**

**⚠️ WARNING: This will ERASE ALL DATA on the drive!**

**Using DISKPART Command:**

1. **Open Command Prompt**
   • Click Start Menu
   • Type "diskpart"
   • Press Enter
   • A command window will open

2. **List All Disks**
   • Type: list disk
   • Press Enter

3. **Select Your Disk**
   • Type: select disk x (replace x with your disk number)
   • Example: select disk 1
   • Press Enter

4. **Clean the Disk**
   • Type: clean
   • Press Enter

5. **Confirmation**
   • You'll see "Successful" when complete
   • All formatting and partitions are removed

**After Cleaning:**
You'll need to reinitialize and format the drive in Disk Management before it can be used again.`
    },
    {
      id: "check_smart_data_20",
      title: "Check Drive Health (S.M.A.R.T.)",
      category: "Maintenance",
      products: ["All", "U32 Shadow", "U34 Bolt", "U35 Bolt+", "Helix", "Novus", "Mobius", "MiniPro", "Fortis"],
      keywords: ['smart', 'data', 'health', 'check', 'hd sentinel', 'drivedx', 'monitor', 'drive health'],
      issue: "check_smart_data",
      response: `**How to Check SMART Data:**

SMART data helps determine drive health and identify when a drive is about to fail.

**✅ All Oyen Digital drives and enclosures are SMART-capable**

**Recommended Applications:**

**For Windows:**
• **HD Sentinel** (Windows only)
  - www.hdsentinel.com
  - Comprehensive drive monitoring
  - Alerts for potential failures
  - Works with all Oyen products

**For Mac:**
• **DriveDX** (Mac only)
  - binaryfruit.com/drivedx
  - Complete SMART monitoring
  - Health status tracking
  - Compatible with all Oyen drives

**What SMART Data Shows:**
• Drive temperature
• Power-on hours
• Read/write errors
• Reallocated sectors
• Health percentage
• Predicted failure warnings

Regular SMART monitoring helps prevent data loss by warning you before drives fail.`
    },
    {
      id: "softraid_readonly_21",
      title: "SoftRAID Read-Only Fix",
      category: "SoftRAID",
      products: ["Software"],
      keywords: ['softraid', 'read-only', 'fix', 'validate', 'diskwarrior', 'repair', 'read only'],
      issue: "softraid_readonly",
      response: `**When SoftRAID Array Becomes Read-Only:**

Follow these 4 steps in order:

**STEP 1: Reboot Computer**
• Restart your Mac
• Check if the issue is resolved
• If not, proceed to Step 2

**STEP 2: Validate in SoftRAID** (May take 2+ hours)
• Open SoftRAID application
• Select the RAID volume
• Click Volume > Validate
• Wait for validation to complete
• If this doesn't solve it, proceed to Step 3

**STEP 3: Run Disk Utility First Aid**
• Open Disk Utility
• Select the volume
• Click First Aid
• Let it complete
• If this doesn't solve it, proceed to Step 4

**STEP 4: Use DiskWarrior** ⭐ (Most Certain Solution)
• Purchase DiskWarrior: www.alsoft.com/DiskWarrior/
• Use it to rebuild the volume
• This will most certainly solve the issue
• DiskWarrior can repair problems that Disk Utility cannot

**Why Read-Only Happens:**
Usually caused by directory corruption or file system issues that macOS can't automatically repair.`
    },
    {
      id: "change_raid_mode_data_22",
      title: "Change RAID Mode (Data Warning)",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay", "MiniPro", "MiniPro RAID"],
      keywords: ['change', 'raid', 'mode', 'switch', 'data loss', 'reconfigure', 'different raid'],
      issue: "change_raid_mode_data",
      response: `**Can I Change RAID Mode After Adding Data?**

**❌ NO - YOU CANNOT CHANGE RAID MODE WITHOUT DATA LOSS**

**Critical Information:**
• You **CANNOT** change RAID mode after data has been added
• Stripe size and stripe width **CANNOT** be changed without deleting the array
• **ALL DATA WILL BE LOST** if you change RAID modes

**Why This Limitation Exists:**
RAID configuration is set at the hardware level when the array is created. The way data is distributed across drives (striping, mirroring, parity) cannot be changed without completely rebuilding the array.

**What You Must Do:**
1. **Backup ALL data** to another location
2. Reconfigure the RAID to your desired mode
3. Restore your data to the new array

**There is NO way around this limitation** - it's a fundamental constraint of how RAID systems work.

If you need help selecting the right RAID mode before configuring, I can explain the options!`
    },
    {
      id: "add_drives_raid5_23",
      title: "Add Drives to RAID 5",
      category: "RAID",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['add', 'drives', 'raid 5', 'expand', 'grow', 'add more drives'],
      issue: "add_drives_raid5",
      response: `**Can I Add Drives to RAID 5 Later?**

**❌ NO - You Cannot Add Drives to an Existing RAID 5**

Once a RAID-5 set is created, it **must be cleared and re-created** to add or subtract drives from the set.

**You CANNOT expand a RAID 5 array.**

**What This Means:**
• All data will be lost if you want to add drives
• You must backup, reconfigure, and restore
• No way to expand without losing data

**The Only Way to Add Drives:**
1. Backup ALL data from current RAID 5
2. Clear the RAID configuration
3. Install all drives (including new ones)
4. Create a new RAID 5 with all drives
5. Restore your data

This is a hardware limitation of the Mobius RAID controller.`
    },
    {
      id: "hot_swap_jbod_24",
      title: "Hot-Swap Drives in JBOD",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['hot swap', 'jbod', 'change', 'drives', 'replace', 'swap drives'],
      issue: "hot_swap_jbod",
      response: `**Can I Hot Swap Disks in JBOD Mode?**

**✅ YES - Hot Swapping Works in JBOD Mode**

The Mobius will recognize drives when hot swapped in JBOD mode.

**⚠️ RECOMMENDATION:**
While hot swapping is technically supported, it is **RECOMMENDED to power cycle the Mobius unit between drive changes** whenever possible for best reliability.

**Best Practice:**
1. Eject the drive in your operating system
2. Power off the Mobius
3. Remove the old drive
4. Insert the new drive
5. Power on the Mobius

**Why Power Cycling is Better:**
• Ensures clean initialization
• Prevents potential data corruption
• More reliable detection
• Reduces wear on connectors

JBOD mode is more forgiving than RAID modes, but taking the extra moment to power cycle is always safer.`
    },
    {
      id: "insert_drives_safe_25",
      title: "Insert Drives Without Losing Data",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['insert', 'drives', 'data', 'safe', 'jbod', 'default', 'lose data'],
      issue: "insert_drives_safe",
      response: `**Can I Insert Drives Without Losing Data?**

**✅ YES - Completely Safe!**

You can insert drives into the Mobius without losing any data.

**Why It's Safe:**
The Mobius does **NOT automatically configure a RAID**.

**The default mode is JBOD:**
• **JBOD** = "Just a Bunch Of Disks"
• Each drive operates independently
• Mobius 2C: 2 independent drives
• Mobius 5-Bay: 5 independent drives

**What This Means:**
• Your existing data stays intact
• Each drive remains separate
• No automatic RAID configuration
• You must manually configure RAID if desired

**To Configure RAID:**
You need to manually set the RAID mode using the switches and MODE button. Until you do that, all drives remain independent in JBOD mode.

Your data is safe! 👍`
    },
    {
      id: "transition_raid1_26",
      title: "Transition to RAID 1 (Mirroring)",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['transition', 'raid 1', 'single drive', 'mirror', 'convert', 'create raid 1'],
      issue: "transition_raid1",
      response: `**Can I Transition to RAID 1 from a Single Drive?**

**❌ NO - You Cannot Create RAID 1 Without Data Loss**

You **cannot** create a RAID 1 setup from a single drive without losing the data on the original drive.

**Why This Doesn't Work:**
RAID 1 requires the RAID controller to set up mirroring from the beginning. It cannot convert existing data to a RAID 1 array.

**SOLUTION OPTIONS:**

**Option 1: Use Software Sync (Keep Data)**
• Leave drives in JBOD mode
• Use software to sync between drives
• Software options: Carbon Copy Cloner (Mac), FreeFileSync (Windows)
• Maintains your data, provides backup

**Option 2: Rebuild with RAID 1 (Temporary Data Move)**
1. Move data to another drive temporarily
2. Set up RAID 1 on the Mobius
3. Move data back to the RAID 1 array

**Option 2 is the only way to get true RAID 1 protection**, but requires temporarily backing up your data elsewhere.`
    },
    {
      id: "set_clear_raid_2bay_27",
      title: "Set/Clear RAID Mode (2-Bay)",
      category: "RAID",
      products: ["Mobius 2C", "Mobius"],
      keywords: ['set', 'clear', 'raid', 'mode', 'configure', '2-bay', 'mode button', 'how to set raid'],
      issue: "set_clear_raid_2bay",
      response: `**How to Set/Clear RAID Mode on Mobius 2-Bay:**

**⚠️ IMPORTANT: If switching RAID modes, you MUST perform "Clear" first**

**SET RAID PROCEDURE:**
1. Set the switch on the Mobius to the desired mode (RAID 0, RAID 1, etc.)
2. Connect the Mobius to the host computer
3. Press & hold the MODE button while turning on the power
4. Continue holding the MODE button for 7-10 seconds
5. Release the MODE button
6. ✅ RAID mode is now configured

**CLEAR RAID PROCEDURE:**
(Required before changing to a different RAID mode)

1. Set the switch on the Mobius to **JBOD**
2. Connect the Mobius to the host computer
3. Press the MODE button while turning on the power
4. Hold the MODE button for 7-10 seconds
5. Release the MODE button
6. ✅ Any previous RAID mode is removed, drives are now in JBOD mode

**Changing RAID Modes:**
You **MUST** perform the Clear procedure first before switching to a different RAID mode. All data will be lost.`
    },
    {
      id: "dual_raid_setup_28",
      title: "Dual RAID Setup (5-Bay)",
      category: "RAID",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['dual', 'raid', 'two', 'separate', 'multiple', 'raid manager', 'two raids'],
      issue: "dual_raid_setup",
      response: `**How to Set Up Dual RAID on Mobius 5-Bay:**

You can create two separate RAID sets using RAID Manager software.

**DOWNLOAD RAID MANAGER:**
Available under the Resources tab on the product page:

**SETUP PROCEDURE:**

1. **Install RAID Manager Software**
   Download and install on your computer

2. **Open Advanced Mode**
   Launch RAID Manager and click "Advanced"

3. **Create First RAID:**
   • Select the RAID creation icon (2nd icon)
   • Select the drives you want in the first array
   • Choose desired RAID mode (RAID 0, 1, 5, etc.)
   • Click Apply

4. **Create Second RAID:**
   • Repeat the same procedure
   • Select remaining drives
   • Choose RAID mode for second array
   • Click Apply

**⚠️ CRITICAL REQUIREMENT:**
**All drives inside the Mobius MUST be the same make/model** for reliable operation.

Using mixed drive models can cause performance issues and reliability problems.`
    },
    {
      id: "format_before_raid_29",
      title: "Format Drives Before RAID Setup",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay", "MiniPro", "MiniPro RAID"],
      keywords: ['format', 'before', 'raid', 'initialize', 'prepare', 'formatting first'],
      issue: "format_before_raid",
      response: `**Should I Format Drives Before Setting RAID Mode?**

**NOT NECESSARY OR RECOMMENDED**

The drives **can** be formatted prior to setting the RAID mode, but it is:
• NOT necessary
• NOT recommended

**Why You Don't Need To:**
The RAID configuration process will handle the drives appropriately. When you set up the RAID array:
• The RAID controller initializes the drives
• Data structures are created automatically
• Formatting is handled by the RAID system

**What You Should Do Instead:**
1. Install the drives in the enclosure
2. Set the desired RAID mode using switches/buttons
3. Let the RAID controller configure the array
4. THEN format the RAID volume in your operating system

Pre-formatting the individual drives adds an unnecessary step and doesn't improve the process.`
    },
    {
      id: "jbod_raid_together_30",
      title: "JBOD & RAID Together",
      category: "RAID",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['jbod', 'raid', 'together', 'combination', 'mixed', 'large', 'both'],
      issue: "jbod_raid_together",
      response: `**Using JBOD and RAID Together on Mobius 5-Bay:**

**✅ YES - You Can Use Both!**

This 9-step process allows JBOD disks in addition to RAID modes:

**PROCEDURE:**

1. **Insert RAID Array Drives**
   • For RAID 1: Use Bays 1 & 2 only
   • For other RAID: Insert appropriate drives

2. **Set Switches**
   Set the switches for your desired RAID mode

3. **Initialize RAID**
   Hold the SET button while powering up. Continue holding until you hear the 2nd beep

4. **Install Remaining Drives**
   Insert the drives you want to use as JBOD

5. **Open RAID Manager**
   Launch the application in Advanced Mode

6. **Select Advanced RAID Configuration**
   Click the 2nd Icon (Advanced RAID Configuration)

7. **Configure JBOD Drives**
   Under 'Create RAID', select **LARGE** from the dropdown menu

8. **Apply to Each Drive**
   • Select an "Unreleased" drive
   • Click Apply
   • The drive is now configured as JBOD

9. **Repeat for Remaining**
   Repeat steps 7-8 for all remaining JBOD drives

**⚠️ WARNING: Any existing data on these drives will be deleted during this process.**`
    },
    {
      id: "raid0_stripe_size_31",
      title: "RAID 0 Stripe Size",
      category: "RAID",
      products: ["Mobius 2C", "Mobius"],
      keywords: ['stripe', 'size', 'raid 0', 'block', 'specification', 'chunk size'],
      issue: "raid0_stripe_size",
      response: `**RAID 0 Stripe Size - Mobius 2-Bay:**

The stripe size for RAID 0 operation in the Mobius 2-Bay is:

**512 bytes**

This is the block size used when data is distributed across the two drives in RAID 0 configuration.

**What This Means:**
• Data is written in 512-byte chunks
• Alternates between Drive 1 and Drive 2
• Optimized for the Mobius 2-Bay hardware
• Cannot be changed by the user

This stripe size is set by the hardware RAID controller and provides good performance for most use cases.`
    },
    {
      id: "bitlocker_mobius_32",
      title: "BitLocker Encryption on Mobius",
      category: "Security",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['bitlocker', 'encryption', 'performance', 'speed', 'impact', 'encrypt mobius'],
      issue: "bitlocker_mobius",
      response: `**Can I Use BitLocker with Mobius?**

**✅ YES - Fully Compatible**

Mobius enclosures are compatible with BitLocker encryption. There is nothing in the Mobius hardware that prevents BitLocker from functioning.

**Performance Impact:**
With modern encryption, you typically will **NOT see more than a 10% drop in performance**.

**How to Use BitLocker with Mobius:**
1. Set up your RAID array in the Mobius
2. Format the RAID volume as NTFS in Windows
3. Right-click the drive in Windows Explorer
4. Select "Turn on BitLocker"
5. Follow the encryption wizard

**What Gets Encrypted:**
• The entire RAID volume
• All data written to the Mobius
• Requires password/key to access

**Notes:**
• Modern CPUs handle encryption efficiently
• Performance hit is minimal on newer systems
• Slightly more noticeable on older hardware
• Worth it for data security

BitLocker works great with Mobius RAID enclosures! 🔒`
    },
    {
      id: "auto_sleep_timer_reset_33",
      title: "Auto-Sleep Timer Reset",
      category: "Power",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['auto-sleep', 'timer', 'reset', 'power cycle', '20 minutes', 'sleep settings'],
      issue: "auto_sleep_timer_reset",
      response: `**Does Auto-Sleep Timer Reset After Power Cycle?**

**YES - Timer Reverts to 20 Minutes**

The Mobius sleep timer will **revert to 20 minutes** after a power cycle.

**How to Retain Custom Sleep Timer:**
To keep your custom time amount:
• Leave the power switch **ON**
• Keep the Mobius **connected to power**
• Do not power cycle the unit

**What Causes Reset:**
Anytime power is completely disconnected:
• Unplugging the power adapter
• Turning off the power switch
• Power outage

The timer setting is stored in volatile memory and resets when power is lost.

**Default Setting:**
• 20 minutes of inactivity
• Drives spin down
• LEDs turn off
• Unit enters low-power mode

If you need a different timer setting to persist, it must be reconfigured after each power cycle using the RAID Manager software.`
    },
    {
      id: "sas_drives_support_34",
      title: "SAS Drive Compatibility",
      category: "Compatibility",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['sas', 'drives', 'support', 'compatible', 'serial attached scsi', 'sas support'],
      issue: "sas_drives_support",
      response: `**Does Mobius Support SAS Drives?**

**❌ NO - SAS Drives Are NOT Supported**

The Mobius 2-Bay and Mobius 5-Bay do **NOT** support SAS (Serial Attached SCSI) drives.

**What IS Supported:**
• **SATA drives only** (Serial ATA)
• 2.5" SATA drives
• 3.5" SATA drives
• SATA SSDs
• SATA HDDs

**Why SAS Doesn't Work:**
• Different physical connector
• Different electrical signaling
• Different protocol
• Incompatible with SATA controllers

**How to Identify Drive Type:**
• SAS drives have a different connector (usually with two separate connectors)
• SATA drives have a single L-shaped connector
• Check drive specifications label

Make sure you're using SATA drives with your Mobius enclosure.`
    },
    {
      id: "raid_during_rebuild_35",
      title: "Using RAID During Rebuild",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay", "MiniPro", "MiniPro RAID"],
      keywords: ['raid', 'rebuild', 'access', 'data', 'usable', 'speed', 'while rebuilding'],
      issue: "raid_during_rebuild",
      response: `**Can I Access Data While RAID is Rebuilding?**

**✅ YES - RAID Remains Connected and Usable**

You can still access the data when the RAID is rebuilding.

**IMPORTANT NOTES:**

**Speed Impact:**
• Transfer speed will be **slowed down** during rebuild
• The RAID controller is simultaneously:
  - Serving your data requests
  - Rebuilding the failed drive
• Slower speeds are normal and expected

**Typical Rebuild Speed:**
**50-100 GB per hour**

**Rebuild Time Estimates:**
• 1 TB drive: 10-20 hours
• 4 TB drive: 40-80 hours
• 8 TB drive: 80-160 hours
• 12 TB drive: 120-240 hours

**Best Practices During Rebuild:**
• Avoid heavy data transfers if possible
• Don't power off the unit
• Let it complete uninterrupted
• Monitor progress in RAID Manager

**Status Indicator:**
• LED will blink 2-3 times per second during rebuild
• Use RAID Manager software to monitor percentage complete

The array remains fully functional, just with reduced performance until rebuild completes.`
    },
    {
      id: "mobius_shuts_down_seconds_36",
      title: "Mobius Shuts Down After a Few Seconds",
      category: "Power",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['shuts down', 'shuts off', 'seconds', 'power', 'handshake', 'shutdown'],
      issue: "mobius_shuts_down_seconds",
      response: `**Mobius 5-Bay Shuts Down After a Few Seconds - Why?**

**CAUSE: No Handshake Detected from Host Computer**

The Mobius 5-Bay will shut off if there is no handshake detected from the host computer.

**SOLUTIONS:**

**1. Check the Cable Connection**
• Ensure cable is fully seated in both ends
• Check for damaged or bent pins
• Use the included cable if possible

**2. Try a Different Host Port**
• Try different USB ports on your computer
• Rear motherboard ports are often more reliable
• Avoid USB hubs

**3. Ensure Good Connection**
• Make sure USB port is not damaged
• Try on a different computer to isolate the issue
• Check if other devices work in the same port

**4. Check Computer USB Power Settings**
Windows: Control Panel > Power Options > USB Selective Suspend = Disabled
Mac: Energy Saver > Uncheck "Put hard disks to sleep"

**What's Happening:**
The Mobius needs to establish communication with the computer. If it can't detect the host, it shuts down as a safety feature.

If the problem persists after trying all ports and cables, please contact support.`
    },
    {
      id: "psu_replacement_37",
      title: "Power Supply Replacement",
      category: "Power",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['power supply', 'psu', 'replacement', 'replace', 'failed', 'no power'],
      issue: "psu_replacement",
      response: `**Mobius 5-Bay Power Supply Replacement Instructions:**

**✅ The PSU is USER-REPLACEABLE**

**13-STEP REPLACEMENT PROCEDURE:**

**Disassembly:**
1. Remove 6 screws on left and right edges (back of unit)
2. Remove 4 screws on edges (bottom of unit)
3. Place Mobius upright
4. Slide shell off: Hold front section with one hand, pull straight back on shell with other hand
5. Turn Mobius upside down
6. Remove screws under 3 of the 4 feet + 1 screw in center of bottom
   ⚠️ Don't completely remove feet - peel back to expose screws
7. Turn Mobius upright
8. Hold back plate (black one) steady with one hand
9. Pull rest of Mobius away with other hand
   (You should now see PSU and PCB fully)

**PSU Removal:**
10. Unscrew voltage selector switch from back plate
11. Disconnect ALL wires from power supply
    (Leave cables attached to Mobius, not PSU)
12. Remove PSU by removing 4 screws in corners

**PSU Installation:**
13. Install new PSU and screw in place
14. Reconnect all cables
15. Screw voltage selector switch to back plate
16. Slide Mobius back together and re-screw
17. Screw on shell

**Order Replacement PSU:**
Replacement PSUs are available in the Accessories section of our website.`
    },
    {
      id: "raid5_rebuild_process_38",
      title: "RAID 5 Rebuild Process",
      category: "RAID",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['raid 5', 'rebuild', 'failed', 'drive', 'replace', 'beeping', 'red led'],
      issue: "raid5_rebuild_process",
      response: `**How to Rebuild a Failed RAID 5 Drive:**

**Situation:** One hard drive failed (indicated by beeping and Red LED). You bought a new drive.

**REBUILD PROCEDURE:**

**Step 1: Prepare**
• Eject the Mobius in your operating system
• Power off the Mobius unit

**Step 2: Replace Failed Drive**
• Remove the failed drive (the one showing Red LED)
• Insert the new drive in the same bay

**Step 3: Start Rebuild**
• Power on the Mobius
• After a few moments, the light will begin blinking
• **Blink pattern: 2-3 times per second** = rebuild in progress

**Step 4: Monitor Progress** (Optional)
• Download RAID Manager utility from Resources tab
• Use it to monitor rebuild status and percentage
• Available on the Mobius RAID product page

**Rebuild Time:**
• Typical speed: 50-100 GB per hour
• 4TB drive: 40-80 hours
• 8TB drive: 80-160 hours

**IMPORTANT:**
• DO NOT power off during rebuild
• DO NOT remove drives during rebuild
• Array remains accessible but slower during rebuild
• Let it complete uninterrupted

The rebuild process is fully automatic once the new drive is installed!`
    },
    {
      id: "mobius_disconnects_usb_39",
      title: "Mobius USB Disconnection Fix",
      category: "Connection",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['disconnects', 'unmounts', 'usb', 'power', 'settings', 'selective suspend', 'sleep'],
      issue: "mobius_disconnects_usb",
      response: `**Mobius Disconnects When Connected via USB - Fix:**

This is caused by computer power management settings trying to save power by shutting down USB devices.

**SOLUTION - CHANGE POWER SETTINGS:**

**WINDOWS 7/8/10:**
1. Control Panel > Power Options
2. Click "Change plan settings"
3. Click "Change advanced power settings"
4. **Hard Disk** > Turn off hard disk after = **Never**
5. **USB Settings** > USB Selective Suspend = **Disabled**
6. Click Apply

**WINDOWS 11 ADDITIONAL FIX:**
Device Manager Method:
1. Open Device Manager
2. Expand "Universal Serial Bus controllers"
3. For EACH "USB Root Hub (USB 3.x)" / "USB Hub":
   • Right-click > Properties
   • Go to Power Management tab
   • **UNCHECK** "Allow the computer to turn off this device to save power"
4. Restart computer

**MAC:**
1. System Preferences > Energy Saver
2. **UNCHECK** "Put hard disks to sleep when possible"

**STILL HAVING TROUBLE?**
Try another USB cable (use the included cable if possible).

These settings prevent your computer from powering down the Mobius to "save energy" - which causes disconnections.`
    },
    {
      id: "auto_shutoff_30min_40",
      title: "Auto Shutoff After 30 Minutes",
      category: "Power",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['auto', 'shut off', 'sleep', '30 minutes', 'inactive', 'turns off automatically'],
      issue: "auto_shutoff_30min",
      response: `**Why Does Mobius Shut Off Automatically After 30 Minutes?**

**This is NORMAL BEHAVIOR - Auto-Sleep Mode**

If there is **no HDD access for 30 minutes**, the RAID will go to sleep to save power.

**What Happens:**
• LEDs turn off
• Drives spin down
• Fans turn off
• Unit enters low-power mode

**Wake Up:**
The unit **wakes up as soon as you access the drive**. Just click on it or try to open a file.

**⚠️ IMPORTANT NOTE:**
**JBOD mode does NOT support auto-sleep mode**

Only RAID modes (RAID 0, RAID 1, RAID 5, etc.) have the auto-sleep feature.

**To Change Sleep Timer:**
Use the RAID Manager software to adjust the sleep timer to a different duration if 30 minutes doesn't work for your needs.

**Why This Feature Exists:**
• Reduces power consumption
• Extends drive lifespan
• Reduces heat generation
• Quieter when not in use

This is energy-efficient design, not a malfunction!`
    },
    {
      id: "spontaneous_disconnect_mac_41",
      title: "Spontaneous Disconnect on Mac",
      category: "Mac",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['spontaneous', 'disconnect', 'long period', 'unmount', 'mac', 'disappeared'],
      issue: "spontaneous_disconnect_mac",
      response: `**Mobius Spontaneously Disconnected After Long Use (Mac):**

**DIAGNOSTIC STEPS:**

**STEP 1: Check LED Indicators**
Look at the drive bay LEDs on the front:
• **All LEDs are BLUE** = No drive failure, not a hardware issue
• **Red LED** = Drive failure detected

**STEP 2: Check Disk Utility**
Open Disk Utility:
• If Mobius is present but **not mounted**:
  1. Select the volume
  2. Click First Aid
  3. Run Verify/Repair
  4. This may solve issues related to the partition table

**STEP 3: Use DiskWarrior** (If First Aid Fails)
If Disk Utility can't fix it:
• **DiskWarrior** is highly recommended: www.alsoft.com/DiskWarrior/
• DiskWarrior often solves issues that Disk Utility cannot resolve
• Can rebuild directories that macOS tools can't fix
• Worth the investment for RAID arrays

**STEP 4: Check RAID Manager**
Open RAID Manager application:
• Check for drive failure indicators
• Verify RAID status
• Look for any warnings or errors

**If All LEDs are Blue and RAID Manager Shows No Failures:**
The issue is likely:
• File system corruption (not drive failure)
• Power management settings
• USB connection issue

DiskWarrior is your best solution for file system corruption issues.`
    },
    {
      id: "fortis_sleep_42",
      title: "Fortis Sleep/Spin-Down Behavior",
      category: "Power",
      products: ["Fortis"],
      keywords: ['fortis', 'sleep', 'computer', 'spin down', 'power', 'goes to sleep'],
      issue: "fortis_sleep",
      response: `**Does Fortis Go to Sleep with Computer?**

**The Fortis does NOT have a sleep timer.**

However, it **WILL respond to OS sleep commands.**

**What This Means:**

**If your computer is configured to sleep:**
• The Fortis drives will spin down when computer goes to sleep
• Responds to OS-level sleep commands
• Wakes when computer wakes

**⚠️ NOTE:**
**There may be a several minute delay** after the computer sleeps before the Fortis drives spin down.

**How It Works:**
1. Computer goes to sleep
2. OS sends sleep command to external drives
3. Fortis receives the command
4. After a few minutes, Fortis drives spin down

**This is Different From:**
• Built-in auto-sleep timer (Fortis doesn't have this)
• Independent sleep scheduling
• Time-based automatic sleep

The Fortis will only sleep when your computer tells it to sleep.`
    },
    {
      id: "smart_monitoring_2c_43",
      title: "S.M.A.R.T. Monitoring on Mobius 2C",
      category: "Maintenance",
      products: ["Mobius 2C", "Mobius"],
      keywords: ['smart', 'monitoring', 'mobius', '2c', 'hd sentinel', 'check drives'],
      issue: "smart_monitoring_2c",
      response: `**Does Mobius 2C RAID Support SMART Monitoring?**

**✅ YES - Full SMART Support**

The individual drives in the Mobius 2C RAID can be monitored using SMART monitoring applications.

**RECOMMENDED APPLICATION:**

**HD Sentinel** (Windows only)
• Website: www.hdsentinel.com
• Monitors each drive individually
• Shows health status
• Temperature monitoring
• Predictive failure alerts
• Works through the RAID enclosure

**What You Can Monitor:**
• Drive health percentage
• Temperature
• Power-on hours
• Error counts
• Reallocated sectors
• Performance degradation

**Why This Matters:**
SMART monitoring helps you identify failing drives BEFORE they fail completely, giving you time to:
• Backup your data
• Order a replacement drive
• Plan the drive replacement

All Oyen Digital products support SMART pass-through!`
    },
    {
      id: "red_led_bay_44",
      title: "Red LED on Drive Bay",
      category: "Hardware",
      products: ["Mobius 2C", "Mobius"],
      keywords: ['red', 'led', 'bay', 'mount', 'fail', 'swap', 'wont mount'],
      issue: "red_led_bay",
      response: `**One Bay Shows Red LED and Won't Mount - Diagnostic:**

**DIAGNOSTIC PROCEDURE:**

**Situation:** Two drives inserted, one mounts fine, one shows red LED

**Step 1: SWAP THE DRIVES**
• Remove both drives
• Put the working drive in the "bad" bay
• Put the "bad" drive in the working bay
• Observe what happens

**Step 2: INTERPRET RESULTS**

**If problem stays with SAME BAY:**
• **Faulty Mobius unit** (bay hardware issue)
• The enclosure bay is defective
• Contact support for replacement

**If problem FOLLOWS THE DRIVE:**
• **Faulty hard drive** (drive hardware issue)
• The drive itself is defective
• Replace the drive

**Step 3: CONTACT SUPPORT (If Mobius Issue)**
If you suspect the Mobius unit is faulty:
• Provide diagnostic results
• Include purchase information
• We'll help arrange replacement

**This simple swap test definitively identifies whether it's the enclosure or the drive causing the problem.**`
    },
    {
      id: "raid1_auto_rebuild_45",
      title: "RAID 1 Automatic Rebuild",
      category: "RAID",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ['raid 1', 'auto', 'rebuild', 'automatic', 'mirror', 'hot swap', 'auto rebuild'],
      issue: "raid1_auto_rebuild",
      response: `**Will RAID 1 Auto-Rebuild on Mobius?**

**✅ YES - Fully Automatic Rebuild**

Simply remove the defective drive and install a new, un-formatted drive. The automatic rebuild process will begin.

**AUTOMATIC REBUILD PROCEDURE:**
1. Power off Mobius (optional but recommended)
2. Remove the defective drive (the one with Red LED)
3. Install a **new, un-formatted drive**
4. Power on (if you powered off)
5. ✅ Automatic rebuild begins immediately

**MANUAL INITIATION:**
To manually initiate an auto-rebuild (simulate drive failure):

1. Power Mobius **down**
2. **Remove a drive** (simulates failure)
3. Power **up** without the drive
   • This tells Mobius a drive has "failed"
4. Insert the new disk
5. Automatic rebuild will begin

**DURING REBUILD:**
• LED blinks 2-3 times per second
• Use RAID Manager to monitor progress
• Typical speed: 50-100 GB per hour
• Array remains accessible (slower performance)

**IMPORTANT:**
The new drive must be:
• Same size or larger than original
• Un-formatted (Mobius will format it)
• Mechanically compatible (2.5" or 3.5" matching original)`
    },
    {
      id: "ssd_raid0_performance_46",
      title: "SSD RAID 0 Performance",
      category: "Performance",
      products: ["MiniPro", "MiniPro RAID"],
      keywords: ['ssd', 'raid 0', 'performance', 'speed', 'boost', '900', 'ssds'],
      issue: "ssd_raid0_performance",
      response: `**Will SSD RAID 0 Provide Significant Performance Boost?**

**It Depends on Your Connection Type:**

**USB 3.0:**
• ❌ RAID 0 with two SSDs **won't provide much speed benefit**
• USB 3.0 bandwidth limits: ~400-500 MB/sec max
• Single SSD already maxes out USB 3.0
• RAID 0 doesn't help with bandwidth-limited connection

**USB 3.2, USB4, or Thunderbolt:**
• ✅ Speed increase will be **SIGNIFICANT** over other modes
• **Speeds can reach over 900 MB/sec in RAID 0**
• Full potential of SSDs can be utilized
• Noticeable real-world performance improvement

**SPEED VARIABLES:**
• Lower capacity SSDs will be slightly slower than higher capacity
• Drive model and specifications matter
• Test parameters affect results
• Host system performance impacts results

**REAL-WORLD NUMBERS:**
• Single SSD: ~525 MB/sec
• RAID 0 (USB 3.2/USB4/TB): 900+ MB/sec
• Nearly 2x speed improvement with proper connection

**RECOMMENDATION:**
If you have USB 3.2, USB4, or Thunderbolt: RAID 0 with SSDs is definitely worth it!
If you only have USB 3.0: Single SSD is sufficient.`
    },
    {
      id: "bus_power_requirement_47",
      title: "Bus Power Requirements",
      category: "Specifications",
      products: ["U34 Bolt", "U35 Bolt+"],
      keywords: ['bus power', 'bus-power', 'power requirement', 'power draw', 'how much power', 'power does', 'watt', 'watts', 'wattage', 'power consumption', 'power needed', 'power use', 'usb power'],
      issue: "bus_power_requirement",
      response: `**U34 Bolt & U35 Bolt+ Bus Power Requirements:**

Both the U34 Bolt and U35 Bolt+ are bus-powered devices — they draw power directly from your computer's USB4/Thunderbolt port. No external power adapter is needed.

**U34 Bolt — Power Draw by Capacity:**
• **1TB & 2TB models:** Up to 7.5W
• **4TB model:** Up to 10W
• **8TB model:** Up to 15W

**U35 Bolt+ — Power Draw:**
• Bus-powered via USB-C (USB4 80Gbps). The USB4/Thunderbolt port must support adequate power delivery.
• If you experience detection issues, connect directly to the computer rather than through a hub or dock.

**What This Means:**
• Standard USB-C/Thunderbolt 3/4/5 ports provide up to 15W or more — all models of both drives work with any compatible port
• Hubs and docks may not pass through enough power, especially for higher-capacity models
• Always use the included cable for proper power delivery

**Troubleshooting Power Issues:**
• Connect directly to the computer (bypass hubs/adapters)
• Use a Thunderbolt 3/4/5 or USB4 port (⚡ symbol or USB4 marking)
• Use the included cable — third-party cables may not support full power delivery
• Try a different port on your computer`
    },
    {
      id: "ipad_compatibility_48",
      title: "iPad / Mobile Device Compatibility",
      category: "Compatibility",
      products: ["All", "U32 Shadow", "U34 Bolt", "U35 Bolt+", "Helix", "Novus"],
      keywords: ['ipad', 'ipad compatible', 'ipad pro', 'dock', 'hub', 'iphone', 'ios', 'ipad power'],
      issue: "ipad_compatibility",
      response: `**Can I Use My Drive with an iPad?**

**COMPATIBILITY:**

**✅ iPad Pro 3rd Generation and Newer:**
• Fully compatible
• Provides sufficient power
• Works out of the box
• No additional accessories needed

**⚠️ Older iPads:**
• May be compatible technically
• Will **NOT supply enough power** to the drive
• Drive may not spin up or function reliably
• Requires external power solution

**SOLUTION FOR OLDER iPads:**
**Use a powered dock or hub:**
• Provides additional power to the drive
• Allows drive to function properly
• Many options available
• Essential for reliable operation

**WHICH PRODUCTS:**
• U35 Bolt+: iPad Pro 3rd gen+
• U34 Bolt: iPad Pro 3rd gen+
• U32 Shadow: iPad Pro 3rd gen+
• Helix: iPad Pro 3rd gen+
• Other drives: Check power requirements

**WHY POWER MATTERS:**
External drives require more power than iPads typically provide through their USB-C or Lightning ports. Newer iPad Pros have higher power output.`
    },
    {
      id: "thunderbolt_asus_bios_49",
      title: "Thunderbolt ASUS BIOS Settings",
      category: "Connectivity",
      products: ["System Configuration"],
      keywords: ['thunderbolt', 'asus', 'bios', 'windows 10', 'enable', 'pcie', 'motherboard'],
      issue: "thunderbolt_asus_bios",
      response: `**Thunderbolt Setup on ASUS Motherboards (Windows 10):**

**⚠️ Additional Steps Required**

There may be additional steps needed to activate Thunderbolt functionality when installing a Thunderbolt expansion card in an ASUS motherboard with Windows 10.

**ACCORDING TO USER FEEDBACK:**

**For ASUS X99-AII with ThunderboltEX II Card:**
(May apply to other ASUS motherboards)

**The Problem:**
• Thunderbolt support is **DISABLED in BIOS by default**
• You need to tell the BIOS which PCIe slot contains the Thunderbolt card

**The Solution:**
1. Enter BIOS setup (usually press DEL or F2 during boot)
2. Find Thunderbolt settings (location varies by BIOS version)
3. **Enable Thunderbolt support**
4. **Specify which PCIe slot** the Thunderbolt card is installed in
5. Save settings and exit BIOS
6. Boot into Windows 10
7. Install Thunderbolt drivers if prompted

**IMPORTANT NOTE:**
This may not apply to all ASUS motherboards and Thunderbolt expansion cards. Some configurations may work without BIOS changes.

**If Thunderbolt isn't working:**
• Check BIOS settings first
• Verify card is properly seated
• Install latest Thunderbolt drivers from ASUS`
    },
    {
      id: "windows11_disconnect_large_transfer_50",
      title: "Windows 11 Disconnect During Large Transfers",
      category: "Windows",
      products: ["All"],
      keywords: ['disconnect', 'large', 'transfer', 'windows 11', 'device manager', 'usb', 'power', 'novus'],
      issue: "windows11_disconnect_large_transfer",
      response: `**Drive Disconnects During Large File Transfers (Windows 11):**

**COMPREHENSIVE FIX - Multiple Solutions:**

**STEP 1: Try Different USB Ports**
• Try both USB-A and USB-C ports if available
• This helps isolate if it's a specific port issue
• Rear motherboard ports often more reliable

**STEP 2: Connect Directly**
• Bypass any USB hubs, docks, or adapters
• Direct connection to computer is most reliable
• Hubs often can't provide adequate power

**STEP 3: Power Options Settings**
1. Open Control Panel
2. Go to Power Options
3. Click "Change plan settings"
4. Click "Change advanced power settings"
5. Find "Turn off hard disk after"
6. Set to **"Never"**
7. Click Apply

**STEP 4: Device Manager USB Power Management** ⭐ (Critical for Windows 11)
1. Open **Device Manager**
2. Expand **"Universal Serial Bus controllers"**
3. For EACH "USB Root Hub (USB 3.x)" / "USB Hub":
   • Right-click > Properties
   • Click **Power Management** tab
   • **UNCHECK** "Allow the computer to turn off this device to save power"
4. Apply to ALL USB hubs listed
5. **Restart computer**

**STEP 5: Try Another Large Transfer**
• Test with a large file (10GB+)
• Monitor if disconnects are resolved

**STEP 6: Reformat if Issues Persist**
• Format the drive as **NTFS** (for Windows)
• Fresh format can resolve file system issues

**STEP 7: Disable ALL Sleep Settings**
• Prevent computer from sleeping during transfers
• Disable screensaver timeouts
• Keep system awake during large transfers

This combination of fixes resolves 95%+ of Windows 11 disconnect issues during large file transfers.`
    },
    {
      id: "ssd_free_space_51",
      title: "SSD Free Space Recommendations",
      category: "Maintenance",
      products: ["All", "U32 Shadow", "U34 Bolt", "U35 Bolt+", "Helix", "MiniPro"],
      keywords: ['free space', 'how much space', 'capacity', 'full ssd', 'leave space', 'how full', 'overprovision', 'performance'],
      issue: "ssd_free_space",
      response: `**How Much Free Space Should You Leave on an SSD?**

**RECOMMENDED: 15% of free space for optimal performance**

**Why This Matters:**
An SSD requires more power as it fills up. Leaving adequate free space ensures:
• Optimal performance
• Longer drive lifespan
• Better wear leveling
• Reduced chance of errors and corruption

**SPECIFIC RECOMMENDATIONS BY CAPACITY:**

**For 1TB SSD:**
• Leave at least 150GB free
• Keep usage under 850GB

**For 2TB SSD:**
• Leave at least 300GB free
• Keep usage under 1.7TB

**For 4TB SSD:**
• Leave at least 600GB free
• Keep usage under 3.4TB

**For 8TB SSD (or larger):**
• Leave at least 800GB-1.2TB free (10-15%)
• Minimum 10% free space recommended
• 15% ideal for best performance

**WHAT HAPPENS IF TOO FULL:**
• Increased power consumption
• Reduced performance
• Higher chance of corruption
• Faster wear on NAND cells
• Potential for errors during file operations

**GENERAL RULE:**
• **Minimum:** 10% free space
• **Recommended:** 15% free space
• **Never:** Fill to 100% capacity

This applies to all Oyen Digital SSDs: U32 Shadow, U34 Bolt, U35 Bolt+, Helix, and SSD-based RAID arrays.`
    },
    {
      id: "raid_controller_specs_52",
      title: "RAID Controller Specifications",
      category: "Specifications",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['raid controller', 'controller', 'chipset', 'jmicron', 'jmb355', 'hardware raid', 'what controller', 'uses what controller', 'which controller', 'controller does', 'mobius controller', 'mobius chipset', 'uses controller'],
      issue: "raid_controller_specs",
      response: `**Mobius 5-Bay RAID Controller:**

The Mobius 5-Bay RAID uses a **JMicron JMB355 hardware RAID controller**.

**Controller Features:**
• Hardware RAID acceleration (not software-based)
• Supports multiple RAID modes: RAID 0, RAID 1, RAID 3, RAID 5, RAID 10, JBOD, and Combine (Span)
• SATA II (3Gbps) interface to drives
• Compatible with SATA III drives (limited to 3Gbps speed)
• Port multiplier functionality (allows all 5 drives through single connection)
• Only compatible with 512e sector format drives (NOT 4Kn drives)

**RAID Management:**
• Hardware-level RAID configuration via DIP switches on back panel
• JMS56X HW RAID Manager software available for advanced configuration
• Automatic rebuild for redundant RAID modes (RAID 1, 3, 5, 10)

This hardware controller provides dedicated RAID processing without consuming system resources.`
    },
    {
      id: "power_supply_specs_53",
      title: "Power Supply Specifications",
      category: "Specifications",
      products: ["Mobius 5-Bay", "Mobius"],
      keywords: ['power supply', 'psu', 'wattage', 'watts', '150w', 'voltage', 'power specs', 'how much power', 'power does', 'psu provide', 'mobius power', 'mobius psu', 'power rating', 'watt rating'],
      issue: "power_supply_specs",
      response: `**Mobius 5-Bay Power Supply Specifications:**

**PSU Rating: 150 Watts**

**Voltage:**
• Input: 110/240V auto-switching
• Universal voltage support (works worldwide)
• Older units: Manual voltage selector switch on back
• Newer units: Automatic voltage detection

**Power Distribution:**
• Provides power for up to 5x 3.5" SATA drives
• Designed for enterprise/NAS drives (higher power requirements)
• Includes power for controller, fans, and electronics

**User-Replaceable:**
• Yes - 13-step replacement procedure available
• Replacement PSU available from Oyen Digital Accessories

**Overcurrent Protection:**
• Built-in protection circuit
• If unit won't power on: Disconnect AC power for 4-5 minutes to reset protection

**Power Recommendations:**
• Use only enterprise or NAS drives for optimal power management
• WD Red, Toshiba N300, Seagate Exos recommended
• Consumer drives may have inconsistent power profiles

The 150W rating provides adequate power for 5 fully-populated bays with enterprise-grade drives, including peak power during simultaneous spinup.`
    },
    {
      id: "sonoma_exfat_bug_new",
      title: "macOS Sonoma & exFAT Corruption Bug",
      category: "Mac",
      products: ["All", "U32 Shadow", "Helix", "Novus", "Fortis", "MiniPro"],
      keywords: ["sonoma", "exfat", "corruption", "spotlight", "sonoma bug", "exfat corrupt", "sonoma exfat", "14.0", "14.1", "14.2", "14.3"],
      issue: "sonoma_exfat_bug",
      response: `There is a known bug in macOS Sonoma that can cause data corruption on external drives formatted as exFAT. The issue is related to Spotlight Indexing in Sonoma.

**SYMPTOMS:**
- Files become corrupted or inaccessible
- Drive shows as unmountable
- Data appears missing or damaged

**SOLUTION:**

**1. Reformat as APFS or Mac OS Extended (Journaled)**
We strongly recommend reformatting the drive as APFS if your computer is running macOS Sonoma. This eliminates the exFAT compatibility issue.

**2. Disable Spotlight Indexing on External Drives**
To prevent Spotlight from causing corruption:
- Go to System Settings > Siri & Spotlight > Spotlight Privacy
- Add your external drive to the exclusion list
- Apple support article: https://support.apple.com/guide/mac-help/prevent-spotlight-searches-in-files-mchlp2811

**3. Repair Corrupted exFAT Drive**
If your drive is already corrupted, connect it to a Windows computer and repair it:
- Right-click the drive > Properties > Tools > Check
- Or run: chkdsk X: /r /f (X = drive letter)
- Windows exFAT repair tools are much more robust than Mac

**More information:**
https://appleinsider.com/articles/24/04/03/external-drive-support-in-macos-sonoma-is-partially-broken-and-its-probably-apples-fault`
    },
    {
      id: "monterey_12_0_1_format_bug_new",
      title: "macOS Monterey 12.0.1 Formatting Bug",
      category: "Mac",
      products: ["All", "U32 Shadow", "MiniPro", "Novus"],
      keywords: ["monterey", "12.0.1", "format bug", "cannot format", "formatting error", "monterey bug", "update monterey"],
      issue: "monterey_12_0_1_format_bug",
      response: `There is a known bug in macOS Monterey version 12.0.1 that prevents formatting external SSDs and high-capacity drives.

**SYMPTOMS:**
- Unable to format or erase external drives in Disk Utility
- Formatting fails with errors
- Drive appears but cannot be reformatted

**SOLUTION:**
Simply update macOS from 12.0.1 to version 12.1 or later. This resolves the formatting issue.

To check your macOS version: Click the Apple icon > About This Mac.

To update: System Preferences > Software Update.

After updating, retry formatting the drive in Disk Utility.`
    },
    {
      id: "m1_mac_slow_ssd_new",
      title: "Apple M1 Mac Slow External SSD Speeds",
      category: "Mac",
      products: ["Helix", "MiniPro", "U32 Shadow"],
      keywords: ["m1", "m1 mac", "slow ssd", "slow speed m1", "apple silicon slow", "queue command", "m1 performance", "m1 slow"],
      issue: "m1_mac_slow_ssd",
      response: `There is a known issue with Apple M1 Macs that can cause slower-than-expected speeds on external USB-C SSDs. The M1 chip does not send the appropriate queue command when transferring data, which results in reduced performance.

**AFFECTED DEVICES:** M1 MacBook Pro, MacBook Air, Mac Mini, Mac Studio, iMac

**WORKAROUNDS:**

**1. Use a Thunderbolt 3/4 Dock**
Connecting through a Thunderbolt dock sends the queue command properly, restoring normal speeds.

**2. Format as Mac OS Extended (Journaled)**
For best performance with M1 Macs, format the drive as Mac OS Extended (Journaled) instead of APFS or exFAT.

**3. Connect via Thunderbolt Port**
If your drive supports Thunderbolt (U34 Bolt, U35 Bolt+), use a Thunderbolt cable for maximum performance. For the U35 Bolt+, use the included 80Gbps-rated cable.

**EXPECTED SPEEDS:**
- Helix: 560-980 MB/s depending on connection and file type
- U32 Shadow: ~500 MB/s
- MiniPro RAID 0 (SSD): ~800 MB/s read/write with Mac OS Extended

Apple has been investigating this issue. Later macOS updates may include improvements.`
    },
    {
      id: "recovery_mode_disk_repair_new",
      title: "Mac Recovery Mode Disk Repair",
      category: "Mac",
      products: ["All", "U32 Shadow", "Helix", "Novus"],
      keywords: ["recovery mode", "disk repair", "first aid", "boot recovery", "command r", "cannot repair", "repair mac", "fsck"],
      issue: "recovery_mode_disk_repair",
      response: `If Disk Utility cannot repair your drive in normal mode, try repairing from Recovery Mode:

**STEP 1: Boot into Recovery Mode**

**Intel Mac:**
- Restart and hold Command + R during startup

**M1/M2/M3/M4 Mac:**
- Shut down completely
- Press and hold the power button until "Options" appears
- Select Options, then Continue

**STEP 2: Open Disk Utility**
- From the Recovery menu, select Disk Utility
- Click View > Show All Devices
- Select your external drive and click First Aid

**STEP 3: If First Aid Fails, Use Terminal**
- Quit Disk Utility, then open Terminal from the Utilities menu
- Identify your disk ID (e.g., disk2s2) from Disk Utility
- Run the appropriate command based on format:

**For APFS drives:**
fsck_apfs -y -T -D -o /dev/disk2s2

**For exFAT drives:**
fsck_exfat -fy /dev/disk2s2

**For Mac OS Extended (HFS+) drives:**
fsck_hfs -fy /dev/disk2s2

Replace "disk2s2" with your actual disk identifier.

**STEP 4: After Repair**
Close Terminal, open Disk Utility, and check if the drive mounts. If it still fails, the drive may need to be reformatted or professionally recovered.`
    },
    {
      id: "spotlight_indexing_disable_new",
      title: "Disable Spotlight Indexing on External Drives",
      category: "Mac",
      products: ["All"],
      keywords: ["spotlight", "indexing", "disable spotlight", "spotlight external", "background process", "blue light blinking", "slow performance"],
      issue: "spotlight_indexing_disable",
      response: `Spotlight Indexing can cause issues with external drives including slow performance, unexpected LED activity, inability to eject, and in some macOS versions (especially Sonoma), data corruption on exFAT drives.

**SYMPTOMS:**
- Drive LED continuously blinking when not in active use
- Cannot eject drive ("disk in use")
- Slow performance during/after connecting
- Data corruption on exFAT volumes (especially macOS Sonoma)

**HOW TO DISABLE SPOTLIGHT INDEXING:**
1. Go to System Settings > Siri & Spotlight (or System Preferences > Spotlight on older macOS)
2. Click the Privacy tab
3. Click the + button and add your external drive
4. This prevents Spotlight from indexing the drive

Apple support article: https://support.apple.com/guide/mac-help/prevent-spotlight-searches-in-files-mchlp2811

We recommend disabling Spotlight Indexing on all external drives, especially if using macOS Sonoma with exFAT formatted drives.`
    },
    {
      id: "minipro_dc_usb_switch_new",
      title: "MiniPro DC/USB Power Switch",
      category: "Power",
      products: ["MiniPro", "MiniPro RAID"],
      keywords: ["dc usb switch", "dc position", "usb switch", "minipro power", "external power adapter", "dc/usb", "power switch minipro", "red lights minipro"],
      issue: "minipro_dc_usb_switch",
      response: `The MiniPro RAID has a DC/USB power switch that controls how the unit receives power. Many issues (disconnects, red LED lights, drive not detecting, slow speeds) are caused by incorrect switch position.

**RECOMMENDED SETTING: DC Position**
We recommend placing the DC/USB switch in the **DC position** and connecting the external power adapter for reliable operation.

**WHEN TO USE DC MODE:**
- Always recommended for RAID configurations
- Required when using high-capacity drives
- Essential for stable write performance (peak power is consumed during writes)
- When experiencing red LED lights or disconnections

**USB MODE:**
- Only suitable for low-power, single SSD configurations
- Draws power from the computer's USB port
- May cause instability with demanding workloads

**TROUBLESHOOTING:**
If the MiniPro shows red lights, disconnects, or won't mount:
1. Move the DC/USB switch to the DC position
2. Connect the external power adapter to a good AC outlet
3. Turn on the unit
4. Then connect to the computer
5. LED lights should be solid blue when healthy

The DC/USB switch is located on the back of the unit.`
    },
    {
      id: "windows_diskpart_reformat_new",
      title: "Windows Diskpart Clean & Reformat",
      category: "Windows",
      products: ["All"],
      keywords: ["diskpart", "clean", "reformat windows", "raw drive", "unallocated", "cannot format windows", "diskpart clean", "new simple volume"],
      issue: "windows_diskpart_reformat",
      response: `If a drive shows as RAW, unallocated, or cannot be formatted through normal Windows methods, use Diskpart to clean and reformat:

**DISKPART STEPS:**
1. Press Windows + R to open the Run box
2. Type **diskpart** and press Enter
3. A command window will open
4. Type **list disk** and press Enter
5. Identify your external drive by size (be careful not to select your system drive!)
6. Type **select disk X** (X = the disk number) and press Enter
7. Type **clean** and press Enter (this erases all data)
8. Type **create partition primary** and press Enter
9. Type **format fs=ntfs quick** and press Enter (or fs=exfat for cross-platform use)
10. Type **assign** and press Enter
11. Type **exit** and press Enter

**WARNING:** The "clean" command erases all data on the selected disk. Make absolutely sure you select the correct disk.

After completion, the drive should appear in File Explorer with a new drive letter.`
    },
    {
      id: "windows_chkdsk_repair_new",
      title: "Windows CHKDSK Repair",
      category: "Windows",
      products: ["All"],
      keywords: ["chkdsk", "repair windows", "check disk", "corrupt windows", "fix drive windows", "scan and repair"],
      issue: "windows_chkdsk_repair",
      response: `If your external drive shows errors or data corruption on Windows, use CHKDSK to scan and repair:

**CHKDSK STEPS:**
1. Right-click the Windows Start icon
2. Select "Command Prompt (Admin)" or "Windows Terminal (Admin)"
3. Click YES when prompted
4. Type: **chkdsk X: /r /f** (X = your drive letter)
5. Press Enter to start the scan and repair

**Parameters:**
- **/f** — Fixes errors on the disk
- **/r** — Locates bad sectors and recovers readable information

The scan may take several hours depending on drive size. Do not disconnect the drive during the process.

**TIP:** For exFAT drives that were corrupted on a Mac, connecting to Windows and running CHKDSK is often the most effective repair method. Windows exFAT repair tools are more robust than macOS.`
    },
    {
      id: "data_recovery_software_new",
      title: "Data Recovery Software Recommendations",
      category: "Software",
      products: ["All", "U32 Shadow", "Helix", "MiniPro", "Novus", "Mobius"],
      keywords: ["data recovery", "recover files", "disk drill", "disk warrior", "lost data", "corrupted files", "file recovery", "recover data"],
      issue: "data_recovery_software",
      response: `If you need to recover data from a corrupted or damaged drive, here are the recommended tools:

**FOR MAC:**

**Disk Warrior** (Mac OS Extended / HFS+ volumes)
- Best tool for repairing Mac OS Extended (Journaled) partitions
- Can rebuild directories and recover mounted volumes
- Works on Intel Macs with macOS 11 and earlier
- https://www.alsoft.com/

**Disk Drill** (All formats)
- Versatile recovery tool for APFS, HFS+, exFAT, and NTFS
- Free trial available with limited recovery
- Works on both Intel and Apple Silicon Macs
- https://www.cleverfiles.com/

**FOR WINDOWS:**

**Recuva** (Free)
- Good for basic file recovery
- https://www.ccleaner.com/recuva

**EaseUS Data Recovery** (Free trial)
- More comprehensive recovery options
- https://www.easeus.com/

**PROFESSIONAL RECOVERY SERVICES:**
For critical data that cannot be recovered with software:
- DriveSavers
- Ontrack
- Gillware

**IMPORTANT:** Stop using the drive immediately if you suspect data loss. Do not write new data to the drive. Attempt recovery before reformatting.`
    },
    {
      id: "speed_testing_aja_new",
      title: "Speed Testing with AJA System Test",
      category: "Performance",
      products: ["All", "U32 Shadow", "Helix", "Novus", "MiniPro", "Mobius"],
      keywords: ["speed test", "aja", "aja system test", "benchmark", "test speed", "how fast", "transfer speed test", "blackmagic"],
      issue: "speed_testing_aja",
      response: `To accurately test your drive's speed, we recommend AJA System Test (free download):

**DOWNLOAD:**
https://www.aja.com/products/aja-system-test
Available for both Mac and Windows.

**HOW TO TEST:**
1. Download and install AJA System Test
2. Select your external drive as the Target Disk
3. Set test size to 4GB or larger for accurate results
4. Make sure no other programs are accessing the drive during the test
5. Connect directly to the computer (not through a hub)

**EXPECTED SPEEDS BY PRODUCT:**
- **U35 Bolt+:** up to 6000 MB/s (USB4 80G / Thunderbolt 5), up to 3800 MB/s (TB4/USB4 40G), up to 2800 MB/s (TB3 Apple Silicon)
- **U34 Bolt:** ~2800 MB/s read, ~2200 MB/s write (Thunderbolt 3 Apple Silicon)
- **Helix:** ~560-1050 MB/s (USB 3.2 Gen 2)
- **U32 Shadow:** ~500-1000 MB/s read, ~900 MB/s write (USB 3.2 Gen 2)
- **MiniPro RAID 0 (SSD):** ~800 MB/s read/write
- **MiniPro RAID 0 (HDD):** ~250-350 MB/s
- **Novus (HDD):** ~200+ MB/s
- **HDX Pro C:** ~270 MB/s
- **Fortis:** ~200 MB/s
- **Mobius (USB 3.0):** Up to ~600 MB/s (RAID 0)
- **Mobius (FireWire 800):** ~100 MB/s

**NOTE:** If you see speeds of ~40 MB/s or less, the drive is likely connected to a USB 2.0 port. Check that you're using USB 3.0 or higher.`
    },
    {
      id: "format_recommendation_mac_new",
      title: "Recommended Drive Format for Mac",
      category: "Mac",
      products: ["All", "U32 Shadow", "Helix", "Novus", "MiniPro", "Mobius"],
      keywords: ["format mac", "apfs", "mac os extended", "journaled", "hfs+", "best format mac", "which format", "format recommendation"],
      issue: "format_recommendation_mac",
      response: `Recommended formatting options for Mac users:

**APFS (Apple File System)**
- Best for SSDs (U32 Shadow, Helix, U34 Bolt, U35 Bolt+)
- Required for Time Machine on macOS Big Sur and later
- Supports TRIM
- Recommended for macOS Sonoma users (avoids exFAT bug)

**Mac OS Extended (Journaled) / HFS+**
- Best for HDDs (Novus, Mobius, HDX Pro C)
- Easier to repair than APFS if corruption occurs
- Compatible with Disk Warrior for recovery
- Good for Time Machine on older macOS versions
- Recommended for M1 Macs for best performance with RAID units

**exFAT**
- Use ONLY if you need cross-platform compatibility (Mac + Windows)
- NOT recommended with macOS Sonoma (known corruption bug)
- Does NOT support TRIM
- Must be properly ejected — corruption risk is higher
- When formatting large drives (>4TB) as exFAT on Windows, set the allocation size to 1MB or lower, otherwise the drive may not mount on Mac

**NTFS**
- Mac can read but NOT write to NTFS without third-party software
- Best for Windows-only use

**HOW TO FORMAT:**
1. Open Disk Utility (Applications > Utilities)
2. Click View > Show All Devices
3. Select the top-level drive (not the indented partition)
4. Click Erase
5. Choose your format and click Erase`
    },
    {
      id: "exfat_allocation_size_new",
      title: "exFAT Allocation Size Issue (Large Drives)",
      category: "Compatibility",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay"],
      keywords: ["allocation size", "cluster size", "exfat windows", "not mounting mac", "exfat large drive", "2mb", "4mb", "file allocation"],
      issue: "exfat_allocation_size",
      response: `When formatting large capacity drives (6TB+) as exFAT using Windows, the default file allocation (cluster) size may be too large for macOS to properly mount the drive.

**THE PROBLEM:**
Windows assigns allocation sizes based on drive capacity:
- 6TB drive: Default 2MB allocation
- 14TB+ drive: Default 4MB allocation

macOS cannot properly mount an exFAT volume with a file allocation size over 2MB.

**SOLUTION:**
When formatting a high-capacity drive as exFAT using Windows:
1. Open Windows Disk Management or use the Format tool
2. Set the Allocation Unit Size to **1024 KB (1MB)** or smaller
3. This ensures Mac compatibility

Alternatively, format the drive on a Mac using Disk Utility, which sets the correct allocation size automatically.

**BEST PRACTICE:**
For cross-platform use with large drives, format on a Mac whenever possible. If formatting on Windows is required, manually set a smaller allocation size.`
    },
    {
      id: "hdx_pro_fan_firmware_new",
      title: "HDX Pro C Fan Noise & Sleep Firmware",
      category: "Hardware",
      products: ["HDX Pro", "HDX Pro C"],
      keywords: ["hdx fan", "hdx noise", "hdx firmware", "hdx sleep", "hdx pro fan", "loud fan", "hdx grinding", "hdx sleep firmware"],
      issue: "hdx_pro_fan_firmware",
      response: `The HDX Pro C is an enterprise-grade aluminum enclosure with an internal fan.

**NORMAL FAN BEHAVIOR:**
- The fan should be nearly silent during normal operation
- If the fan can be heard from a few feet away, it may be faulty
- The vented aluminum provides passive cooling in addition to the fan

**LOUD OR GRINDING FAN:**
If the fan is unusually loud or making grinding noises:
- Try cleaning the vents with compressed air to remove dust or debris
- If cleaning doesn't help, the fan may need replacement — contact us for an RMA

**SLEEP FIRMWARE VERSIONS:**
The HDX Pro C comes in two firmware versions:

**Standard (Non-Sleep) Version:**
- Designed to run 24/7
- Does not respond to OS sleep commands
- No need to disable sleep settings on your computer

**Sleep Version:**
- Responds to OS sleep and power commands
- Shuts down when the computer sleeps
- Available upon request when ordering

If you need a different firmware version, contact us and we can ship a unit with your preferred firmware.`
    },
    {
      id: "usbc_usba_troubleshooting_new",
      title: "USB-C vs USB-A Cable Troubleshooting",
      category: "Connection",
      products: ["All", "U32 Shadow", "Helix", "Novus", "MiniPro", "Mobius"],
      keywords: ["usb-c", "usb-a", "which cable", "adapter", "both cables", "try both ports", "bypass adapter", "included cable"],
      issue: "usbc_usba_troubleshooting",
      response: `Most Oyen Digital drives include both USB-C and USB-A cables. Here's how to troubleshoot connection issues using both:

**GENERAL RULE: Use the Included Cables**
Always use the cables that came with your drive. Third-party cables may not support full speeds or power delivery.

**TROUBLESHOOTING STEPS:**

**1. Try Both Cable Types**
If your computer has both USB-C and USB-A ports, try each cable to help isolate the issue.

**2. Bypass Adapters**
If you're using a USB-C to USB-A adapter (or vice versa), bypass it and connect directly. Adapters can cause power and connection issues.

**3. Bypass Hubs and Docks**
Connect directly to your computer. USB hubs often cannot provide adequate power for external drives.

**USB PORT SPEEDS:**
- USB 2.0: ~40 MB/s (very slow — if you see this speed, check your port type)
- USB 3.0 / 3.1 Gen 1: ~500 MB/s (5Gbps)
- USB 3.1 Gen 2 / 3.2 Gen 2: ~1000 MB/s (10Gbps)
- USB4 / Thunderbolt: ~2700+ MB/s (40Gbps)

**NOTE FOR MAC USERS:**
The USB-C cable connects directly to newer MacBooks without any adapter needed. If using a USB hub or dock, try the direct USB-C connection first.`
    },
    {
      id: "time_machine_setup_new",
      title: "Time Machine Backup Setup & Issues",
      category: "Mac",
      products: ["All", "Novus", "U32 Shadow", "Helix", "MiniPro", "Mobius"],
      keywords: ["time machine", "backup mac", "time machine setup", "time machine not working", "time machine format", "backup drive"],
      issue: "time_machine_setup",
      response: `Setting up your Oyen Digital drive for Time Machine:

**FORMATTING FOR TIME MACHINE:**
- macOS Big Sur and later: Format as **APFS** (recommended)
- macOS Catalina and earlier: Format as **Mac OS Extended (Journaled)**
- Time Machine will offer to format the drive when you first select it

**SETUP:**
1. Connect the drive to your Mac
2. Go to System Settings > General > Time Machine (or System Preferences > Time Machine)
3. Click Add Backup Disk and select your Oyen Digital drive
4. Follow the prompts to begin your first backup

**COMMON ISSUES:**

**Backup Stalls or Stops:**
- Ensure the drive is connected directly (no hubs)
- Disable sleep settings: System Settings > Energy > Prevent sleep during backups
- First backup may take many hours — let it complete

**Drive Disappears During Backup:**
- Check power management settings
- Disable Spotlight Indexing on the backup drive
- Try a different USB port

**macOS Monterey Issues:**
The initial Monterey release (12.0.1) had Time Machine bugs. Update to the latest Monterey version to resolve.

**COMPATIBLE PRODUCTS:**
All Oyen Digital drives work with Time Machine when properly formatted.`
    },
    {
      id: "safe_eject_best_practices_new",
      title: "Safe Ejection & Corruption Prevention",
      category: "Maintenance",
      products: ["All"],
      keywords: ["safe eject", "safely remove", "proper eject", "corruption prevent", "disk not ejected properly", "data protection", "best practices"],
      issue: "safe_eject_best_practices",
      response: `Properly ejecting your drive before disconnecting is critical to preventing data corruption.

**HOW TO SAFELY EJECT:**

**Mac:**
- Right-click the drive icon on the desktop and select Eject
- Or drag the drive icon to the Trash
- Wait for the drive to disappear from the desktop

**Windows:**
- Click the "Safely Remove Hardware" icon in the system tray
- Select your drive and wait for the "Safe to Remove" message
- Wait at least 5 seconds before physically disconnecting

**BEST PRACTICES FOR DATA PROTECTION:**
1. **Always safely eject** before disconnecting — especially exFAT drives
2. **Keep 10-15% free space** on the drive for optimal performance
3. **Don't disconnect during file transfers**
4. **Avoid force-shutting down** your computer while the drive is connected
5. **Wait 5 seconds** after ejecting before physically unplugging
6. **Wait 30 seconds** after connecting before accessing the drive

**exFAT WARNING:**
exFAT volumes are especially prone to corruption if not properly ejected. If you need cross-platform compatibility, take extra care with safe ejection.

**FOLLOW THE 3-2-1 BACKUP RULE:**
- 3 copies of your data
- 2 different types of media
- 1 copy offsite or in the cloud`
    },
    {
      id: "mac_drive_not_visible_show_all_new",
      title: "Mac: Drive Not Visible in Disk Utility",
      category: "Mac",
      products: ["All", "Helix", "U32 Shadow", "Novus"],
      keywords: ["show all devices", "not visible disk utility", "hidden drive", "cannot see drive mac", "disk utility empty", "external not showing"],
      issue: "mac_drive_not_visible_show_all",
      response: `If your drive doesn't appear in Disk Utility or Finder, follow these steps:

**STEP 1: Show All Devices**
In Disk Utility, click **View > Show All Devices** from the top menu. This reveals the physical drive, not just mounted volumes. Your drive may appear even if its partition doesn't mount.

**STEP 2: Check Drive Status**
If the drive appears in the left column:
- If the partition below it is **greyed out**: This indicates corruption. Select it and click **First Aid**.
- If it shows as **Uninitialized**: You may need to erase and reformat.
- Click **File > Get Info** to view the disk identifier (e.g., disk2s2)

**STEP 3: Try Different Connections**
- Try a different USB port (both USB-C and USB-A if available)
- Use the cable included with the drive
- Bypass any hubs, docks, or adapters
- Power cycle: Disconnect, wait 10 seconds, reconnect
- Wait at least 30 seconds for the drive to mount

**STEP 4: If Still Not Visible**
- Try another Mac or Windows computer to determine if it's a computer-specific issue
- Boot into Recovery Mode and check Disk Utility there
- If the drive is not visible on any computer, it may be a hardware failure — contact us for warranty support`
    },
    {
      id: "novus_hdd_noise_normal_new",
      title: "Novus Hard Drive Noise (Normal vs. Abnormal)",
      category: "Hardware",
      products: ["Novus"],
      keywords: ["novus noise", "novus clicking", "novus sound", "hdd noise", "hard drive sound", "novus buzzing", "normal noise"],
      issue: "novus_hdd_noise_normal",
      response: `The Novus uses a traditional hard disk drive (HDD), which produces some normal operating sounds.

**NORMAL SOUNDS:**
- Light clicking during read/write operations (drive head seeking)
- Soft whirring when the drive spins up
- Brief startup sound when first connected

**ABNORMAL SOUNDS (Contact Us):**
- Loud, repetitive clicking or clunking
- Grinding or scraping noises
- Abnormal buzzing that wasn't present before
- Any sounds accompanied by the drive not being recognized

**IF YOU HEAR ABNORMAL SOUNDS:**
1. Stop using the drive immediately
2. Back up any accessible data
3. Contact us for warranty support

**STACKING NOVUS DRIVES:**
If stacking multiple Novus drives, ensure adequate ventilation between units. The bumper can be removed if needed for space, but it provides drop protection.

**NOTE:** Unlike SSDs (U32 Shadow, Helix, U34 Bolt, U35 Bolt+), HDDs have moving parts and will always make some noise during operation. This is completely normal.`
    },
    {
      id: "softraid_initialize_raid_new",
      title: "SoftRAID: Creating a New RAID Array",
      category: "SoftRAID",
      products: ["SoftRAID", "Fortis"],
      keywords: ["softraid create raid", "softraid initialize", "softraid setup", "zero sectors", "softraid new raid", "disable safeguard"],
      issue: "softraid_initialize_raid",
      response: `To create a new RAID array in SoftRAID:

**BEFORE CREATING THE RAID:**
If you see prompts about existing data or format warnings, click **Ignore** on those prompts.

**IF INITIALIZATION FAILS:**
1. Select **Volume > Disable Safeguard**
2. Select each disk individually in the left column
3. Choose **Disk > Zero Sectors** (select "First and Last 100 sectors" when prompted)
4. Repeat for all drives you want to include
5. After zeroing all drives, select all disks
6. Choose **Disk > Initialize**

**CREATING THE RAID:**
1. Open SoftRAID application
2. Select the initialized disks
3. Choose your desired RAID level
4. Follow the creation wizard

**VALIDATING A RAID:**
To check RAID integrity:
1. Select the volume
2. Clear the IO counters
3. Run Validate — this reads all tracks without changing data
4. This may take several hours
5. If validation fails, provide the error log to support

**TROUBLESHOOTING:**
- If any drives show errors in the left column, try moving them to a different slot
- Ensure SoftRAID is updated to the latest version for your macOS
- Check SoftRAID.com for macOS compatibility`
    },
    {
      id: "usb_port_speed_identification_new",
      title: "Identifying USB Port Speed (2.0 vs 3.0+)",
      category: "Performance",
      products: ["All"],
      keywords: ["usb 2.0", "usb 3.0", "slow 40 mb", "port speed", "which usb port", "blue port", "port type", "gen 1", "gen 2"],
      issue: "usb_port_speed_identification",
      response: `If you're experiencing very slow speeds (~40 MB/s or less), your drive may be connected to a USB 2.0 port instead of USB 3.0 or higher.

**HOW TO IDENTIFY YOUR USB PORT:**

**By Color (Desktop PCs):**
- Black: Usually USB 2.0 (slow)
- Blue: Usually USB 3.0 (fast)
- Teal/Red: Usually USB 3.1/3.2 (fastest)
- USB-C ports vary — check your computer's specifications

**By Location:**
- Rear motherboard ports typically provide more stable power and faster speeds
- Front panel USB ports are sometimes USB 2.0 even on modern PCs

**EXPECTED SPEEDS BY PORT TYPE:**
- USB 2.0: ~40 MB/s (480 Mbps) — Very slow for external SSDs
- USB 3.0 / 3.2 Gen 1: ~450 MB/s (5 Gbps)
- USB 3.1 / 3.2 Gen 2: ~900 MB/s (10 Gbps)
- USB4 / Thunderbolt 3: ~2700 MB/s (40 Gbps)

**TO VERIFY (Windows):**
- Device Manager > Universal Serial Bus Controllers
- Look for "USB 3.0" or "xHCI" entries

**TO VERIFY (Mac):**
- Apple menu > About This Mac > System Report > USB
- Check the "Speed" listed for each port`
    },
    {
      id: "ps5_xbox_console_setup_new",
      title: "PS5, Xbox & Game Console Compatibility",
      category: "Compatibility",
      products: ["U32 Shadow", "Novus"],
      keywords: ["ps5", "ps4", "playstation", "xbox", "console", "game console", "nintendo", "gaming"],
      issue: "ps5_xbox_console_setup",
      response: `Oyen Digital portable drives are compatible with PS5, PS4, Xbox Series X/S, and Xbox One.

**FORMATTING FOR CONSOLES:**

**PS5 / PS4:**
- Format the drive as **exFAT** using a computer before connecting to the console
- PS5 can also format the drive directly, but if it fails, format on a computer first
- The drive is used for game storage (PS5) or extended storage (PS4)

**Xbox Series X/S / Xbox One:**
- The Xbox will format the drive automatically when connected
- If the drive is not recognized, try a different USB port on the console
- Format as NTFS on a Windows PC if automatic formatting fails

**TROUBLESHOOTING:**
- If the console says data is "corrupted," reformat the drive on a computer first, then reconnect to the console
- Try different USB ports on the console
- Use the cable included with the drive
- If the drive works on a computer but not the console, the issue is console-specific — try power cycling the console
- Make sure the drive is connected directly to the console, not through a hub

**COMPATIBLE PRODUCTS:**
- **U32 Shadow** — Most popular for consoles (SSD, fast load times)
- **Novus** — Budget-friendly option (HDD, larger capacities)

**NOTE:** The drive must be formatted for the console, which will erase all existing data. Back up your data first.`
    },
    {
      id: "minipro_raid_hardware_switch_new",
      title: "MiniPro RAID Hardware Switch (DIP Switch) Settings",
      category: "RAID",
      products: ["MiniPro", "MiniPro RAID"],
      keywords: ["dip switch", "raid switch", "minipro switch", "set button", "clear raid", "raid mode switch", "hardware switch", "minipro raid mode"],
      issue: "minipro_raid_hardware_switch",
      response: `The MiniPro RAID uses DIP switches on the back panel to set the RAID mode.

**DIP SWITCH POSITIONS:**
- **RAID 0 (Striping):** Left switch UP, Right switch UP — Maximum speed, no redundancy
- **RAID 1 (Mirror):** Left switch DOWN, Right switch UP — Data protection, half capacity
- **JBOD/Clear:** Left switch DOWN, Right switch DOWN — Independent drives
- **Large/Span:** Left switch UP, Right switch DOWN — Combines drives into one volume

**HOW TO CHANGE RAID MODE:**
⚠️ Changing the RAID mode will erase all data on the drives.

1. Power off the MiniPro and disconnect from the computer
2. Set the DIP switches to **CLEAR** position (both down)
3. Reconnect to the computer and power on
4. Wait for D1 and D2 blue lights to turn on
5. Using a small screwdriver tip, **press and hold the SET button** for at least 5-10 seconds
6. The lights will blink to confirm the clear
7. Power off the unit
8. Move the DIP switches to your desired RAID mode
9. Power on and connect to the computer
10. Format the drive in Disk Utility (Mac) or Disk Management (Windows)

**VERIFYING RAID MODE (Mac):**
Open Disk Utility > View > Show All Devices. The MiniPro will display its current mode in the device name (e.g., "MiniPro RAID V3 RAID 1").

**RAID 1 REBUILD AFTER DRIVE REPLACEMENT:**
When replacing a failed drive in RAID 1:
1. Remove the failed drive (indicated by red LED)
2. Insert a new **unformatted** drive of equal or greater capacity
3. The rebuild begins automatically — the LED will blink during rebuild
4. Do not disconnect during rebuild
5. After rebuild completes, both LEDs return to solid blue`
    },
    {
      id: "mobius_raid_mode_setup_new",
      title: "Mobius RAID Mode Configuration",
      category: "RAID",
      products: ["Mobius", "Mobius 5-Bay", "Mobius 2C"],
      keywords: ["mobius raid mode", "mode button", "mobius raid setup", "mobius raid 0", "mobius raid 1", "mobius raid 5", "mobius jbod", "raid configuration"],
      issue: "mobius_raid_mode_setup",
      response: `The Mobius uses a hardware RAID controller with a MODE button and switches to configure RAID.

**AVAILABLE RAID MODES:**
- **JBOD** — Each drive appears individually
- **RAID 0 (Stripe)** — Maximum speed, combines all drives, no redundancy
- **RAID 1 (Mirror)** — Data protection (2-bay models)
- **RAID 5** — Speed + redundancy, can survive one drive failure (requires 3+ drives)
- **RAID 10** — Stripe of mirrors (requires 4+ drives)
- **Large/Span** — Combines drives into one large volume

**CHANGING RAID MODE:**
⚠️ Changing the RAID mode erases all data.

**Mobius 5-Bay:**
1. Set the switch to the desired RAID mode position
2. Press and hold the **MODE button** for 10 seconds
3. The unit will reset and configure the new RAID
4. Format the new volume in Disk Utility or Disk Management

**Mobius 2C:**
1. With the unit connected and powered on
2. Place the switch in the desired position
3. Press and hold the MODE button for 10 seconds
4. Wait for the drives to initialize
5. Format the volume

**IMPORTANT NOTES:**
- The Mobius has a hardware RAID controller — it does not require software
- RAID 5 maximum speed is approximately 250 MB/s
- RAID 0 can reach up to 600 MB/s (USB 3.0)
- Always safely eject before powering off
- The Mobius does not have a sleep timer but will respond to OS sleep commands`
    },
    {
      id: "windows_drive_not_detected_new",
      title: "Windows: Drive Not Detected",
      category: "Windows",
      products: ["All"],
      keywords: ["windows not detected", "device manager", "disk management", "not recognized", "usb device not recognized", "windows cannot see", "not showing windows"],
      issue: "windows_drive_not_detected",
      response: `If your drive is not appearing in Windows File Explorer:

**STEP 1: Check Device Manager**
- Right-click the Windows Start icon > Device Manager
- Look under **Disk Drives** — if your drive appears here, Windows sees the hardware
- If not listed, there is no USB communication — try a different port/cable

**STEP 2: Check Disk Management**
- Right-click the Windows Start icon > **Disk Management**
- Look for your drive (identify by size)
- If it shows as **"Not Initialized"**: Right-click > Initialize Disk > Select GPT > OK
- If it shows as **"Unallocated"**: Right-click the unallocated space > New Simple Volume
- If it shows as **"Offline"**: Right-click > Online
- If it shows with **no drive letter**: Right-click the volume > Change Drive Letter and Paths > Add

**STEP 3: Try Different Connections**
- Use the cable included with the drive
- Try both USB-C and USB-A ports if available
- Bypass any hubs, docks, or adapters
- Try a USB port on the rear of the computer (more stable power)

**STEP 4: Check USB Drivers**
- In Device Manager, check for yellow exclamation marks under Universal Serial Bus Controllers
- If "USB device not recognized" appears, try: unplug, wait 10 seconds, replug
- Try a different USB port

**STEP 5: Power Management**
Disable USB Selective Suspend:
- Control Panel > Power Options > Change Plan Settings > Change Advanced Power Settings
- USB Settings > USB Selective Suspend = **Disabled**`
    },
    {
      id: "sleep_power_management_new",
      title: "Drive Sleep & Power Management Settings",
      category: "Power",
      products: ["All", "Mobius", "MiniPro", "Novus", "U32 Shadow", "Helix"],
      keywords: ["sleep", "power management", "spin down", "standby", "wake", "energy saver", "put hard disk to sleep", "power saving", "idle", "disconnect sleep"],
      issue: "sleep_power_management",
      response: `If your drive disconnects, goes to sleep unexpectedly, or won't wake up, adjust these power management settings:

**MAC SETTINGS:**

1. **Disable Hard Disk Sleep:**
   - System Settings > Energy (or Energy Saver)
   - Uncheck "Put hard disks to sleep when possible"
   - On laptops: Check both Battery and Power Adapter tabs

2. **Prevent Computer Sleep During Transfers:**
   - System Settings > Energy > Prevent automatic sleeping when the display is off

**WINDOWS SETTINGS:**

1. **Disable HDD Sleep:**
   - Control Panel > Power Options > Change Plan Settings > Change Advanced Power Settings
   - Hard Disk > Turn off hard disk after = **Never** (set to 0)

2. **Disable USB Selective Suspend:**
   - Same Advanced Power Settings window
   - USB Settings > USB Selective Suspend = **Disabled**

3. **Disable USB Power Management:**
   - Device Manager > Universal Serial Bus Controllers
   - Double-click each USB Root Hub
   - Power Management tab > Uncheck "Allow the computer to turn off this device to save power"

**PRODUCT-SPECIFIC NOTES:**

- **HDX Pro C (Standard firmware):** Does NOT respond to OS sleep commands — runs 24/7. No sleep settings need to be changed.
- **HDX Pro C (Sleep firmware):** Responds to OS sleep commands. Available upon request.
- **Mobius:** No built-in sleep timer, but responds to OS sleep commands. The white power light should stay on during sleep; only blue HD lights go out.
- **SSDs (U32 Shadow, Helix, U34 Bolt, U35 Bolt+):** No moving parts, so sleep/wake is instant.
- **HDDs (Novus, Mobius, HDX Pro):** May take a few seconds to spin up after waking.`
    },
    {
      id: "led_indicator_meanings_new",
      title: "LED Indicator Light Meanings",
      category: "Hardware",
      products: ["All"],
      keywords: ["led", "light", "blue light", "red light", "blinking", "flashing", "indicator", "no light", "light meaning"],
      issue: "led_indicator_meanings",
      response: `LED indicators show your drive's current status:

**PORTABLE SSDs (U32 Shadow, Helix, U34 Bolt, U35 Bolt+):**
- **Solid Blue:** Connected and ready
- **Blinking Blue:** Read/write activity (normal during file transfers)
- **No Light:** Not connected or not receiving power

**MiniPro RAID (D1 and D2 lights):**
- **Both Solid Blue:** Both drives healthy and operational
- **One Red Light:** That drive has failed or has errors — replace the drive
- **Blinking Blue:** RAID rebuild in progress (do not disconnect!)
- **Both Off:** No power — check DC/USB switch position and power adapter

**Mobius 5-Bay:**
- **White Power Light:** Unit is powered on
- **Blue Drive Lights:** Drives are detected and active
- **Blinking Blue:** Read/write activity
- **No Blue Lights During Sleep:** Normal — white power light should remain on

**HDX Pro C:**
- **Blue LED:** Connected and operational
- **Blinking Blue:** Drive activity (may be caused by Spotlight Indexing)
- **No LED but fan running:** No USB signal — check cable and port

**Novus:**
- **Solid Blue:** Connected and ready
- **Blinking Blue:** Read/write activity
- **Blinking Power Light:** May indicate a power issue

**GENERAL TROUBLESHOOTING:**
If LEDs are blinking when you're not actively using the drive, it may be caused by background processes like Spotlight Indexing, Time Machine, antivirus scans, or system backup software.`
    },
    {
      id: "ssd_health_tbw_trim_new",
      title: "SSD Health, TBW Endurance & TRIM",
      category: "Maintenance",
      products: ["All", "U32 Shadow", "Helix", "U34 Bolt", "U35 Bolt+", "MiniPro"],
      keywords: ["ssd health", "tbw", "endurance", "lifespan", "trim", "ssd life", "wear", "how long last", "terabytes written", "smart health"],
      issue: "ssd_health_tbw_trim",
      response: `Understanding SSD health, endurance, and TRIM support:

**TBW (Terabytes Written) RATINGS:**
TBW indicates the total amount of data that can be written to the SSD over its lifetime.
- **Helix Dura:** 2000 TBW (2TB model) — TBW varies by capacity
- **U32 Shadow:** Varies by internal SSD model
- **U34 Bolt:** Varies by capacity
- **U35 Bolt+:** Varies by capacity
- **MiniPro Dura RAID:** Based on individual SSDs installed

A 1% life loss after ~2,500 GB written and 2,000 hours of use is normal.

**CHECKING SSD HEALTH:**
- **Mac:** Use a SMART monitoring tool like DriveDx
- **Windows:** Use HD Sentinel (hdsentinel.com) — approved and recommended
- Look for "Health" or "Life Remaining" percentage
- 100% = brand new, declining over time is normal

**TRIM SUPPORT:**
TRIM helps SSDs maintain performance by telling the drive which data blocks are no longer in use.
- **APFS and Mac OS Extended:** TRIM is supported natively on Mac
- **exFAT:** Does NOT support TRIM
- **NTFS:** TRIM is supported on Windows
- Some enclosures have firmware that passes TRIM commands. Check our firmware downloads page for TRIM-enabled firmware if available for your model.

**BEST PRACTICES FOR SSD LONGEVITY:**
- Keep at least **10-15% free space** on the drive
- Format as APFS (Mac) or NTFS (Windows) for TRIM support
- Avoid completely filling the drive
- Use the Optimize function in Windows (Defragment and Optimize Drives)`
    },
    {
      id: "warranty_rma_info_new",
      title: "Warranty & RMA Information",
      category: "Support",
      products: ["All"],
      keywords: ["warranty", "rma", "return", "replacement", "how long warranty", "warranty period", "defective", "exchange"],
      issue: "warranty_rma_info",
      response: `Oyen Digital warranty information:

**WARRANTY PERIODS:**
- **Most Products (U32 Shadow, Helix, U34 Bolt, U35 Bolt+, Novus, MiniPro, Mobius, Fortis):** 3-year limited warranty
- **HDX Pro C:** 4-year limited warranty
- Warranty applies to the original purchaser from the date of purchase
- Replacement units continue the original warranty period

**WHAT'S COVERED:**
- Hardware defects in materials and workmanship
- Drive failures under normal use
- Enclosure malfunctions
- Faulty cables (we can ship replacement cables)

**WHAT'S NOT COVERED:**
- Physical damage, drops, or liquid damage
- Data loss or recovery costs
- Normal wear (SSD endurance, etc.)
- Use outside of intended specifications

**RMA PROCESS:**
1. Contact support at support@oyendigital.com with your serial number and description of the issue
2. We will troubleshoot to determine if the issue can be resolved
3. If an RMA is needed, we will provide a prepaid shipping label (US)
4. Ship the drive to our service center
5. We will repair, replace, or ship a new unit — typically within 1 business day of receiving

**ADVANCE REPLACEMENT:**
In many cases, we can ship a replacement unit before receiving the faulty one. A return label will be included.

**DATA RECOVERY:**
We offer basic data recovery inspection at no additional charge during warranty service. If you are interested, let us know before shipping.`
    },
    {
      id: "ntfs_mac_read_only_new",
      title: "NTFS Drive is Read-Only on Mac",
      category: "Compatibility",
      products: ["All"],
      keywords: ["ntfs mac", "read only mac", "cannot write mac", "ntfs read only", "mac ntfs write"],
      issue: "ntfs_mac_read_only",
      response: `macOS can **read** NTFS drives but **cannot write** to them natively. This is by design — Apple does not include NTFS write support.

**SOLUTIONS:**

**Option 1: Reformat the Drive (if data can be backed up)**
- Back up all data from the NTFS drive
- Reformat as APFS, Mac OS Extended, or exFAT
- exFAT is the best option if you need both Mac and Windows read/write access

**Option 2: Use Third-Party NTFS Software**
- **Paragon NTFS for Mac** (paid) — Enables full NTFS read/write on Mac
- **Tuxera NTFS** (paid) — Another popular option
- These install as system extensions and enable transparent NTFS write support

**Option 3: Use a Windows Computer**
If you only need to write files occasionally, connect the drive to a Windows computer for write operations.

**WHY WAS MY DRIVE SHIPPED AS NTFS?**
Some replacement drives are formatted as NTFS to avoid the macOS Sonoma/Sequoia exFAT bug. You can reformat as APFS or Mac OS Extended for full Mac compatibility.`
    },
    {
      id: "sequoia_sonoma_exfat_update_new",
      title: "macOS Sequoia & Sonoma: exFAT Issues Continue",
      category: "Mac",
      products: ["All", "U32 Shadow", "Helix", "MiniPro", "Novus", "Fortis"],
      keywords: ["sequoia", "sequoia exfat", "sequoia bug", "macos 15", "sonoma sequoia", "sequoia corruption"],
      issue: "sequoia_sonoma_exfat_update",
      response: `The exFAT corruption bug first identified in macOS Sonoma (14.x) continues to affect macOS Sequoia (15.x).

**AFFECTED VERSIONS:**
- macOS Sonoma 14.0 through 14.x
- macOS Sequoia 15.0 and later

**THE ISSUE:**
Spotlight Indexing in these macOS versions can cause data corruption on external drives formatted as exFAT. This affects drives from all manufacturers, not just Oyen Digital.

**RECOMMENDED ACTIONS:**

1. **Reformat as APFS** (strongly recommended)
   - If your drive is used only with Mac, reformat as APFS
   - This completely eliminates the exFAT corruption risk

2. **If You Must Use exFAT:**
   - Remove the drive from Spotlight Indexing:
     System Settings > Siri & Spotlight > Spotlight Privacy > Add your drive
   - This may reduce (but not eliminate) the risk
   - Always safely eject the drive

3. **If Drive Is Already Corrupted:**
   - Connect to a Windows PC and run: chkdsk X: /r /f
   - Windows exFAT repair tools are more effective than Mac
   - After repair, reformat as APFS on the Mac
`
    },
    {
      id: "ipad_iphone_android_compat_new",
      title: "iPad, iPhone & Android Device Compatibility",
      category: "Compatibility",
      products: ["All", "U32 Shadow", "Helix", "U34 Bolt", "U35 Bolt+", "Novus"],
      keywords: ["ipad", "iphone", "android", "ios", "mobile", "tablet", "samsung", "pixel", "phone"],
      issue: "ipad_iphone_android_compat",
      response: `Oyen Digital USB-C drives can connect to mobile devices with the right setup:

**iPAD (USB-C models):**
- iPads with USB-C ports (iPad Pro, iPad Air, iPad mini) support external storage
- Use the included USB-C cable to connect directly
- Open the Files app to access the drive
- Supported formats: exFAT, FAT32, APFS, Mac OS Extended
- iPadOS 13 or later required

**iPHONE (USB-C models — iPhone 15 and later):**
- Connect via USB-C cable
- Access through the Files app
- Same format support as iPad

**iPHONE (Lightning models — iPhone 14 and earlier):**
- Requires a Lightning to USB-C adapter (Apple Camera Connection Kit)
- Limited functionality compared to USB-C models

**ANDROID DEVICES:**
- Most Android devices with USB-C support external storage
- Format the drive as **exFAT** for Android compatibility
- Use the built-in file manager to access the drive
- Some devices may require an OTG adapter

**IMPORTANT NOTES:**
- Mobile devices may not provide enough power for HDD-based drives (Novus, Mobius)
- SSD drives (U32 Shadow, Helix, U34 Bolt, U35 Bolt+) work best with mobile devices due to lower power requirements
- Format as exFAT for maximum cross-platform compatibility`
    },
    {
      id: "encryption_bitlocker_filevault_new",
      title: "Drive Encryption (BitLocker & FileVault)",
      category: "Security",
      products: ["All", "Fortis"],
      keywords: ["encryption", "bitlocker", "filevault", "encrypt drive", "password protect", "secure drive", "apfs encrypted"],
      issue: "encryption_bitlocker_filevault",
      response: `You can encrypt your Oyen Digital drive using built-in OS encryption tools:

**MAC — FileVault / APFS Encrypted:**
- Format the drive as **APFS (Encrypted)** in Disk Utility
- Or right-click the drive in Finder > Encrypt
- You will set a password — the drive cannot be accessed without it
- ⚠️ If you forget the password, the data cannot be recovered

**WINDOWS — BitLocker:**
- Right-click the drive in File Explorer > Turn on BitLocker
- Choose a password and save the recovery key
- BitLocker encrypts the entire drive
- Available on Windows 10/11 Pro and Enterprise editions

**IMPORTANT NOTES:**
- Oyen Digital drives do not include hardware encryption (except where specified)
- Software encryption (BitLocker, FileVault) works with all models
- Encrypted drives formatted on Mac will not be readable on Windows and vice versa
- If the drive fails while encrypted, data recovery becomes extremely difficult or impossible
- We recommend keeping a backup of any encrypted data

**PERFORMANCE:**
Software encryption may slightly reduce transfer speeds, particularly on older computers. Modern Macs and PCs with hardware encryption acceleration show minimal impact.`
    },
    {
      id: "free_space_best_practice_new",
      title: "Maintain Free Space for Drive Health",
      category: "Maintenance",
      products: ["All"],
      keywords: ["free space", "full drive", "capacity", "drive full", "how much space", "running out of space", "10 percent", "15 percent"],
      issue: "free_space_best_practice",
      response: `Maintaining adequate free space is essential for drive health and performance, especially for SSDs.

**RECOMMENDED FREE SPACE:**
- **SSDs (U32 Shadow, Helix, U34 Bolt, U35 Bolt+):** Keep at least **10-15% free space** at all times
- **HDDs (Novus, Mobius, HDX Pro):** Keep at least **10% free space**

**WHY IT MATTERS:**

**For SSDs:**
- SSDs need free blocks to perform wear leveling and garbage collection
- A nearly full SSD will experience significantly slower write speeds
- Insufficient free space accelerates SSD wear and reduces lifespan
- TRIM operations require free space to work effectively

**For HDDs:**
- File fragmentation increases as the drive fills up
- Performance degrades significantly above 90% capacity
- Less room for the file system to manage data efficiently

**SIGNS YOUR DRIVE IS TOO FULL:**
- Slow write speeds that weren't present before
- Files taking longer to save
- Drive disconnecting during large transfers
- Backup software failing to complete

**RECOMMENDATION:**
If your drive is consistently above 85% capacity, consider upgrading to a larger drive or archiving older files elsewhere.`
    },
    {
      id: "linux_windows_server_compat_new",
      title: "Linux & Windows Server Compatibility",
      category: "Compatibility",
      products: ["All", "HDX Pro"],
      keywords: ["linux", "ubuntu", "ext4", "debian", "fedora", "windows server", "server 2019", "server 2022"],
      issue: "linux_windows_server_compat",
      response: `Oyen Digital drives are compatible with Linux and Windows Server:

**LINUX:**
- All Oyen Digital drives work with Linux distributions (Ubuntu, Debian, Fedora, etc.)
- Format as **ext4** for best Linux performance
- **exFAT** is recommended for cross-platform use (Linux, Mac, Windows)
- Most modern Linux kernels support exFAT natively (kernel 5.4+)
- NTFS is supported via ntfs-3g driver

**WINDOWS SERVER:**
- Compatible with Windows Server 2012 and later
- Some servers may not have USB 3.0 drivers pre-installed
- The drive should appear in Device Manager under Disk Drives
- If not detected, check if USB storage is enabled in BIOS/UEFI settings
- Server editions may require manually installing USB drivers

**FORMATTING:**
- Linux only: ext4
- Windows only: NTFS
- Cross-platform (any OS): exFAT
- Mac only: APFS or Mac OS Extended

**NOTE:** The drive can be reformatted as any file system. The factory format (typically exFAT) is chosen for maximum out-of-box compatibility.`
    },
    {
      id: "tb_not_detected_windows",
      title: "Drive Not Detected or Slow on Thunderbolt Port (Windows)",
      category: "Connectivity",
      products: ["U34 Bolt", "U35 Bolt+"],
      keywords: ["thunderbolt not detected", "thunderbolt slow", "tb port slow", "not showing thunderbolt", "thunderbolt control center", "tb handshake", "pcie tunnel", "nvme tunnel", "u34 thunderbolt windows", "u35 thunderbolt windows", "thunderbolt speed slow"],
      issue: "tb_not_detected_windows",
      response: `**ISSUE: Drive appears in Thunderbolt Control Center but does not show as an available drive, or runs significantly slower than expected on the Thunderbolt port.**

This applies to the U34 Bolt and U35 Bolt+ on Windows. It typically indicates the Thunderbolt handshake is completing but the PCIe/NVMe tunnel is not being established properly.

**SOLUTION — Step by Step:**

**1. Update BIOS to Latest Version**
Visit your laptop/motherboard manufacturer's website and ensure you have the latest BIOS installed. Thunderbolt compatibility is frequently improved through BIOS updates.

**2. Update Thunderbolt Drivers & Firmware**
- Install the latest **Intel Thunderbolt Driver** from your manufacturer's support page
- Update the **Thunderbolt Controller Firmware** if available
- Update the **Intel Thunderbolt Control Center** app

**3. Check Thunderbolt Security Settings**
In BIOS/UEFI, find the Thunderbolt Security Level and set it to the most permissive option (e.g., "No security" or "User authorization off").

**4. Try a Different Thunderbolt Cable**
If you have another certified Thunderbolt cable, try it to rule out cable issues. For the U35 Bolt+, use an 80Gbps-rated cable for full performance.

**5. Compare Speeds**
If the drive works on a USB-C 3.2 Gen 2 port but is slower on the Thunderbolt port, this confirms the PCIe tunnel issue. The drive should be significantly faster on Thunderbolt.

**6. Check Device Manager**
When connected to the Thunderbolt port, the drive may show under a different name (e.g., the internal SSD brand name like "Samsung" instead of the Oyen product name). This is normal behavior for Thunderbolt connections.

**If the issue persists after all steps**, please provide the serial number from the drive (located on the end of the unit under the rubber sleeve) and we will escalate to our engineering team for review.`
    },
    {
      id: "tb_boot_windows",
      title: "Booting Windows from Thunderbolt Port (U34 Bolt / U35 Bolt+)",
      category: "Compatibility",
      products: ["U34 Bolt", "U35 Bolt+"],
      keywords: ["boot thunderbolt", "boot from thunderbolt", "thunderbolt boot", "boot u34", "boot u35", "windows boot thunderbolt", "can't boot thunderbolt", "usb boot works thunderbolt doesn't", "pre-boot thunderbolt"],
      issue: "tb_boot_windows",
      response: `**ISSUE: The drive boots successfully from a USB port but does not boot when connected to a Thunderbolt port.**

When connected via USB, the drive shows as a standard SCSI disk device. When connected via Thunderbolt, it may appear under the internal SSD brand name (e.g., "Samsung") and won't boot by default. This is because Thunderbolt boot requires specific BIOS configuration.

This applies to both the U34 Bolt and U35 Bolt+.

**SOLUTION — Enable Thunderbolt Boot in BIOS:**

**Step 1:** Restart your computer and enter the BIOS/UEFI setup (often by pressing F2, Del, F10, or F12 right after turning it on).

**Step 2:** Look for any option named "Thunderbolt Boot Support," "Boot from Thunderbolt," or "Pre-boot Thunderbolt" and set it to **Enabled**.

**Step 3:** Find the **Thunderbolt Security Level** (or similar) and set it to the lowest/most permissive option, such as "No security" or "User authorization off." This allows PCIe storage devices to be recognized before the OS loads.

**Step 4:** Make sure the system is set to **UEFI boot only**, with any "Legacy" or "CSM" boot mode **disabled**.

**Step 5:** Save the changes and reboot back into BIOS/UEFI with the drive plugged into the Thunderbolt port. Check the boot order or boot device list — the SSD should now appear as a boot option (it may show under the internal SSD brand name or as a Thunderbolt storage device).

**Step 6:** Set the drive as the primary boot device and save.

**NOTE:** Not all systems support Thunderbolt boot. If your BIOS does not have Thunderbolt boot options, your system may not support this feature. In that case, use a USB-C port for booting.`
    },

  // ===== U35 BOLT+ =====
  {
    id: "u35_bolt_plus_overview",
    title: "Product Overview & Specifications",
    category: "Overview",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+", "u35 bolt plus", "specs", "specifications", "overview", "usb4 80gbps", "pcie gen 5", "6000 mbs", "dimensions", "capacity"],
    issue: "u35_bolt_plus_overview",
    response: `The U35 Bolt+ is Oyen Digital's flagship portable SSD, built around a USB4 80Gbps interface with PCIe Gen 5.0 x4 internal architecture for sustained speeds up to 6000 MB/s.

**Interface:** USB-C (USB4 80Gbps)
**PCIe Technology:** Gen 5.0 x4
**Internal Storage:** TLC NAND Flash

**Performance by Host Port:**
• USB4 80G: up to 6000 MB/s
• Thunderbolt 5: up to 6000 MB/s
• USB4 / Thunderbolt 4: up to 3800 MB/s
• Thunderbolt 3 on Mac Silicon: up to 2800 MB/s
• Thunderbolt 3 on Mac Intel: up to 1000 MB/s

**Capacities:** 1TB, 2TB, 4TB
**Housing:** Aluminum Alloy core with Silicone Rubber sleeve
**Dimensions (with sleeve):** 4.5 × 2.7 × 0.85 inches
**Operating Temperature:** 32°F – 180°F (0°C – 82°C)

**Compatible Platforms:** Mac OS 11 or higher, Windows, Android, Chrome OS, Linux

**In the Box:** U35 Bolt+, USB-C cable (80Gbps rated), User Guide
**Warranty:** 3-Year Oyen Digital repair/replacement warranty`
  },
  {
    id: "u35_bolt_plus_performance",
    title: "Performance Expectations by Port Type",
    category: "Performance",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ speed", "performance", "slow speed", "not fast enough", "expected speed", "bandwidth", "aja system test", "usb4 80g", "thunderbolt 5", "thunderbolt 4", "thunderbolt 3"],
    issue: "u35_bolt_plus_performance",
    response: `The U35 Bolt+ speed depends entirely on the capability of the host port it is connected to. Speeds are hardware-limited by the host — the drive itself is capable of up to 6000 MB/s.

**Port-by-port performance:**
• **USB4 80Gbps port:** up to 6000 MB/s
• **Thunderbolt 5 port:** up to 6000 MB/s
• **USB4 40Gbps / Thunderbolt 4:** up to 3800 MB/s
• **Thunderbolt 3 on Apple Silicon Mac:** up to 2800 MB/s
• **Thunderbolt 3 on Intel Mac:** up to 1000 MB/s

**To achieve maximum speed:**
Connect using the included USB-C cable (rated for 80Gbps) — or a certified Thunderbolt 5 cable — to a Thunderbolt 5 or USB4 80Gbps port. Third-party cables may limit performance even if the port is capable.

**To benchmark speed accurately:**
Download AJA System Test: https://aja.com/products/aja-system-test
Use a large test file size (16GB or more) for a realistic sustained read/write measurement.

**Note:** If your system does not have a USB4 80Gbps or Thunderbolt 5 port, the drive will still work at the best speed your host supports — it is fully backward compatible.`
  },
  {
    id: "u35_bolt_plus_thunderbolt",
    title: "Thunderbolt Compatibility",
    category: "Compatibility",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ thunderbolt", "thunderbolt 3", "thunderbolt 4", "thunderbolt 5", "tb3", "tb4", "tb5", "thunderbolt 1", "thunderbolt 2", "2015 mac", "legacy thunderbolt", "compatible"],
    issue: "u35_bolt_plus_thunderbolt",
    response: `The U35 Bolt+ is compatible with all Thunderbolt 3, Thunderbolt 4, and Thunderbolt 5 ports using the included cable.

**Compatible:**
• ✅ Thunderbolt 5 (up to 6000 MB/s)
• ✅ Thunderbolt 4 (up to 3800 MB/s)
• ✅ Thunderbolt 3 — Apple Silicon Mac (up to 2800 MB/s)
• ✅ Thunderbolt 3 — Intel Mac (up to 1000 MB/s)

**Not compatible:**
• ❌ Thunderbolt 1 (found on 2011–2013 Macs with Mini DisplayPort connector)
• ❌ Thunderbolt 2 (found on 2013–2015 Macs with Mini DisplayPort connector)

If your Mac has a Mini DisplayPort-style Thunderbolt port, it is Thunderbolt 1 or 2 and cannot be used with the U35 Bolt+. Look for a USB-C shaped Thunderbolt port (with the lightning bolt icon) for compatibility.

All modern Macs with Apple Silicon (M1 and later) use Thunderbolt 3 or higher and are fully compatible.`
  },
  {
    id: "u35_bolt_plus_usb_type_a",
    title: "USB Type-A (USB 3.0/3.1) Compatibility",
    category: "Compatibility",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ usb-a", "usb 3.0", "usb type-a", "usb-a port", "not working", "not enough power", "usb hub", "desktop usb"],
    issue: "u35_bolt_plus_usb_type_a",
    response: `The U35 Bolt+ is **not recommended** for use with USB Type-A ports (USB 3.0 / 3.1).

**Why:** USB Type-A ports do not supply sufficient power for the U35 Bolt+ to operate reliably. The drive may not mount, may disconnect intermittently, or may not power on at all.

**Recommendation:** Connect the U35 Bolt+ only to USB-C host ports, including:
• USB 3.2 Gen 2 USB-C
• USB4 (40Gbps or 80Gbps)
• Thunderbolt 3, 4, or 5

If your computer only has USB-A ports, the U35 Bolt+ is not the right drive for that system. Consider the U32 Shadow (USB 3.2 Gen 2) which is designed for USB-A use via an included cable.`
  },
  {
    id: "u35_u34_bolt_formatting",
    title: "Formatting the U35 Bolt+ or U34 Bolt",
    category: "Setup",
    products: ["U35 Bolt+", "U34 Bolt"],
    keywords: ["u35 bolt+ format", "u34 bolt format", "formatting", "windows format", "apfs", "exfat", "ntfs", "mac format", "reformat", "oyen formatter app", "u35 format windows", "u35 format mac", "u34 format windows", "u34 format mac", "trim support"],
    issue: "u35_u34_bolt_formatting",
    response: `The U35 Bolt+ and U34 Bolt ship pre-formatted as **APFS** (U35 Bolt+) or **HFS+** (U34 Bolt) for macOS.

**Mac Users:**
No formatting needed. Connect the drive and it will be ready to use immediately.

**Windows Users:**
The drive must be reformatted before use on Windows. Oyen Digital provides a free Formatter app — download it at <a href="https://oyendigital.com/formatter" target="_blank" rel="noopener">oyendigital.com/formatter</a>.

1. Open the app after installing
2. Select your drive from the Device list
3. Click **Start** to format

**To use on both Mac and Windows (cross-platform):**
Format as **exFAT** using Disk Utility (Mac) or Disk Management (Windows). exFAT is readable and writable on both platforms.

**TRIM Support:**
For best SSD performance and longevity:
- **Windows:** Format as **NTFS** (supports TRIM via "Optimize Drives")
- **Mac:** Format as **APFS** (TRIM runs automatically)
- **Note:** exFAT does not support TRIM commands

**Note:** Formatting erases all data on the drive. Back up any files first.`
  },
  {
    id: "u35_bolt_plus_heat",
    title: "Drive Gets Very Warm — Is This Normal?",
    category: "Troubleshooting",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ hot", "warm", "heat", "overheating", "too hot", "aluminum hot", "thermal", "temperature", "normal heat"],
    issue: "u35_bolt_plus_heat",
    response: `**Yes, it is completely normal for the U35 Bolt+ to get very warm during use.**

The U35 Bolt+ uses a thick aluminum alloy core as an internal heat sink. This is an intentional design — the aluminum absorbs and dissipates heat from the SSD controller and NAND, keeping internal temperatures stable for consistent sustained performance.

**What to expect:**
• The aluminum body will be warm or even hot to the touch during heavy read/write operations
• The silicone rubber sleeve helps insulate your hand while handling the drive
• This is normal thermal behavior, not a sign of malfunction

**Operating temperature range:** 32°F – 180°F (0°C – 82°C)

If the drive unexpectedly disconnects or slows significantly under load, allow it to cool for a few minutes, then reconnect. Ensure it is not placed inside a closed bag or against other heat-generating devices during intensive use.`
  },
  {
    id: "u35_bolt_plus_eject",
    title: "How to Safely Eject the U35 Bolt+",
    category: "Usage",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ eject", "safely remove", "disconnect", "unmount", "eject mac", "eject windows", "safely eject"],
    issue: "u35_bolt_plus_eject",
    response: `Always eject the U35 Bolt+ safely before physically disconnecting it to prevent data loss or file system corruption.

**On Mac:**
1. Close all applications accessing the drive
2. Drag the drive icon from the desktop to the Trash (the icon changes to an Eject symbol)
3. Wait for the icon to disappear from the desktop
4. Disconnect the cable

Alternatively, right-click the drive icon and select **Eject**.

**On Windows:**
1. Close all applications accessing the drive
2. Click the **"Eject Hardware"** (Safely Remove Hardware) icon in the system tray (bottom-right)
3. Highlight the U35 Bolt+ and click to eject
4. Wait for the "You may safely remove this device" prompt
5. Disconnect the cable

**Note:** Disconnecting without ejecting — especially during a write operation — can corrupt files or damage the file system. If this happens, use Disk Utility (Mac) or CHKDSK (Windows) to check and repair the drive.`
  },
  {
    id: "u35_bolt_plus_backup",
    title: "Backup Software Recommendations",
    category: "Usage",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ backup", "backup software", "time machine", "carbon copy cloner", "windows backup", "data backup", "clone"],
    issue: "u35_bolt_plus_backup",
    response: `Oyen Digital recommends the following backup applications to use with the U35 Bolt+:

**Mac:**
• **Time Machine** — Built into macOS. Automatic incremental backups to an external drive.
  Setup guide: https://support.apple.com/en-us/104984
• **Carbon Copy Cloner** — Creates a bootable clone of your Mac's internal drive. Ideal for full system backup.
  Download: https://bombich.com

**Windows:**
• **Windows Backup** — Built into Windows. Access via Settings > Update & Security > Backup.
  Guide: https://bit.ly/3AaGx8e

**General tips:**
• Use the U35 Bolt+ as a dedicated backup destination rather than primary storage for most reliable results
• For Time Machine, the APFS or HFS+ format works best; exFAT is not supported by Time Machine
• For Windows Backup or cloning software, NTFS format is recommended`
  },
  {
    id: "u35_bolt_plus_warranty",
    title: "Warranty Information",
    category: "Warranty",
    products: ["U35 Bolt+"],
    keywords: ["u35 bolt+ warranty", "warranty", "3 year", "repair", "replacement", "non-transferable", "warranty claim", "defective"],
    issue: "u35_bolt_plus_warranty",
    response: `The U35 Bolt+ includes a **3-Year repair/replacement warranty** provided by Oyen Digital.

**Warranty terms:**
• Coverage period: 3 years from date of purchase
• Non-transferable — limited to the original purchaser
• Covers manufacturer defects and hardware failure under normal use
• Does not cover physical damage, water damage, or data recovery

**To submit a warranty request:**
Fill out the warranty request form with your order information and description of the issue.

**Technical support:** info@oyendigital.com`
  },
];
window.LEGACY_FAQ_DB_DATA = [
    // ===== AVASTOR HDX1500 =====
    {
      id: "hdx1500_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_avastor_hdx1500"],
      keywords: ["hdx1500", "avastor hdx1500", "hdx 1500", "specs", "specifications", "overview", "ports", "interfaces", "dimensions", "weight"],
      issue: "hdx1500_overview",
      response: `The Avastor HDX1500 is a professional-grade desktop external hard drive enclosure designed for audio and video professionals. It accepts a standard 3.5-inch SATA hard drive.

**Interfaces / Ports:**
• USB 3.1
• FireWire 800 (FW800 / IEEE 1394b)
• FireWire 400 (FW400 / IEEE 1394a)
• eSATA 6G
Note: Only one interface should be active at a time.

**Drive Support:** 3.5-inch SATA HDD

**Chipset:** ASMedia 1351 & JMicron JMB355

**Physical:**
• Dimensions: 7.75 x 4.5 x 1.68 inches
• Materials: ABS

**Power:** Internal power supply, Input 100–240V AC (no wall adapter needed)

**Cooling:** Fluid Bearing Fan (built-in, low noise)

**Operating Temperature:** 5°C – 55°C

**LED Indicators:**
• Power LED — Green
• Activity LED — Red

**Compatible Systems:** Windows 7/8/10, Mac OS

**In the Box:**
USB B-A cable, eSATA cable, FW800 cable, IEC power cable, Session Label, Vertical HDX Stand, LockBox carry case

**Warranty:** 4-Year Industry Leading Warranty

**Status:** This product is discontinued. It has been replaced by the HDX Pro C.`
    },
    {
      id: "hdx1500_compatibility",
      title: "Mac, Windows & Linux Compatibility",
      category: "Compatibility",
      products: ["legacy_avastor_hdx1500"],
      keywords: ["hdx1500 mac", "hdx1500 windows", "hdx1500 linux", "compatible", "operating system", "format", "reformat", "time machine"],
      issue: "hdx1500_compatibility",
      response: `The Avastor HDX1500 is compatible with Mac, Windows, and Linux.

**Default Format:**
The HDX1500 ships pre-formatted for Mac (HFS+) and is Time Machine compatible out of the box.

**Using with Windows or Linux:**
The drive can be reformatted for use with Windows (NTFS) or Linux (ext4). Note that reformatting will erase all data on the drive — back up any existing content first.

**Cross-Platform Use (Mac + Windows):**
If you need to share the drive between Mac and Windows, format it as exFAT, which is natively read/written by both operating systems without additional software.

**Time Machine (Mac):**
The drive works with Time Machine as-shipped. Simply plug it in and macOS will prompt you to use it as a backup drive.

**Interface Compatibility:**
• **USB 3.1** — Compatible with USB 3.0, 3.1, and USB 2.0 ports (backwards compatible, speed will match the port)
• **FireWire 800** — Requires a FW800 port or FW400 with an adapter
• **eSATA 6G** — Requires an eSATA port on your computer or an eSATA expansion card`
    },
    {
      id: "hdx1500_connectivity",
      title: "Which Interface Should I Use? (USB vs FW800 vs eSATA)",
      category: "Connection",
      products: ["legacy_avastor_hdx1500"],
      keywords: ["hdx1500 interface", "usb or firewire", "esata vs usb", "fastest connection", "fw800", "firewire 800", "esata", "which port", "best connection"],
      issue: "hdx1500_connectivity",
      response: `The HDX1500 offers four interfaces. Here's a guide on which to use:

**eSATA 6G — Fastest**
eSATA provides a direct SATA connection and delivers the best performance. Use this if your computer has an eSATA port. Theoretical max: 6 Gbps (600 MB/s), though real-world drive speeds are the limiting factor.

**FireWire 800 (FW800 / IEEE 1394b) — Low Latency, Great for Audio/Video Work**
FW800 is highly recommended for professional audio and video recording due to its consistent, low-latency transfer performance. Theoretical max: 800 Mbps (~80 MB/s). If you are recording or working with DAW software (Pro Tools, Logic, Cubase, etc.), FW800 is the preferred interface.

**FireWire 400 (FW400 / IEEE 1394a) — Legacy FireWire**
The HDX1500 also includes a FW400 port for compatibility with older systems that have FW400 but not FW800. Theoretical max: 400 Mbps (~40 MB/s).

**USB 3.1 — Most Universal**
USB 3.1 is the most universally compatible option and is recommended if you don't have eSATA or FireWire ports. Fully backward compatible with USB 3.0 and USB 2.0 ports (speed will match the port).

**Thunderbolt 3 Port:**
The HDX1500 can connect to a Thunderbolt 3 port using a USB B-C cable (not included). It will operate at USB 3.1 speeds — it does not use the full Thunderbolt bandwidth.

**Important:** The HDX1500 can only use one connection at a time. Do not connect multiple interfaces simultaneously.`
    },
    {
      id: "hdx1500_power_fan",
      title: "Internal Power Supply & Fan",
      category: "Setup",
      products: ["legacy_avastor_hdx1500"],
      keywords: ["hdx1500 power", "power supply", "internal power", "wall adapter", "fan", "silent fan", "cooling", "overheating", "noise", "fan noise"],
      issue: "hdx1500_power_fan",
      response: `**Internal Power Supply:**
The HDX1500 includes a built-in power supply — no external power brick or wall adapter is required. Simply connect the included IEC power cable (standard computer-style power cable) directly to the drive and a wall outlet or power strip.

The internal power supply supports 100–240V AC, making it compatible worldwide.

**Built-In Silent Fan:**
The HDX1500 includes an internal cooling fan to keep the hard drive at a safe operating temperature during extended use. The fan is designed to run quietly.

**If the fan sounds louder than normal:**
• Ensure the drive has adequate ventilation — do not place it in an enclosed space or directly against a wall
• Check that the vents on the unit are not obstructed by dust or debris
• If the fan noise started suddenly or is accompanied by performance issues, contact support — it may indicate the drive is running hot due to an internal issue`
    },
    {
      id: "hdx1500_lockbox",
      title: "What is the LockBox?",
      category: "Overview",
      products: ["legacy_avastor_hdx1500"],
      keywords: ["lockbox", "lock box", "case", "carrying case", "shipping", "transport", "whats included"],
      issue: "hdx1500_lockbox",
      response: `The HDX1500 ships with an Avastor LockBox — a durable protective carrying case designed specifically for the drive.

**Key features of the LockBox:**
• Built to withstand the rigors of transport
• Compact enough to fit into any medium-sized shipping box from major carriers (UPS, FedEx, USPS, etc.)
• Ideal for professionals who transport drives between locations such as studios, post-production houses, and client sites

The LockBox is included in the box along with the HDX1500, cables, power cable, session label, and vertical stand.`
    },
    {
      id: "hdx1500_assembly",
      title: "How to Install a Hard Drive into the HDX1500 Enclosure",
      category: "Setup",
      products: ["legacy_avastor_hdx1500"],
      keywords: ["hdx1500 install", "install hard drive", "assembly", "open enclosure", "put drive in", "how to open", "slide rails", "top cover", "hard drive assembly"],
      issue: "hdx1500_assembly",
      response: `The HDX1500 is an enclosure — it accepts a standard 3.5-inch SATA hard drive which you install yourself. Follow these steps:

**Step 1 — Open the Enclosure**
Separate the top cover from the bottom chassis. The cover slides or lifts off depending on orientation.

**Step 2 — Install the Hard Drive**
Connect the hard drive to both SATA connectors inside the chassis (data and power). Place the drive into the chassis so that the screw hole aligns with the mount point.

**Step 3 — Close the Enclosure**
Replace the top cover and slide the included slide rails into the slots on each side to secure the enclosure.

**Step 4 — Format the Drive (if new)**
If you installed a brand new hard drive, it will not be accessible until it is formatted. See the formatting instructions in the "How to Format the HDX1500" article.

**Compatible drives:** 3.5-inch SATA HDDs`
    },   {
      id: "hdx_pro_leds_removal",
      title: "Safe Removal & LED Indicators",
      category: "Setup",
      products: ["legacy_avastor_hdx_pro"],
      keywords: ["hdx pro eject", "safe removal", "safely remove", "disconnect", "unplug", "led light", "green light", "red light", "activity light", "power light", "blinking"],
      issue: "hdx_pro_leds_removal",
      response: `**Always eject the HDX Pro before disconnecting or powering it off** to prevent data corruption.

**On Mac:** Click the eject icon (⏏) next to the drive in the Finder sidebar, wait for it to disappear from the desktop, then disconnect or power off.

**On Windows:** Click **Safely Remove Hardware** in the system tray, select the HDX Pro, wait for the confirmation, then disconnect or power off.

**LED Indicators:**

• **Power LED (Green)** — Solid green: drive is powered on and ready. Off: powered down.

• **Activity LED (Red)** — Blinking red: data is actively being read or written. Never disconnect while the Activity LED is blinking — wait for it to stop and eject the drive properly first.`
    },
    {
      id: "hdx_pro_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_avastor_hdx_pro"],
      keywords: ["hdx pro warranty", "warranty", "discontinued", "replacement", "hdx pro c", "out of warranty", "support"],
      issue: "hdx_pro_warranty",
      response: `**Warranty:**
The Avastor HDX Pro shipped with a 4-Year Industry Leading Warranty from the date of purchase. The warranty is non-transferable and applies to the original purchaser only.

**Discontinuation:**
The HDX Pro (HDX-C) has been discontinued and is no longer sold. It has been replaced by the **HDX Pro C**.

**If within warranty:** Submit a warranty request at OyenDigital.com/Support.

**If out of warranty:** Our support team can still assist with troubleshooting, data recovery guidance, and current replacement recommendations.

**User Manual:**
https://oyendigital.com/downloads/manuals/HDX_Pro_enclosure.pdf`
    },

    // ===== DASH PRO THUMB DRIVE =====
    {
      id: "dash_pro_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro", "dp-32a", "specs", "specifications", "overview", "flash drive", "thumb drive", "usb stick", "portable ssd", "dimensions", "weight", "controller"],
      issue: "dash_pro_overview",
      response: `The Dash Pro is a high-performance USB flash drive using NVMe SSD technology inside an aluminum alloy housing. It delivers SSD-class speeds in a thumb drive form factor, capable of up to 1050 MB/s when connected to a USB 3.2 Gen 2 or Thunderbolt 3/4 port.

**Interface:** USB-A (USB 3.2 Gen 2, up to 10 Gbps)
**Internal Interface:** NVMe PCIe 3.0 x4
**Controller:** Phison E13
**Memory:** 3D TLC NAND Flash
**Available Capacities:** 2TB, 4TB

**Physical:**
• Dimensions: 3.1 x 0.99 x 0.34 inches
• Weight: 2 oz
• Material: Aluminum Alloy (acts as heatsink)
• Keychain loop included

**Format (pre-formatted):** exFAT — compatible with Windows and Mac out of the box. Can be reformatted if desired.

**Operating Temperature:** 0°C – 60°C

**LED:** Single activity LED — blinking indicates data transfer

**Compatible Systems:** Windows, Mac, Linux; also compatible with PS4 / PS5 gaming consoles

**Thunderbolt:** Compatible with Thunderbolt 3, 4 & 5 using the included USB-C adapter. Not compatible with Thunderbolt 1 or 2.

**Certifications:** CE, FCC

**In the Box:** Dash Pro Flash Drive, USB-C adapter, USB-A extender, Lanyard

**Warranty:** 3-Year Repair/Replacement Warranty

**Status:** Discontinued`
    },
    {
      id: "dash_pro_connecting",
      title: "Connecting the Dash Pro — USB-A, USB-C & Extender",
      category: "Connection",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro connect", "how to connect", "usb-c adapter", "usb-a extender", "usb-c port", "plug in", "connection", "adapter", "extender", "connect to mac", "connect to pc"],
      issue: "dash_pro_connecting",
      response: `The Dash Pro has a native USB-A connector. Three connection methods are supported using the included accessories:

**Direct USB-A connection**
Plug the Dash Pro directly into any USB-A port on your computer. This is the most common connection method.

**Using the included USB-C adapter**
If your computer has USB-C or Thunderbolt 3/4 ports (and no USB-A), attach the included USB-C adapter to the drive's connector, then plug into your USB-C port. This is required to achieve full 10 Gbps speeds on modern USB-C Macs and PCs.

**Using the included USB-A extender**
If neighboring USB devices are physically blocking the port and there isn't enough clearance for the drive, attach the USB-A extender to the connector first, then plug the extender into the port. This adds a short flexible extension for tight spaces.

**First use — plug and play**
The drive ships pre-formatted as exFAT and is immediately ready to use on Windows and Mac. No drivers or software are required.`
    },
    {
      id: "dash_pro_speeds",
      title: "Speed & Performance — Why Is It Slower Than Expected?",
      category: "Connection",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro slow", "speed", "slow transfer", "performance", "not fast", "1050 mb/s", "expected speed", "usb 3.0 speed", "usb 2.0 speed", "bandwidth", "slow read", "slow write"],
      issue: "dash_pro_speeds",
      response: `The Dash Pro's maximum speed depends entirely on the port it is connected to. The drive itself is capable of up to 1050 MB/s, but only when connected to a fast enough port.

**Port speed reference:**

| Port Type | Max Speed | Approximate Real-World |
|---|---|---|
| Thunderbolt 3, 4 or USB 3.2 Gen 2 (10Gbps) | 10 Gbps | ~1050 MB/s |
| USB 3.0 / USB 3.1 Gen 1 (5Gbps) | 5 Gbps | ~500–525 MB/s |
| USB 2.0 | 480 Mbps | ~40 MB/s |

**Tips for maximum performance:**
• Use the included USB-C adapter and connect to a Thunderbolt 3, Thunderbolt 4, or USB 3.2 Gen 2 port for the fastest speeds
• Avoid USB hubs if possible — especially unpowered hubs, which can reduce bandwidth
• Make sure the port on your computer is actually USB 3.2 Gen 2 (10 Gbps) — many computers have a mix of Gen 1 (5 Gbps) and Gen 2 ports. Check your computer's spec sheet or system info to confirm

**Note:** The Dash Pro is not compatible with Thunderbolt 1 or 2 ports.`
    },
    {
      id: "dash_pro_thunderbolt",
      title: "Thunderbolt Compatibility",
      category: "Compatibility",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro thunderbolt", "thunderbolt 3", "thunderbolt 4", "thunderbolt 5", "tb3", "tb4", "thunderbolt compatible", "thunderbolt 1", "thunderbolt 2", "thunderbolt adapter", "usb-c thunderbolt"],
      issue: "dash_pro_thunderbolt",
      response: `**Thunderbolt 3 — Compatible ✓**
Use the included USB-C adapter and plug into any Thunderbolt 3 port. The drive will operate at full USB 3.2 Gen 2 speeds (~1050 MB/s).

**Thunderbolt 4 — Compatible ✓**
Same as Thunderbolt 3 — use the included USB-C adapter.

**Thunderbolt 5 — Compatible ✓**
The Dash Pro is also compatible with Thunderbolt 5 ports using the included USB-C adapter.

**Thunderbolt 1 — Not Compatible ✗**
Thunderbolt 1 uses a Mini DisplayPort connector and does not support USB devices natively.

**Thunderbolt 2 — Not Compatible ✗**
Thunderbolt 2 also uses a Mini DisplayPort connector and is not compatible with the Dash Pro, even with an adapter.

**Summary:** Thunderbolt 3, 4, and 5 are all compatible using the included USB-C adapter. Thunderbolt 1 and 2 are not supported.`
    },
    {
      id: "dash_pro_heat",
      title: "Why Is the Dash Pro Getting Warm?",
      category: "Overview",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro hot", "getting warm", "warm", "heat", "aluminum", "overheating", "normal temperature", "heatsink", "too hot", "temperature"],
      issue: "dash_pro_heat",
      response: `**This is completely normal and by design.**

The Dash Pro is built with an aluminum alloy housing that serves as an active heatsink. Unlike competing flash drives made from plastic, the aluminum body absorbs heat generated by the NVMe SSD components inside and dissipates it to the surrounding air.

This thermal design keeps the internal components at safe operating temperatures during sustained transfers, which is critical for maintaining consistent high performance and long-term reliability.

**What to expect:**
• The drive may become noticeably warm to the touch during large or extended file transfers
• This is a sign the heatsink is working correctly
• Operating temperature range is 0°C – 60°C

If the drive becomes excessively hot and performance drops sharply, try pausing the transfer briefly to allow the drive to cool, or ensure the drive is not enclosed in a tight space with no airflow.`
    },   {
      id: "dash_pro_led_eject",
      title: "Safe Disconnection & LED Indicator",
      category: "Setup",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro eject", "safely remove", "disconnect", "unplug", "led", "blinking light", "activity light", "safe removal", "eject windows", "eject mac"],
      issue: "dash_pro_led_eject",
      response: `**Always eject the Dash Pro before physically removing it** to prevent data corruption or file system errors.

**On Windows:**
1. Close any applications that are accessing files on the drive
2. Click the **Safely Remove Hardware** icon in the system tray
3. Highlight the Dash Pro from the list
4. Wait for the confirmation prompt: "You may safely remove this device"
5. Remove the drive

**On Mac:**
1. Close any applications that are accessing files on the drive
2. Drag the drive icon to the **Trash / Eject** icon in the Dock, or click the eject button (⏏) next to it in Finder
3. Wait for the drive icon to disappear from the desktop
4. Remove the drive

**LED Indicator:**
The Dash Pro has a single LED on the body:
• **Blinking** — Data is actively being transferred. Do not remove the drive while the LED is blinking.
• **Off / solid** — No active transfer; safe to eject via the above steps and then remove.`
    },
    {
      id: "dash_pro_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_dash_pro"],
      keywords: ["dash pro warranty", "warranty", "discontinued", "3 year warranty", "repair", "replacement", "support", "out of warranty"],
      issue: "dash_pro_warranty",
      response: `**Warranty:**
The Dash Pro includes a **3-Year Repair/Replacement Warranty** from the date of purchase. The warranty is non-transferable and is limited to the original purchaser.


For the complete warranty policy: ****

**Discontinuation:**
The Dash Pro (DP-32A) has been discontinued and is no longer sold.

**If within warranty:** Submit a warranty request and the team will assist with a repair or replacement evaluation.

**If out of warranty:** Our support team can still assist with troubleshooting guidance and recommendations for a current replacement product.

**User Manual:**
https://oyendigital.com/downloads/manuals/dash-pro-flash.pdf`
    },

    // ===== MINIPRO eSATA / USB =====
    {
      id: "minipro_esata_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata", "e31m-c", "e31m-c-bk", "specs", "specifications", "overview", "esata usb-c", "2.5 inch enclosure", "minipro enclosure", "dimensions", "weight", "chipset"],
      issue: "minipro_esata_overview",
      response: `The MiniPro eSATA / USB-C is a rugged 2.5-inch SATA drive enclosure offering both USB-C and eSATA 6G connectivity. The aluminum housing provides drop/impact protection and passive heat dissipation. With a compatible SSD installed, the enclosure is capable of speeds exceeding 500 MB/s.

**Interfaces / Ports:**
• USB-C (USB 3.1 Gen 2, up to 10 Gbps) — compatible with USB 3.1 / 3.0 / 2.0 and Thunderbolt 3
• eSATA 6G (up to 6 Gbps)
• Note: Only one interface may be used at a time

**Drive Support:** 2.5-inch SATA SSD or HDD (up to 15mm height)

**Chipset:** ASMedia 235CM (USB-C) & ASMedia 1542 (eSATA)
**Controller Features:** UASP & TRIM support

**Power:**
• USB bus power (USB connection only)
• External power adapter 5VDC/2A (included) — required for eSATA use, optional for USB use
• DC to USB power cable (included) — alternative power option for eSATA

**Physical:**
• Dimensions: 4.9 x 3.2 x 1.0 inches
• Weight: 6 oz
• Housing: Rugged aluminum (impact protection + passive heatsink)
• Power switch: ON/OFF

**Operating Environment:** 5°C – 60°C | Humidity: 10%RH – 80%RH

**Compatible Systems:** Windows, Mac, Linux

**Certifications:** CE, FCC

**In the Box:** MiniPro enclosure, USB C-A cable with Type-C adapter, eSATA cable, DC to USB power cable, external power adapter (5VDC/2A), user guide

**Warranty:** 3-Year Repair/Replacement Warranty

**Status:** Discontinued`
    },
    {
      id: "minipro_esata_interfaces",
      title: "USB-C vs eSATA — Which Interface to Use?",
      category: "Connection",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata which port", "usb-c vs esata", "which interface", "esata vs usb", "use esata", "use usb-c", "interface comparison", "fastest connection", "esata speed", "usb-c speed"],
      issue: "minipro_esata_interfaces",
      response: `The MiniPro eSATA / USB-C supports two interfaces. **Only connect one at a time** — do not connect both simultaneously.

**USB-C (USB 3.1 Gen 2 — up to 10 Gbps)**
• Plug-and-play: connect the USB cable, power on, wait 5–20 seconds
• Can run on USB bus power — no external power adapter required
• Also compatible with USB 3.0 and USB 2.0 ports (at those ports' lower speeds)
• Compatible with Thunderbolt 3 ports
• Best for: everyday use, laptops, portability without carrying a power adapter

**eSATA 6G (up to 6 Gbps)**
• Requires external power — either the included power adapter or the DC to USB power cable connected to a USB port
• Connect the eSATA cable to an eSATA port on your computer, apply power, then turn on the power switch
• Best for: desktop workstations with an eSATA port where maximum SATA throughput is needed

**Speed summary:**
| Interface | Max Bandwidth |
|---|---|
| USB-C (USB 3.1 Gen 2) | 10 Gbps (~1000 MB/s theoretical) |
| eSATA 6G | 6 Gbps (~600 MB/s theoretical) |
| USB 3.0 / 3.1 Gen 1 | 5 Gbps (~500 MB/s theoretical) |

Real-world SSD speeds will be limited by the drive's own read/write performance.`
    },
    {
      id: "minipro_esata_power",
      title: "Power Options — Bus Power vs External Adapter",
      category: "Connection",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata power", "bus power", "external power", "power adapter", "dc to usb cable", "esata power required", "usb powered", "no power adapter", "power supply"],
      issue: "minipro_esata_power",
      response: `The MiniPro eSATA / USB-C supports two power options depending on which interface you use:

**USB Bus Power (USB connection)**
When connected via USB-C, the enclosure draws power directly from your computer's USB port. No external power adapter is needed. This makes it a true portable solution when using USB.

**External Power (required for eSATA)**
When connecting via eSATA, the eSATA port does not carry power, so external power is mandatory. Two options are included:

• **Power Adapter (5VDC/2A):** Plug directly into a wall outlet and connect to the DC IN port on the enclosure
• **DC to USB Power Cable:** Connect the DC end to the enclosure's DC IN port, and the USB end to any available USB port on your computer or a USB charger — useful if a wall outlet is not accessible

**Summary:**
| Connection | Bus Power | Adapter Required |
|---|---|---|
| USB-C | ✓ Yes — no adapter needed | Optional |
| eSATA | ✗ No | ✓ Required |`
    },
    {
      id: "minipro_esata_assembly",
      title: "How to Install a Drive into the MiniPro Enclosure",
      category: "Setup",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata install drive", "install hard drive", "open enclosure", "drive assembly", "ssd install", "screw", "circuit board", "how to open", "assemble", "put drive in"],
      issue: "minipro_esata_assembly",
      response: `The MiniPro eSATA / USB-C is an enclosure — you install your own 2.5-inch SATA drive. Follow these steps:

**Step 1 — Open the Enclosure**
Remove the screw located at the bottom of the case, then slide the circuit board out from the enclosure.

**Step 2 — Install the Drive**
Connect your 2.5-inch SATA drive to the SATA connector on the circuit board. Mount the drive using the 4 included silver mounting screws. Do not over-tighten.

**Step 3 — Reassemble**
Slide the assembled drive (circuit board + drive) back into the enclosure. Fasten the 4 screws at the bottom of the casing to complete the assembly, then place the rubber feet over the screws.

**Compatible drives:** 2.5-inch SATA SSD or HDD, up to 15mm in height

**Step 4 — Format (if new drive)**
A brand new drive must be formatted before use. See the "Formatting" article for instructions.`
    },   {
      id: "minipro_esata_trim",
      title: "TRIM Support on the MiniPro eSATA / USB-C",
      category: "Compatibility",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata trim", "trim support", "trim windows", "trim mac", "ssd optimization", "optimize drive", "uasp trim", "ntfs trim", "garbage collection"],
      issue: "minipro_esata_trim",
      response: `The MiniPro eSATA / USB-C supports TRIM via its ASMedia chipset, which helps maintain long-term SSD performance by allowing the operating system to inform the drive which data blocks are no longer in use.

**TRIM on Windows:**
TRIM is supported when the drive is formatted as **NTFS**. To use the Optimize (TRIM) function in Windows, the drive must be formatted as NTFS..

**TRIM on Mac:**
Mac OS does not currently support TRIM with external USB drives. TRIM will not function when connected to a Mac via USB, regardless of file system.

**UASP (USB Attached SCSI Protocol):**
The enclosure also supports UASP, which improves USB transfer efficiency and reduces CPU overhead compared to standard BOT (Bulk-Only Transfer) mode. UASP is automatically used when your host system supports it — no configuration needed.`
    },
    {
      id: "minipro_esata_connecting",
      title: "Connecting & Disconnecting the MiniPro",
      category: "Setup",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata connect", "how to connect", "usb-c connect", "esata connect", "power on", "power switch", "safely remove", "eject", "disconnect", "unplug", "safe removal"],
      issue: "minipro_esata_connecting",
      response: `**Connecting via USB-C:**
1. Connect the USB cable to a USB port on your computer
2. Turn the power switch ON
3. Wait 5–20 seconds for the computer to recognize the drive

**Connecting via eSATA:**
1. Connect the eSATA cable to the eSATA port on your computer
2. Apply power using either the included power adapter or the DC to USB power cable
3. Turn the power switch ON
4. Wait 5–20 seconds for the computer to recognize the drive

⚠️ Only connect one interface at a time.

**Disconnecting safely:**

*Windows:*
1. Close all applications accessing the drive
2. Click **Safely Remove Hardware** in the system tray
3. Highlight the MiniPro and wait for "You may safely remove this device"
4. Turn off the power switch and disconnect

*Mac:*
1. Close all applications accessing the drive
2. Drag the drive to the **Trash/Eject** icon, or click ⏏ next to it in Finder
3. Wait for the drive icon to disappear from the desktop
4. Turn off the power switch and disconnect`
    },
    {
      id: "minipro_esata_thunderbolt",
      title: "Thunderbolt 3 Compatibility",
      category: "Compatibility",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata thunderbolt", "thunderbolt 3", "tb3", "thunderbolt compatible", "usb-c thunderbolt", "thunderbolt port"],
      issue: "minipro_esata_thunderbolt",
      response: `The MiniPro eSATA / USB-C is compatible with **Thunderbolt 3** ports via its USB-C interface.

Connect the included USB-C cable to the Thunderbolt 3 port on your computer. The drive will operate at USB 3.1 Gen 2 speeds (up to 10 Gbps) — it does not use the full Thunderbolt 3 bandwidth (40 Gbps), but is fully functional and plug-and-play.

Thunderbolt 1 and Thunderbolt 2 ports (Mini DisplayPort style) are not compatible.`
    },
    {
      id: "minipro_esata_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_minipro_esata"],
      keywords: ["minipro esata warranty", "warranty", "discontinued", "3 year", "repair replacement", "support", "rma"],
      issue: "minipro_esata_warranty",
      response: `**Warranty:**
The MiniPro eSATA / USB-C includes a **3-Year Repair/Replacement Warranty** from the date of purchase. The warranty is non-transferable and is limited to the original purchaser.

For the complete warranty policy:

**Discontinuation:**
The MiniPro eSATA / USB-C (E31M-C-BK) has been discontinued and is no longer sold.

**If within warranty:** Submit a warranty request and the team will assist with a repair or replacement evaluation.

**If out of warranty:** Our support team can still help with troubleshooting guidance and recommendations for a current replacement.

**User Manual:**
https://oyendigital.com/downloads/manuals/minipro-E31M-C25-Enclosure.pdf`
    },

    // ===== MINIPRO RAID V2 =====
    {
      id: "minipro_raid_v2_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2", "cb3r2-sl", "specs", "specifications", "overview", "firewire 800", "fw800", "usb 3.0", "esata", "2-bay raid", "raid enclosure", "dimensions", "chipset"],
      issue: "minipro_raid_v2_overview",
      response: `The MiniPro RAID V2 is a dual-drive 2.5-inch SATA enclosure offering a triple-interface combination of FireWire 800, USB 3.0, and eSATA 6G. It features a hardware RAID controller with four configurable modes (RAID 0, RAID 1, JBOD, BIG) set via a physical switch — no software required. The fully aluminum housing provides passive silent cooling and impact protection.

**Interfaces / Ports:**
• FireWire 800 (IEEE 1394b) — up to 100 MB/s; two FW800 ports for daisy-chaining
• USB 3.0 — up to 425 MB/s
• eSATA 6G — up to 375 MB/s

**Drive Support:** 2 × 2.5-inch SATA HDD or SSD (up to 15mm height); up to 4TB per bay when using RAID 1

**Chipset:** JMicron JMS562 / JMS355

**RAID Modes:** RAID 0 (Striping), RAID 1 (Mirroring), JBOD (independent drives), BIG (Span)
**Default Mode:** JBOD

**Power:** AC adapter (+12V/2A, included) or FireWire bus power
**Note:** USB/eSATA can be used for data while FireWire provides power simultaneously

**Physical:**
• Dimensions: 6.5 x 5.1 x 1.1 inches
• Weight: 20 oz
• Housing: Full aluminum

**LED Indicators:** Power LED, Drive 1 (D1), Drive 2 (D2)

**Compatible Systems:** Mac OS 10.4 or higher; Windows Vista/7/8 or higher; Linux

**Certifications:** CE, FCC

**In the Box:** MiniPro RAID V2, eSATA cable, USB 3.0 cable, FW800 cable, AC adapter, user guide

**Optional Software:** RAID Manager utility available for Windows and Mac (optional — hardware RAID requires no software)

**Status:** No longer available`
    },
    {
      id: "minipro_raid_v2_raid_modes",
      title: "RAID Modes Explained — RAID 0, RAID 1, JBOD, BIG",
      category: "Overview",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 raid modes", "raid 0", "raid 1", "jbod", "big span", "striping", "mirroring", "raid mode", "which raid mode", "raid explained", "redundancy", "performance"],
      issue: "minipro_raid_v2_raid_modes",
      response: `The MiniPro RAID V2 supports four hardware RAID modes, set via a physical switch on the enclosure. No software is required to configure or use RAID.

**RAID 0 — Striping (Speed)**
Data is split and written simultaneously across both drives, dramatically increasing read/write performance. The two drives appear as a single volume.
• ⚠️ No redundancy — if one drive fails, all data on both drives is lost
• Total capacity = (smallest drive size) × 2. Example: a 500GB + 2TB pair yields only 1TB total.
• Best for: performance-critical workflows where data is backed up elsewhere

**RAID 1 — Mirroring (Redundancy)**
Both drives store identical copies of all data. If one drive fails, the other contains a complete copy.
• Write speed is slower than RAID 0
• Total capacity = capacity of one drive (the smaller of the two)
• Max 4TB per bay
• Supports automatic rebuild when a failed drive is replaced
• Best for: data protection and reliability

**JBOD — Just a Bunch Of Drives (Independent)**
Each drive appears as a completely separate, independent volume to your operating system. No RAID, no merging.
• This is the **default mode** from the factory
• No performance benefit or redundancy
• Each drive can be removed and accessed individually in another enclosure
• Best for: using two separate drives independently from one enclosure

**BIG — Span (Combined Volume)**
Both drives are combined into a single larger logical volume. Unlike RAID 0, data is written to the first drive until it is full, then continues onto the second drive.
• No performance increase; no redundancy
• Total capacity = Drive 1 + Drive 2
• Best for: maximizing total available storage in a single volume`
    },
    {
      id: "minipro_raid_v2_setup",
      title: "Setting & Changing RAID Modes",
      category: "Setup",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 setup", "set raid mode", "change raid mode", "raid switch", "set button", "configure raid", "clear raid", "jbod setup", "raid 0 setup", "raid 1 setup", "big setup", "clear procedure"],
      issue: "minipro_raid_v2_setup",
      response: `RAID mode is configured using a physical switch on the enclosure plus a SET button — no software required.

**Setting a RAID Mode (new drives or after Clear):**
1. Set the mode switch on the MiniPro to the desired RAID mode
2. Connect the MiniPro to your computer
3. Using the tip of the included screwdriver, press and hold the **SET button** while turning on the power switch
4. Hold the SET button for **7–10 seconds**
5. Release the SET button — the RAID mode is now configured
6. Format the volume before use (see Formatting article)

**Clearing an Existing RAID Mode (required before changing modes):**
Before changing from one RAID mode to another, you must first perform a Clear procedure:
1. Set the mode switch to **Clear**
2. Press and hold the SET button while turning on the power
3. Hold for **7–10 seconds**, then release
4. The previous RAID mode is removed and the drives are now set to JBOD

**Important notes:**
• Performing a Clear on RAID 1 or JBOD drives **does not delete existing data**
• When installing previously used JBOD drives, Oyen Digital recommends performing a Clear procedure first to condition the drives for use
• After setting a new RAID mode, the volume must be formatted before it is accessible
• Default mode out of the factory is JBOD`
    },
    {
      id: "minipro_raid_v2_install_drives",
      title: "Installing Drives into the MiniPro RAID V2",
      category: "Setup",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 install", "install drives", "open enclosure", "drive assembly", "circuit board", "d1 d2 slot", "screw bracket", "2.5 inch ssd", "add drives", "empty enclosure"],
      issue: "minipro_raid_v2_install_drives",
      response: `The MiniPro RAID V2 is an enclosure — you install your own 2.5-inch SATA drives. Supports HDDs and SSDs up to 15mm in height.

**Step 1 — Open the enclosure**
Remove the screws at the bottom of the case and slide the circuit board bracket out from the enclosure.

**Step 2 — Install drives**
Install your drives into the D1 and D2 slots on the circuit board.

**Step 3 — Mount the drives**
Hold the drives into the bracket, flip it over to view the screw holes, and use the 8 included mounting screws and the included screwdriver to attach the drives to the bracket. Do not over-tighten.

**Step 4 — Reassemble**
Slide the bracket back into the enclosure and fasten using the 4 exterior screws removed in Step 1.

**Step 5 — Configure RAID and format**
If using a mode other than the default JBOD, set your RAID mode before formatting. New drives must be formatted before they are accessible — see the Formatting article for instructions.

**Compatible drives:** 2.5-inch SATA HDD or SSD, up to 15mm height, up to 4TB per bay (RAID 1)`
    },
    {
      id: "minipro_raid_v2_power",
      title: "Power Options — AC Adapter vs FireWire Bus Power",
      category: "Connection",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 power", "bus power", "firewire bus power", "ac adapter", "power adapter", "usb esata power", "firewire power", "power options", "no power adapter"],
      issue: "minipro_raid_v2_power",
      response: `The MiniPro RAID V2 supports two power sources:

**AC Adapter (included — +12V/2A)**
Plug the included AC adapter into a wall outlet and connect to the power input on the enclosure. Works with all three interfaces (USB, eSATA, FireWire).

**FireWire Bus Power**
When connected via FireWire 800, the MiniPro can draw power directly from the FireWire bus — no AC adapter needed. This makes it portable when used with a Mac or PC with a FireWire port.

**Using USB or eSATA for data + FireWire for power:**
A useful configuration for computers that have FireWire but you prefer USB or eSATA for data speed:
1. Connect the USB 3.0 or eSATA cable for data
2. Connect the FireWire cable for power
3. Turn on the power switch

This allows you to benefit from USB 3.0 transfer speeds while using FireWire bus power, without needing the AC adapter.

**Note:** USB and eSATA alone do not supply sufficient bus power for the dual-drive system — FireWire or the AC adapter is required in those cases.`
    },
    {
      id: "minipro_raid_v2_leds",
      title: "LED Indicators — Status & Drive Health",
      category: "Overview",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 led", "led indicator", "drive error", "red light", "blinking led", "d1 d2 led", "power led", "drive status", "sleep light", "rebuild light"],
      issue: "minipro_raid_v2_leds",
      response: `The MiniPro RAID V2 has three LED indicators: **Power LED**, **D1** (Drive 1), and **D2** (Drive 2).

**LED State Reference:**

| Power LED | D1 / D2 LED | Meaning |
|---|---|---|
| Slow steady blink | Off | **Powered & ready** (no activity) |
| Slow steady blink | Fast rapid blinking | **Read/Write activity** |
| Slow steady blink | Slow steady blink | **HDD Sleep mode** |
| Fast rapid blinking | Fast rapid blinking | **RAID 1 Rebuilding** |
| (any) | Red or Off | **Drive Error** — that drive has failed or is missing |

**Key notes:**
• D1 and D2 LEDs will be **OFF** when the MiniPro is not connected to a computer, or when a drive is not installed in that bay
• A **red or off** D1 or D2 LED while connected to a computer indicates a drive failure — see the RAID 1 Rebuild article if using RAID 1
• During a RAID 1 rebuild, the D1/D2 LEDs blink twice per second — this can take many hours depending on capacity`
    },
    {
      id: "raid_mobius_formatting_guide",
      title: "Formatting After a RAID Mode Change",
      category: "Setup",
      products: ["Mobius", "Mobius 2C", "Mobius 5-Bay", "MiniPro", "MiniPro RAID", "legacy_minipro_raid_v2", "legacy_minipro_raid_v3", "legacy_mobius_2bay", "legacy_mobius_pro_2c", "legacy_mobius_tb2", "legacy_mobius_pro_5c"],
      keywords: ["raid format", "format after raid", "raid mode format", "mobius format", "minipro format", "format volume", "raid 0 format", "raid 1 format", "jbod format", "ntfs raid", "exfat raid", "disk management raid", "disk utility raid", "unallocated raid", "new simple volume", "format enclosure"],
      issue: "raid_formatting",
      response: `After setting a new RAID mode, you must format the volume before it is accessible on your computer.

**Note:** RAID 0, RAID 1, RAID 5, RAID 10, and BIG (Span) will all appear as a single drive to the OS. JBOD will appear as separate drives, each requiring individual formatting.

**Recommended formats:**
| Use Case | Format |
|---|---|
| Windows only | NTFS |
| Mac only | HFS+ (Mac OS Extended) |
| Windows + Mac | exFAT |

**On Windows — Disk Management:**
1. Connect the Oyen drive.
2. Right-click the Start button and select **Disk Management**.
3. If the drive already shows a partition (for example, a Mac volume), locate the Oyen drive by its capacity, right-click each partition on that disk and select **Delete Volume**, then confirm.
4. After all partitions are deleted, the drive will show as **Unallocated**.
5. Find the Unallocated disk in the list.
6. If prompted to initialize, choose **GPT** (recommended) and click OK.
7. Right-click the unallocated space and select **New Simple Volume**.
8. Follow the wizard and format as **NTFS** (recommended for Windows-only use) or **exFAT** (for cross-platform use).

**On Mac — Disk Utility:**
1. Connect the Oyen drive.
2. Open **Disk Utility** (Applications > Utilities > Disk Utility).
3. Select the drive from the left sidebar.
4. Click **Erase**.
5. Choose a name, select **APFS** or **Mac OS Extended (Journaled)** for Mac-only use, or **exFAT** for cross-platform use.
6. Click **Erase** to confirm.

**Note:** Formatting erases all data on the volume. If you are reconfiguring RAID, ensure any needed data has been backed up first.`
    },
    {
      id: "minipro_raid_v2_rebuild",
      title: "RAID 1 Drive Failure & Rebuild Procedure",
      category: "Setup",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 rebuild", "drive failure", "failed drive", "replace drive", "raid 1 rebuild", "d1 d2 red", "automatic rebuild", "replace failed drive", "data recovery raid 1"],
      issue: "minipro_raid_v2_rebuild",
      response: `**Detecting a drive failure:**
If a drive fails, the **D1 or D2 LED will appear red or off** while the MiniPro is connected to a computer. You can still access your data from the remaining healthy drive if configured in RAID 1.

**RAID 1 Automatic Rebuild:**
When configured in RAID 1 (Mirroring), the MiniPro RAID V2 supports automatic rebuild after a failed drive is replaced. The replacement drive **must be a new, unformatted drive**.

**Rebuild steps:**
1. Power down the MiniPro RAID
2. Remove the failed drive using the included screwdriver
3. Install the new (unformatted) replacement drive
4. Power up the MiniPro
5. The D1/D2 LED will blink twice per second — this indicates a rebuild is in progress
6. Wait for the rebuild to complete — this can take **many hours** depending on drive capacity and model
7. Do not power off or disconnect during rebuild

**Notes:**
• Automatic rebuild only works in **RAID 1** mode
• RAID 0 does not support rebuild — a drive failure in RAID 0 results in complete data loss for both drives
• After rebuild completes, the new drive is an exact mirror of the surviving drive`
    },
    {
      id: "minipro_raid_v2_drive_access",
      title: "Can I Remove a Drive and Access It in Another Enclosure?",
      category: "Compatibility",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 remove drive", "access files", "remove drive", "single drive access", "other enclosure", "jbod access", "raid 1 access", "drive portable"],
      issue: "minipro_raid_v2_drive_access",
      response: `Whether you can remove a drive from the MiniPro RAID V2 and access its files in another enclosure depends on the RAID mode:

**JBOD — Yes ✓**
In JBOD mode, each drive is independent and contains its own file system. You can remove either drive and install it in a standard 2.5-inch enclosure to access its files normally.

**RAID 1 (Mirroring) — Yes ✓**
In RAID 1, each drive contains an identical, complete copy of all data. You can remove either drive and read it in another standard 2.5-inch SATA enclosure.

**RAID 0 (Striping) — No ✗**
RAID 0 splits data across both drives simultaneously. Neither drive alone contains complete files — both drives must be present and working together in the RAID 0 array to access data.

**BIG (Span) — No ✗**
BIG mode creates a single spanned volume across both drives. Files may span across both physical drives, so removing one drive alone will not give you full access to all data.

**Summary:** RAID 1 and JBOD drives can be removed and accessed independently. RAID 0 and BIG drives cannot.`
    },
    {
      id: "minipro_raid_v2_sleep",
      title: "Sleep Mode Behavior",
      category: "Overview",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 sleep", "auto sleep", "sleep mode", "computer sleep", "power management", "sleep follow computer"],
      issue: "minipro_raid_v2_sleep",
      response: `The MiniPro RAID V2 does not have an independent auto-sleep timer.

However, it does support **computer-linked sleep**: when your computer enters sleep mode, the MiniPro will automatically enter sleep mode as well. When your computer wakes, the MiniPro will wake with it.

**LED during sleep:** Both D1 and D2 LEDs will show a slow steady blink to indicate the drive is in HDD sleep mode.

This behavior is automatic and requires no configuration — it is managed by your computer's power management settings.`
    },
    {
      id: "minipro_raid_v2_warranty",
      title: "Warranty & Availability Info",
      category: "Warranty",
      products: ["legacy_minipro_raid_v2"],
      keywords: ["minipro raid v2 warranty", "warranty", "discontinued", "no longer available", "support", "repair replacement"],
      issue: "minipro_raid_v2_warranty",
      response: `**Warranty:**
The MiniPro RAID V2 shipped with a **2-Year Repair/Replacement Warranty** from the date of purchase (per the product manual). The warranty is non-transferable and is limited to the original purchaser.

**Availability:**
The MiniPro RAID V2 (CB3R2-SL) is no longer available.

**Optional RAID software (still available for download):**

These utilities are optional — the hardware RAID controller works without any software.

**User Manual:**
https://oyendigital.com/downloads/manuals/minipro-RAID-V2-3Panel.pdf`
    },

    // ===== MINIPRO RAID V3 =====
    {
      id: "minipro_raid_v3_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["minipro raid v3", "cb3r3", "specs", "specifications", "overview", "usb-c raid", "usb 3.1", "2-bay raid", "raid v3", "dimensions", "chipset", "10gbps"],
      issue: "minipro_raid_v3_overview",
      response: `The MiniPro RAID V3 is the successor to the V2, replacing FireWire 800 and eSATA with a single modern USB-C (USB 3.1 Gen 2) interface delivering up to 10 Gbps. It retains the same aluminum housing, hardware RAID controller, and four RAID modes. A fan provides active cooling (note: do not block the fan).

**Interface / Port:**
• USB-C (USB 3.1 Gen 2) — up to 10 Gbps
• Compatible with USB 3.1, USB 3.0, USB 2.0 ports
• Compatible with **Thunderbolt 3** ports
• **Not compatible** with Thunderbolt 2 (even via adapter)

**Drive Support:** 2 × 2.5-inch SATA HDD or SSD (up to 15mm height)

**RAID Modes:** RAID 0 (Striping), RAID 1 (Mirroring), JBOD (independent drives), BIG (Span — legacy, not recommended)
**Default Mode:** JBOD

**Power:**
• DC adapter (+12V/2A, included) — recommended for USB 3.0 host ports
• USB bus power — selector switch on enclosure; use a USB Y-cable (two USB ports) for maximum power on USB 3.0

**Physical:**
• Dimensions: 6.5 x 5.1 x 1.1 inches
• Housing: Aluminum with active fan cooling

**Compatible Systems:** Windows, Mac, Linux

**Certifications:** FCC Class B

**In the Box:** MiniPro RAID V3 enclosure, USB-C cable, DC adapter (+12V/2A), screwdriver, user guide

**Video Guide:** TinyURL.com/MiniProV3Video

**Status:** Discontinued`
    },
    {
      id: "minipro_raid_v3_vs_v2",
      title: "MiniPro RAID V3 vs V2 — What Changed?",
      category: "Overview",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 vs v2", "difference v2 v3", "upgrade", "firewire removed", "esata removed", "usb-c", "minipro raid comparison", "v3 new features"],
      issue: "minipro_raid_v3_vs_v2",
      response: `The MiniPro RAID V3 is a significant interface update over the V2. Here's what changed:

| Feature | RAID V2 | RAID V3 |
|---|---|---|
| Data interface | USB 3.0, FireWire 800, eSATA | USB-C (USB 3.1 Gen 2) only |
| Max speed | ~425 MB/s (USB 3.0) | ~1000 MB/s theoretical (USB 3.1 Gen 2) |
| Thunderbolt 3 | ✗ | ✓ (via USB-C) |
| Thunderbolt 2 | ✗ | ✗ |
| Power | AC adapter or FW bus power | AC adapter or USB bus power (selector switch) |
| Fan | Passive (no fan) | Active fan |
| SET button hold time | 7–10 seconds | 5 seconds |
| Rebuild time estimate | Not specified | HDD: size × 3 hrs; SSD: combined size ÷ 4 hrs |
| Disconnect during rebuild | Not specified | ✓ Supported |
| RAID modes | RAID 0, 1, JBOD, BIG | RAID 0, 1, JBOD, BIG (BIG noted as legacy) |
| Dimensions | 6.5 × 5.1 × 1.1 in | 6.5 × 5.1 × 1.1 in |
| Warranty | 2 years | 2 years |

**Bottom line:** The V3 drops legacy interfaces (FW800, eSATA) in favor of the modern USB-C Gen 2 interface and adds Thunderbolt 3 compatibility.`
    },
    {
      id: "minipro_raid_v3_raid_modes",
      title: "RAID Modes Explained — RAID 0, RAID 1, JBOD, BIG",
      category: "Overview",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 raid modes", "raid 0", "raid 1", "jbod", "big span", "striping", "mirroring", "which raid mode", "redundancy", "performance", "span legacy"],
      issue: "minipro_raid_v3_raid_modes",
      response: `The MiniPro RAID V3 supports four hardware RAID modes set via a physical switch — no software required.

**RAID 0 — Striping (Speed)**
Data is split and written simultaneously across both drives for dramatically increased read/write performance. Appears as a single volume.
• ⚠️ No redundancy — if one drive fails, all data is lost
• Total capacity = smallest drive × 2. (e.g., 500GB + 2TB = 1TB total)
• Best for: performance workflows where data is backed up elsewhere

**RAID 1 — Mirroring (Redundancy)**
Both drives store identical copies of all data. If one drive fails, a complete copy remains on the other.
• Slower writes than RAID 0
• Total capacity = one drive's capacity (e.g., 2 × 1TB = 1TB usable)
• Supports automatic rebuild when failed drive is replaced
• Best for: data protection and reliability

**JBOD — Just a Bunch Of Drives (Default)**
Each drive appears as a completely independent volume. No RAID, no merging. Default factory mode.
• No performance benefit or redundancy
• Each drive can be removed and accessed individually in another enclosure
• Best for: using two separate drives independently

**BIG — Span (Legacy — Not Recommended)**
Combines both drives into one large volume. Fills the first drive completely before writing to the second.
• No performance increase or redundancy
• The manual notes this is a **legacy mode** that may cause a decrease in drive performance — not recommended for most applications`
    },
    {
      id: "minipro_raid_v3_setup",
      title: "Setting & Changing RAID Modes",
      category: "Setup",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 setup", "set raid mode", "change raid mode", "raid switch", "set button", "configure raid", "clear raid", "5 seconds", "clear procedure", "jbod setup"],
      issue: "minipro_raid_v3_setup",
      response: `RAID mode is configured with a physical switch and SET button. No software required.

**Setting a RAID Mode:**
1. Set the mode switch to the desired RAID mode
2. Connect the MiniPro to your computer and turn it on
3. Using the tip of the included screwdriver, press and hold the **SET button for at least 5 seconds**
4. Release the SET button — the RAID mode is now configured
5. Format the volume before use (see Formatting article)

**Clearing an Existing RAID Mode (required before changing modes):**
1. Set the mode switch to **Clear**
2. Connect to computer and turn on
3. Press and hold the SET button for **at least 5 seconds**
4. Release — the previous RAID mode is removed, drives revert to JBOD
5. You can now set a new mode or leave as JBOD

**Important notes:**
• sufficient bus power for two drives.

**USB = Bus Power**
The MiniPro draws power directly from the USB port on your computer. Works with USB-C and USB 3.1/3.0 ports.

• If using USB 3.0 bus power, Oyen Digital recommends a **USB Y-cable** (connects to two USB ports simultaneously for maximum power delivery). • USB bus power is most reliable on USB 3.1 Gen 2 / USB-C ports which deliver higher power

**To switch:** Slide the DC/USB selector switch to the desired position before powering on.`
    },
    {
      id: "minipro_raid_v3_thunderbolt",
      title: "Thunderbolt Compatibility",
      category: "Compatibility",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 thunderbolt", "thunderbolt 3", "tb3", "thunderbolt 2", "tb2 adapter", "usb-c thunderbolt", "thunderbolt compatible"],
      issue: "minipro_raid_v3_thunderbolt",
      response: `**Thunderbolt 3 — Compatible ✓**
The MiniPro RAID V3 is fully compatible with Thunderbolt 3 ports via its USB-C interface. Connect the included USB-C cable to a Thunderbolt 3 port and it will operate at USB 3.1 Gen 2 speeds (up to 10 Gbps).

**Thunderbolt 2 — Not compatible ✗**
The MiniPro RAID V3 is **not compatible with Thunderbolt 2**, even when using a Thunderbolt 3-to-Thunderbolt 2 adapter of any make or model.

Thunderbolt 2 uses a Mini DisplayPort connector and a different protocol that does not support USB 3.1 passthrough, so the MiniPro will not be recognized.`
    },
    {
      id: "minipro_raid_v3_install_drives",
      title: "Installing Drives into the MiniPro RAID V3",
      category: "Setup",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 install drives", "install hard drive", "open enclosure", "drive assembly", "d1 d2 slot", "8 screws", "circuit board", "bracket", "assemble drives"],
      issue: "minipro_raid_v3_install_drives",
      response: `The MiniPro RAID V3 is an enclosure — install your own 2.5-inch SATA drives (HDD or SSD, up to 15mm height).

**Step 1 — Open the enclosure**
Remove the screws at the bottom of the case and slide the circuit board bracket out.

**Step 2 — Install drives**
Insert drives into the D1 and D2 slots on the circuit board.

**Step 3 — Mount the drives**
Hold the drives against the bracket, flip over to access the screw holes, and fasten using the 8 included mounting screws and the included screwdriver.

**Step 4 — Reassemble**
Slide the bracket back into the enclosure and replace the 4 exterior bottom screws.

**Step 5 — Configure and format**
If you want a mode other than JBOD, set RAID mode before formatting. Format the volume(s) before use — see the Setup and Formatting articles.`
    },
    {
      id: "minipro_raid_v3_rebuild",
      title: "RAID 1 Drive Failure & Rebuild Procedure",
      category: "Setup",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 rebuild", "drive failure", "red led", "replace drive", "raid 1 rebuild", "automatic rebuild", "rebuild time", "d1 d2 red", "failed drive"],
      issue: "minipro_raid_v3_rebuild",
      response: `**Detecting a drive failure:**
If a drive fails, the **D1 or D2 LED will turn RED** while the MiniPro is connected to a computer.

**RAID 1 Automatic Rebuild:**
Replace the failed drive and the MiniPro will automatically rebuild — no software required.

**Rebuild steps:**
1. Power down the MiniPro and remove the failed drive
2. Install the new replacement drive
3. Power up the MiniPro and connect to a computer
4. The D1/D2 LED will blink about **three times per second** — rebuild is in progress
5. You may disconnect the MiniPro from the computer during the rebuild if desired — **this will not interrupt the rebuild**

**Estimating rebuild time:**
| Drive Type | Formula | Example |
|---|---|---|
| HDD | Drive size (TB) × 3 = hours | 10TB RAID 1 → 5TB × 3 = **15 hours** |
| SSD | Combined size (TB) ÷ 4 = hours | 4TB SSD RAID 1 → 4 ÷ 4 = **1 hour** |

**Note:** Only RAID 1 supports automatic rebuild. RAID 0 does not — a drive failure in RAID 0 results in complete data loss.`
    },
    {
      id: "minipro_raid_v3_leds",
      title: "LED Indicators — Status & Drive Health",
      category: "Overview",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 led", "led indicator", "red led", "drive error", "blinking led", "d1 d2 led", "power led", "sleep indicator", "rebuild indicator", "drive status"],
      issue: "minipro_raid_v3_leds",
      response: `The MiniPro RAID V3 has three LED indicators: **Power LED**, **D1** (Drive 1), and **D2** (Drive 2).

**LED State Reference:**

| Power LED | D1 / D2 LED | Meaning |
|---|---|---|
| Slow steady blink | Off | **Powered & ready** |
| Slow steady blink | Fast rapid blinking | **Read/Write activity** |
| Slow steady blink | Slow steady blink | **HDD Sleep mode** |
| Fast rapid blinking | Fast rapid blinking | **RAID 1 Rebuilding** |
| (any) | Red | **Drive Error or missing** |

**Notes:**
• D1 and D2 LEDs are **OFF** when the MiniPro is not connected to a computer
• A **red** D1 or D2 LED while connected indicates a drive failure or missing drive in that bay
• During RAID 1 rebuild, D1/D2 blink approximately 3 times per second`
    },
    {
      id: "minipro_raid_v3_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_minipro_raid_v3"],
      keywords: ["raid v3 warranty", "warranty", "discontinued", "2 year", "repair replacement", "support", "rma"],
      issue: "minipro_raid_v3_warranty",
      response: `**Warranty:**
The MiniPro RAID V3 includes a **2-Year Repair/Replacement Warranty** from the date of purchase. Non-transferable, limited to the original purchaser.

**Discontinuation:**
The MiniPro RAID V3 (CB3R3) has been discontinued.

**If within warranty:** Submit a warranty request and the team will assist with a repair or replacement evaluation.

**If out of warranty:** Our support team can still assist with troubleshooting and recommend current alternatives.

**User Manual:**
https://oyendigital.com/downloads/manuals/minipro-RAID-V3-3Panel.pdf

**Video User Guide:**
TinyURL.com/MiniProV3Video`
    },

    // ===== MOBIUS 2-BAY =====
    {
      id: "mobius_2bay_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2-bay", "3r2-eb3", "mobius raid", "specs", "specifications", "overview", "firewire 800", "esata", "usb 3.0", "3.5 inch raid", "desktop raid", "dimensions", "chipset", "fan"],
      issue: "mobius_2bay_overview",
      response: `The Mobius 2-Bay RAID System is a desktop 2-bay enclosure for 3.5-inch SATA drives, offering FireWire 800, eSATA 6G, and USB 3.0 connectivity. The trayless lever design allows tool-free drive insertion and removal, and a key lock secures the drive bays. An internal power supply means no external adapter to carry. Replaced by the Mobius 2C RAID.

**Interfaces / Ports:**
• USB 3.0 — up to 525 MB/s
• FireWire 800 (IEEE 1394b) — up to 100 MB/s; two FW800 ports for daisy-chaining
• eSATA 6G — up to 525 MB/s

**Drive Support:** 2 × 3.5-inch SATA I/II/III HDD or SSD (RAID-qualified drives recommended — check with manufacturer)

**RAID Modes:** JBOD (default), RAID 0 (Striping), RAID 1 (Mirroring), Combine (Span)

**Chipset:** JMicron
**SATA Interface:** SATA III 6.0 Gbps with UASP

**Power:** Internal power supply — AC 100–240V, 50W (no external adapter required)

**Fan:** Hen Li Xin HD7015S12L, 27.0 dB(A) — quiet active cooling

**Physical:**
• Dimensions: 8.25 × 4.5 × 5.0 inches (L × W × H)
• Weight: 7 lbs
• Trayless drive bays with lever latch and key lock

**Compatible Systems:** Windows XP and above; Mac OS 10.4 or higher

**Certifications:** CE, FCC

**In the Box:** Mobius 2-Bay, USB 3.0 cable, FW800 cable, eSATA cable, power cord, user guide, key set

**Additional Resources:**
• Optional RAID Manager utility for Windows and Mac
• Firmware update for 8TB per bay compatibility (see support resources)

**Replaced by:** Mobius 2C RAID (3R2C)

**Status:** Discontinued`
    },
    {
      id: "mobius_2bay_drive_install",
      title: "Inserting & Removing Drives — Trayless Design",
      category: "Setup",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay insert drive", "remove drive", "trayless", "lever", "drive bay", "open door", "lock drive", "key lock", "install hard drive", "hotswap", "pull lever"],
      issue: "mobius_2bay_drive_install",
      response: `The Mobius 2-Bay uses a trayless lever design — no screwdrivers or drive trays required.

**Inserting a drive:**
1. Gently pull the lever to open the drive bay door
2. Slide the drive into the bay
3. Pull the lever again and push the door all the way closed
4. Release the lever once the door is fully closed

**Removing a drive:**
1. Pull the lever to open the bay door
2. Slide the drive out

**Locking:**
Use the included key to lock the bay door if desired. This prevents accidental or unauthorized drive removal.

**Compatible drives:** 3.5-inch SATA I/II/III HDD or SSD
• Drives should be RAID-qualified when using RAID 0 or RAID 1 — check with your drive manufacturer for RAID compatibility
• Drives must be properly seated for LEDs to illuminate and for the system to recognize them

**Note:** Drive LEDs will be OFF when the Mobius is not connected to a computer.`
    },
    {
      id: "mobius_2bay_raid_modes",
      title: "RAID Modes Explained — JBOD, RAID 0, RAID 1, Combine",
      category: "Overview",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay raid modes", "raid 0", "raid 1", "jbod", "combine span", "striping", "mirroring", "which raid mode", "redundancy", "performance"],
      issue: "mobius_2bay_raid_modes",
      response: `The Mobius 2-Bay supports four hardware RAID modes set via a physical switch on the enclosure. No software required.

**JBOD — Default**
Each drive appears as a separate, independent volume. No performance benefit or redundancy. This is the factory default.

**RAID 0 — Striping (Speed)**
Data is split across both drives simultaneously for dramatically increased performance. Appears as a single volume.
• ⚠️ No redundancy — if one drive fails, all data on both drives is lost
• Total capacity = smallest drive × 2. Example: 500GB + 2TB = 1TB total
• Oyen Digital recommends performing a **low-level format** after setting RAID 0.

**RAID 1 — Mirroring (Redundancy)**
Both drives store identical copies of all data. A complete copy survives if one drive fails.
• Slower writes than RAID 0
• Total capacity = one drive's capacity
• Supports a on the power
4. Continue holding the MODE button for **7–10 seconds**
5. Release the MODE button — the RAID mode is now configured
6. Format the volume before use (see Formatting article)

**Clearing an Existing RAID Mode (required before changing modes):**
1. Set the RAID switch to **JBOD**
2. Connect to computer
3. Press and hold the MODE button while turning on the power
4. Hold for **7–10 seconds**, then release
5. The previous RAID mode is removed; drives are now in JBOD mode

**Important notes:**
• Performing a Clear on RAID 1 or JBOD drives **does not delete existing data**
• Default factory mode is JBOD
• After setting any new RAID mode, format the volume before use`
    },
    {
      id: "mobius_2bay_leds",
      title: "LED Indicators — Status & Drive Health",
      category: "Overview",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay led", "led status", "blue led", "red led", "purple led", "drive error", "blinking led", "power led", "sleep indicator", "rebuild indicator"],
      issue: "mobius_2bay_leds",
      response: `The Mobius 2-Bay has a **blue Power LED** on the front panel, plus individual **Drive LEDs** for each bay.

**Drive LED State Reference:**

| Drive LED | Meaning |
|---|---|
| **Steady blue** | Powered & ready |
| **Blinking blue** (fast) | Read/Write activity |
| **Slow blink** (twice per second) | RAID 1 Rebuilding |
| **Off** | HDD Sleep mode |
| **Steady red or purple** | Drive Error or No Drive installed |

**Key notes:**
• Drive LEDs are **OFF** when the Mobius is not connected to a computer
• A **red or purple** LED while connected indicates a drive failure or missing drive in that bay
• During RAID 1 rebuild, LEDs blink twice per second — rebuild can take several hours`
    },
    {
      id: "mobius_2bay_power",
      title: "Power & Daisy-Chaining",
      category: "Connection",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay power", "internal power supply", "no adapter", "power cord", "daisy chain", "firewire daisy chain", "fw800 daisy chain"],
      issue: "mobius_2bay_power",
      response: `**Internal Power Supply**
The Mobius 2-Bay uses an **internal power supply** (AC 100–240V, 50W) — no external power adapter is needed. Simply connect the included power cord to a standard wall outlet.

**FireWire Daisy-Chaining**
The Mobius 2-Bay has **two FireWire 800 ports**, allowing you to daisy-chain additional FireWire devices. Connect one FW800 port to your computer and use the second port to connect another FireWire device in the chain.

**Interface note:** Only one data interface should be connected at a time (USB, eSATA, or FireWire). Do not connect multiple data cables simultaneously.`
    },
    {
      id: "mobius_2bay_rebuild",
      title: "RAID 1 Drive Failure & Rebuild Procedure",
      category: "Setup",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay rebuild", "drive failure", "red led", "purple led", "replace drive", "raid 1 rebuild", "automatic rebuild", "same capacity", "failed drive"],
      issue: "mobius_2bay_rebuild",
      response: `**Detecting a drive failure:**
If a drive fails, that drive's LED will change from **blue to red** while the Mobius is connected to a computer.

**RAID 1 Automatic Rebuild:**
The Mobius supports automatic rebuild when a failed drive is replaced. The replacement drive must be:
• **New and unformatted**
• **Same capacity** as the original drive (this is required — unlike the MiniPro RAID V2/V3 which does not specify this)

**Rebuild steps:**
1. Power down the Mobius
2. Remove the failed drive (pull the lever, open the bay door)
3. Install the new replacement drive and close the bay
4. Power up the Mobius
5. The drive LEDs will **blink twice per second** — rebuild is in progress
6. Wait for completion — this can take **several hours**

**Notes:**
• Automatic rebuild only works in **RAID 1** mode
• RAID 0 does not support rebuild — a drive failure means complete data loss
• Do not power off during rebuild`
    },
    {
      id: "mobius_2bay_sleep",
      title: "Sleep Mode Behavior",
      category: "Overview",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay sleep", "auto sleep", "sleep mode", "spin down", "power management", "computer sleep"],
      issue: "mobius_2bay_sleep",
      response: `The Mobius 2-Bay does not have an independent auto-sleep timer.

When your computer enters sleep mode, the drives inside the Mobius will **spin down** automatically. When your computer wakes, the Mobius will wake with it.

This behavior is automatic and requires no configuration — it follows your computer's power management settings.`
    },
    {
      id: "mobius_2bay_warranty",
      title: "Warranty & Replacement Info",
      category: "Warranty",
      products: ["legacy_mobius_2bay"],
      keywords: ["mobius 2bay warranty", "warranty", "discontinued", "2 year", "repair replacement", "support", "rma", "replaced by"],
      issue: "mobius_2bay_warranty",
      response: `**Warranty:**
The Mobius 2-Bay includes a **2-Year Repair/Replacement Warranty** from the date of purchase. Non-transferable, limited to the original purchaser.

**Discontinuation:**
The Mobius 2-Bay (3R2-EB3-M) has been discontinued. It was replaced by the **Mobius 2C RAID**.

**Optional RAID software:**

**User Manual:**
https://oyendigital.com/downloads/manuals/Mobius_2Bay.pdf`
    },

    // ===== MOBIUS PRO 2C =====
    {
      id: "mobius_pro_2c_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c", "3r2-2c", "specs", "specifications", "overview", "usb-c raid", "usb 3.1", "2-bay raid", "desktop raid", "hub port", "thunderbolt 3", "dimensions"],
      issue: "mobius_pro_2c_overview",
      response: `The Mobius Pro 2C is a desktop 2-bay enclosure for 3.5-inch SATA drives with two USB-C ports: a MAIN port for host computer connection (USB & Thunderbolt 3 compatible) and a HUB port for daisy-chaining additional USB devices. It features a lever-based trayless drive insertion, key lock, internal 150W PSU, and hardware RAID.

**Interfaces / Ports:**
• **MAIN Port:** USB-C (USB 3.1, 10 Gbps) — compatible with USB and **Thunderbolt 3**
• **HUB Port:** USB-C (USB 3.1, 10 Gbps) — compatible with **USB devices only** (not TB3); provides 15W bus power for connected USB devices

**Drive Support:** 2 × 3.5-inch SATA HDD

**RAID Modes:** JBOD (default), RAID 0 (Striping), RAID 1 (Mirroring), Combine (Span)

**Power:** Internal PSU — AC 100–240V, 50 Hz; Output 150W (no external adapter)

**Operating Environment:** 5°C–40°C; 10%–80% RH

**Physical:** 8.25 × 4.5 × 5.0 inches

**Compatible Systems:** Any USB or Thunderbolt 3 host

**In the Box:** Mobius Pro 2C, USB C-C cable, USB C-A cable, power cable, key

**Warranty:** 3 years (repair/replacement)

**Status:** Discontinued`
    },
    {
      id: "mobius_pro_2c_ports",
      title: "MAIN Port vs HUB Port — What's the Difference?",
      category: "Connection",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c main port", "hub port", "usb-c ports", "which port to use", "main vs hub", "thunderbolt 3 port", "usb only hub", "15w hub power", "connect to computer"],
      issue: "mobius_pro_2c_ports",
      response: `The Mobius Pro 2C has two USB-C ports with different capabilities:

**MAIN Port (connect to your computer)**
• USB-C, USB 3.1 Gen 2 — up to 10 Gbps
• Compatible with USB hosts AND Thunderbolt 3 hosts
• This is always the port you connect to your computer or the upstream device in a chain

**HUB Port (for additional devices)**
• USB-C, USB 3.1 — up to 10 Gbps
• Compatible with **USB devices only** — Thunderbolt 3 devices cannot be connected here
• Provides **15W** of bus power for connected USB drives or devices
• Use this to daisy-chain additional Mobius Pro 2C units or other USB devices

**Quick rule:**
• Computer → MAIN port (TB3 or USB OK)
• Downstream device → HUB port (USB only)`
    },
    {
      id: "mobius_pro_2c_thunderbolt",
      title: "Thunderbolt 3 Compatibility & Daisy-Chaining",
      category: "Compatibility",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c thunderbolt", "thunderbolt 3", "tb3", "thunderbolt 2", "tb2 adapter", "daisy chain", "6 devices", "chain length", "tb3 hub port", "thunderbolt chain"],
      issue: "mobius_pro_2c_thunderbolt",
      response: `**Thunderbolt 3 on MAIN port — Compatible ✓**
Connect the Mobius Pro 2C's MAIN port to a Thunderbolt 3 host. It will operate at USB 3.1 Gen 2 speeds (up to 10 Gbps).

**Thunderbolt 3 on HUB port — Not compatible ✗**
The HUB port supports USB devices only. TB3 devices cannot be connected to the HUB port. To daisy-chain with other TB3 devices:
• Place the Mobius Pro 2C at the **end** of the TB3 chain
• Connect the MAIN port to the upstream Thunderbolt 3 device

**Thunderbolt 2 — Not compatible ✗**
The Mobius Pro 2C is not compatible with Thunderbolt 2 using an adapter of any make or model.

**Daisy-Chaining**
• Up to **6 devices total** can be connected in a chain
• Daisy-chaining works from either a USB or Thunderbolt 3 host
• Each downstream device connects via HUB port → next device's MAIN port`
    },
    {
      id: "mobius_pro_2c_raid_modes",
      title: "RAID Modes Explained — JBOD, RAID 0, RAID 1, Combine",
      category: "Overview",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c raid modes", "raid 0", "raid 1", "jbod", "combine span", "striping", "mirroring", "redundancy", "performance", "capacity calculation"],
      issue: "mobius_pro_2c_raid_modes",
      response: `The Mobius Pro 2C supports four hardware RAID modes set via a physical switch. No software required.

**JBOD — Default**
Two independent drives recognized separately by the OS. No performance benefit or redundancy. Factory default; pre-installed drives formatted exFAT.

**RAID 0 — Striping (Speed)**
Data split across both drives simultaneously for maximum performance. Appears as a single volume.
• ⚠️ No redundancy — if one drive fails, all data on both drives is lost
• Total capacity = smallest drive × 2. Example: 500GB + 2TB = 1TB total

**RAID 1 — Mirroring (Redundancy)**
Both drives store identical copies of all data. Complete copy survives if one drive fails.
• Slower writes than RAID 0
• Total capacity = one drive's capacity
• Supports automatic rebuild — replacement drive must be same capacity as original

**Combine — Span**
Combines both drives into one large volume, filling the first drive before writing to the second.
• No performance increase or redundancy

**Note:** RAID 0, RAID 1, and Combine each appear as a **single volume** to the OS. Only RAID 1 and JBOD drives can be removed and accessed individually in another enclosure.`
    },
    {
      id: "mobius_pro_2c_setup",
      title: "Setting & Changing RAID Modes",
      category: "Setup",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c setup", "set raid", "mode button", "raid switch", "change raid mode", "clear raid", "5-10 seconds", "configure raid", "jbod setup"],
      issue: "mobius_pro_2c_setup",
      response: `RAID mode is set using a physical RAID switch and MODE button. No software required.

**Setting a RAID Mode:**
1. Connect the Mobius to your computer using an included cable; connect the power cable and press the power switch to turn on
2. Set the RAID switch to the desired mode
3. Press and hold the **MODE button for approximately 5–10 seconds**
4. Release the MODE button — RAID is configured and ready for formatting

**Clearing an Existing RAID Mode (required before changing modes):**
1. Set the RAID switch to **JBOD**
2. Connect to computer
3. Press and hold the MODE button for **5–10 seconds**
4. Release — previous RAID mode is removed; drives revert to JBOD

**Key notes:**
• Performing a Clear on RAID 1 or JBOD does **not** delete existing data on those drives
• Default factory mode is JBOD
• After setting any new RAID mode, format the volume before use`
    },
    {
      id: "mobius_pro_2c_drive_install",
      title: "Inserting & Removing Drives",
      category: "Setup",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c insert drive", "remove drive", "trayless", "lever", "drive bay", "install hard drive", "key lock", "seated connector"],
      issue: "mobius_pro_2c_drive_install",
      response: `The Mobius Pro 2C uses a trayless lever design — no screwdrivers or drive trays needed.

**Inserting a drive:**
1. Gently pull the lever to open the bay
2. Slide the drive in and push it all the way in until you feel it seated firmly into the connector
3. Release the lever

**Removing a drive:**
1. Pull the lever to open the bay
2. Slide the drive out

**Locking:**
Use the included key in the Lock Inlet to secure the drives against accidental or unauthorized removal.

**Drive compatibility:** 3.5-inch SATA HDD. Pre-installed drives are formatted as exFAT for Windows and Mac compatibility.`
    },
    {
      id: "mobius_pro_2c_leds",
      title: "LED Indicators — Status & Drive Health",
      category: "Overview",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c led", "led indicator", "white led", "blue led", "red led", "drive error", "blinking led", "d1 d2 led", "power led", "sleep indicator", "rebuild indicator"],
      issue: "mobius_pro_2c_leds",
      response: `The Mobius Pro 2C has a **Power LED** and per-bay **D1/D2 LEDs**.

**LED State Reference:**

| State | Power LED | D1 / D2 LED |
|---|---|---|
| Powered & ready | Solid White | Solid Blue |
| Read/Write activity | Solid White | Fast rapid blinking |
| Drive Error or missing | Solid White | Red |
| HDD Sleep | Solid White | Off |
| RAID 1 Rebuilding | Solid White | Slow steady blink |

**Key notes:**
• D1 and D2 LEDs are **OFF** when the Mobius is not connected to a computer
• A **red** D1 or D2 LED while connected indicates a drive failure or missing drive
• The Power LED remains **solid white** in all states — it is not a status indicator beyond "powered on"`
    },
    {
      id: "mobius_pro_2c_rebuild",
      title: "RAID 1 Drive Failure & Rebuild Procedure",
      category: "Setup",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c rebuild", "drive failure", "red led", "replace drive", "raid 1 rebuild", "automatic rebuild", "rebuild time", "same capacity", "failed drive", "disconnect during rebuild"],
      issue: "mobius_pro_2c_rebuild",
      response: `**Detecting a drive failure:**
If a drive fails, the **D1 or D2 LED turns RED** while the Mobius is connected to a computer.

**Automatic Rebuild (RAID 1 only):**
Replace the failed drive and the Mobius will automatically rebuild. Replacement drive must be the **same capacity** as the original.

**Steps:**
1. Power down the Mobius
2. Remove the failed drive (pull lever, slide out)
3. Install the new replacement drive; push until seated in connector
4. Power up the Mobius with it connected to your computer
5. D1/D2 LEDs will **blink 2–3 times per second** — rebuild in progress
6. You may disconnect from the computer during the rebuild — **this will not interrupt the rebuild**

**Estimating rebuild time:**
**Combined drive size (TB) ÷ 2 = approximate hours**
Example: 20TB RAID 1 (2 × 10TB drives) → 20 ÷ 2 = **~10 hours**
Actual time can vary based on drive model and specs.

**Note:** This rebuild time formula differs from other Oyen RAID products — use this formula specifically for the Mobius Pro 2C.`
    },
    {
      id: "mobius_pro_2c_eject_sleep",
      title: "Safe Ejection & Sleep Mode",
      category: "Overview",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c eject", "safely remove", "sleep mode", "spin down", "data corruption", "drag to trash", "eject hardware", "power management"],
      issue: "mobius_pro_2c_eject_sleep",
      response: `**Safe Ejection**
Always properly eject the Mobius before disconnecting to prevent data corruption.

**Mac:** Close all windows and applications accessing the drive. Drag the drive icon to the Trash/Eject icon to dismount. The activity LED will cycle on/off and the HDD will spin down.

**Windows:** Close all applications accessing the Mobius. Click the "Eject Hardware" (Safely Remove Hardware) icon in the system tray and select the drive. The activity LED will cycle on/off and the drive will spin down.

**Sleep Mode**
The Mobius Pro 2C does not have an independent auto-sleep timer. If there is no HDD activity, the computer may put the Mobius to sleep (LEDs off, HDDs spin down) depending on your computer's energy saver settings. The Mobius will wake automatically when accessed.`
    },
    {
      id: "mobius_pro_2c_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_mobius_pro_2c"],
      keywords: ["mobius pro 2c warranty", "3 year warranty", "discontinued", "repair replacement", "support", "rma"],
      issue: "mobius_pro_2c_warranty",
      response: `**Warranty:**
The Mobius Pro 2C includes a **3-Year Repair/Replacement Warranty** from the date of purchase. Non-transferable, limited to the original purchaser.

**Note:** The Mobius Pro 2C carries a **3-year warranty** — longer than most Oyen Digital enclosures which carry 2-year coverage.

**Discontinuation:**
The Mobius Pro 2C has been discontinued.

**Support contact:** support@oyendigital.com`
    },

    // ===== MOBIUS THUNDERBOLT 2 (5-BAY) =====
    {
      id: "mobius_tb2_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius thunderbolt 2", "mobius tb2", "3n5-t2", "5-bay", "specs", "specifications", "overview", "thunderbolt 2", "20gbps", "no raid", "jbod", "5 drives", "dimensions"],
      issue: "mobius_tb2_overview",
      response: `The Mobius 5-Bay Thunderbolt 2 is a desktop 5-bay enclosure for 2.5" or 3.5" SATA drives. It uses Thunderbolt 2 for up to 20 Gbps transfer speeds. Unlike most Oyen Digital RAID enclosures, this unit has **no hardware RAID controller** — all five drives operate as independent JBOD volumes. Software RAID (e.g. SoftRAID) is compatible if needed.

**Interface / Ports:**
• 2 × Thunderbolt 2 ports — up to 20 Gbps
• Both ports available for daisy-chaining (up to 6 devices total)
• **Thunderbolt cable must be connected** for the unit to power on

**Drive Support:** 2.5" or 3.5" SATA I/II/III HDD or SSD (tray-based installation)

**RAID:** No hardware RAID. All five drives are independent JBOD volumes. Software RAID compatible (e.g. SoftRAID).

**Chipset:** Intel DSL5520, ASMedia ASM1062 (×2), ASM1092

**Fan:** 2000 RPM, 26 dB(A)

**Power Supply:** Input AC 100–240V; Output 150W (external adapter included)

**Operating Environment:** 5°C–40°C; upright position only

**Physical:** 8.5 × 4.6 × 6.8 inches; ~8 lbs

**Compatible Systems:** Windows 8 or higher; Mac OS 10.9 or higher

**Certifications:** CE, FCC

**In the Box:** Mobius 5-Bay, Thunderbolt cable, power supply, screw pack (3.5" & 2.5"), key set, user guide

**Recommended drives:** Enterprise or NAS class — e.g. WD Red, WD SE/RE

**Warranty:** 2 years standard; 3 years if purchased with drives pre-installed by Oyen Digital

**Status:** Discontinued`
    },
    {
      id: "mobius_tb2_no_raid",
      title: "Does the Mobius TB2 Support RAID?",
      category: "Overview",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 raid", "no raid", "hardware raid", "software raid", "softraid", "jbod only", "5 independent drives", "configure raid", "raid controller"],
      issue: "mobius_tb2_no_raid",
      response: `**The Mobius 5-Bay Thunderbolt 2 does not include a hardware RAID controller.**

All five drive bays operate as **independent JBOD volumes** — each drive mounts separately on your computer, like five individual external drives.

**Software RAID is possible:**
The Mobius is compatible with software RAID applications. Oyen Digital references **SoftRAID** as a compatible option. Software RAID is managed by your computer's OS or a RAID application, rather than by dedicated hardware in the enclosure.

This is a fundamental difference from the Oyen Digital MiniPro RAID and Mobius 2-Bay/Pro 2C products, which include hardware RAID controllers with physical RAID switches.

If you need hardware RAID in a multi-bay TB/USB-C enclosure, refer to the Mobius Pro 5C (Thunderbolt 3) or the Mobius 2C RAID product line.`
    },
    {
      id: "mobius_tb2_drive_install",
      title: "Installing Drives — Removable Trays",
      category: "Setup",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 install drive", "drive tray", "removable tray", "insert tray", "remove tray", "mounting screws", "door latch", "door lever", "2.5 inch", "3.5 inch", "sata connector"],
      issue: "mobius_tb2_drive_install",
      response: `The Mobius 5-Bay uses **removable trays** — unlike the Mobius 2-Bay and Pro 2C which use trayless lever systems.

**Installing a drive into a tray:**
1. Remove the tray from the bay (slide door latch A to the left to release door lever B; open lever B before sliding tray out)
2. Place the drive into the tray and slide it onto the SATA connector
3. Attach the drive to the tray using the included mounting screws
   • 3.5-inch mounting holes are on the sides (may vary by drive model)
   • 2.5-inch drives use 3 mounting holes on the bottom

**Reinserting a tray:**
1. Ensure lever B is open
2. Slide the tray back into the bay
3. Close the door lever

**Locking:**
Use the included key to lock the door latch to prevent accidental or unauthorized tray removal.

**Compatible drives:** Any 2.5-inch or 3.5-inch SATA I/II/III HDD or SSD. For best performance, Oyen Digital recommends enterprise or NAS-class drives such as WD Red or WD SE/RE.`
    },
    {
      id: "mobius_tb2_connecting",
      title: "Connecting to a Computer & Daisy-Chaining",
      category: "Connection",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 connect", "thunderbolt 2 connection", "daisy chain", "6 devices", "thunderbolt cable required", "power on", "thunderbolt port", "mini displayport", "older mac"],
      issue: "mobius_tb2_connecting",
      response: `**Connection steps:**
1. Connect the included power adapter to the DC-IN input on the Mobius
2. Connect the Thunderbolt cable to **either** TB2 port on the Mobius
3. Connect the other end of the cable to a Thunderbolt port on your computer
4. (Optional) Connect additional Thunderbolt devices to the second port for daisy-chaining (up to 6 devices total)
5. Turn on the power switch
6. The Mobius powers up and drives will mount on your computer

**⚠️ Important: Thunderbolt cable required to power on**
The Thunderbolt cable must be connected to a Thunderbolt-capable computer port for the Mobius to power up. It will not power on from the power adapter alone.

**Mini DisplayPort ≠ Thunderbolt**
Macs from 2011 and earlier use a Mini DisplayPort connector that physically looks identical to Thunderbolt but **cannot** carry Thunderbolt data. If connecting to an older Mac, verify the port is actually a Thunderbolt port (it will have a lightning bolt icon).

**Daisy-chaining:** Up to 6 total devices can be connected in a Thunderbolt chain.`
    },
    {
      id: "mobius_tb2_power_buttons",
      title: "Per-Bay HDD Power Buttons",
      category: "Overview",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 power button", "hdd power button", "per bay power", "power off drive", "power on drive", "individual drive power", "spin down", "spin up", "3-5 seconds"],
      issue: "mobius_tb2_power_buttons",
      response: `The Mobius 5-Bay Thunderbolt 2 has a dedicated **power button for each of the five drive bays**, allowing individual drives to be powered on or off without turning off the entire unit.

**Power OFF a single drive:**
Press and hold the corresponding bay's button for **3–5 seconds**. The LEDs will turn off and the drive will spin down.

**Power ON a single drive:**
Briefly press the corresponding button — **do not hold**. The drive will spin up and mount.

This is useful for:
• Powering down a drive you're not using to reduce heat and noise
• Remounting a drive that isn't showing up (see Troubleshooting)
• Hot-swapping or working with individual drives independently

**Note:** This feature is unique to the Mobius 5-Bay Thunderbolt 2 among legacy Oyen Digital encloss Thunderbolt link is active`
    },
    {
      id: "mobius_tb2_sleep_eject",
      title: "Sleep Mode & Safely Ejecting Drives",
      category: "Overview",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 sleep", "eject drives", "safely remove", "data corruption", "spin down", "drag to trash", "power management", "eject hardware"],
      issue: "mobius_tb2_sleep_eject",
      response: `**Sleep Mode**
The Mobius has no independent sleep timer. If there is no HDD activity, the computer may put the Mobius to sleep (LEDs off, drives spin down) based on your computer's energy saver settings. The Mobius wakes automatically when accessed.

**Ejecting Drives Safely**
Always eject before disconnecting to prevent data corruption.

**Mac:** Close all windows and applications accessing the drive. Drag the drive icon to the Trash/Eject icon. The activity LED will cycle on/off and the HDD will spin down.

**Windows:** Close all applications accessing the Mobius. Click "Eject Hardware" (Safely Remove Hardware) in the system tray and select the drive. The activity LED will cycle on/off and the drive will spin down.`
    },
    {
      id: "mobius_tb2_troubleshooting",
      title: "Troubleshooting — Drive Not Showing Up, Won't Power On",
      category: "Troubleshooting",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 troubleshooting", "drive not showing", "not mounting", "won't power on", "no power", "disk utility", "thunderbolt cable", "mini displayport", "remount drive", "power button"],
      issue: "mobius_tb2_troubleshooting",
      response: `**Unit won't power on:**
The Thunderbolt cable must be connected to a Thunderbolt-capable port for the Mobius to power up. Check:
• Is the Thunderbolt cable connected to the Mobius AND to the computer?
• Is the computer's port actually Thunderbolt? Macs from 2011 and earlier use Mini DisplayPort, which looks identical but cannot carry Thunderbolt signals. Look for a lightning bolt (⚡) icon next to the port.

**Hard drive not showing up:**
1. Briefly press (do not hold) the HDD power button for the corresponding bay to remount the drive
2. If still not mounting: disconnect all other Thunderbolt devices and connect the Mobius directly to a Thunderbolt port on the computer
3. Open Disk Utility (Mac: Applications > Utilities > Disk Utility) to see if the drive is listed — if it is, it may need formatting
4. If the drive doesn't appear in Disk Utility at all, the drive itself may be faulty

**For software RAID questions:**
The Mobius has no hardware RAID. For RAID configuration, use a compatible software application such as SoftRAID.`
    },
    {
      id: "mobius_tb2_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_mobius_tb2"],
      keywords: ["mobius tb2 warranty", "2 year", "3 year", "pre-installed drives warranty", "discontinued", "repair replacement", "rma"],
      issue: "mobius_tb2_warranty",
      response: `**Warranty:**
• **2-Year Repair/Replacement Warranty** for enclosure-only purchases
• **3-Year Warranty** if the Mobius was purchased with hard drives pre-installed by Oyen Digital

Non-transferable, limited to the original purchaser.

**Discontinuation:**
The Mobius 5-Bay Thunderbolt 2 (SKU: 3N5-T2-M) has been discontinued. No named replacement was specified on the product page.

**User Manual:**
https://oyendigital.com/downloads/manuals/Mobius_TB2_6panel.pdf`
    },

    // ===== MOBIUS PRO 5C =====
    {
      id: "mobius_pro_5c_overview",
      title: "Product Overview & Specifications",
      category: "Overview",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c", "5-bay", "usb-c", "10gbps", "thunderbolt 3", "thunderbolt 4", "specs", "specifications", "overview", "5 drive bays", "jbod", "no raid", "dimensions", "hub port"],
      issue: "mobius_pro_5c_overview",
      response: `The Mobius Pro 5C is a desktop 5-bay enclosure for 3.5-inch SATA drives (or Legent card readers) with two USB-C ports: a MAIN port for host connection (USB & Thunderbolt 3/4 compatible) and a HUB port for daisy-chaining additional USB devices. It uses a lever-based trayless design and has no hardware RAID — all five bays operate as independent JBOD volumes (software RAID is supported).

**Interfaces / Ports:**
• **MAIN Port:** USB-C (USB 3.2 Gen 2, 10 Gbps) — compatible with USB and **Thunderbolt 3 / 4**
• **HUB Port:** USB-C (USB 3.2 Gen 1, **5 Gbps**) — compatible with **USB devices only** (not TB3/4); provides 15W bus power

**Drive Support:** 3.5-inch SATA HDD or Legent card reader

**RAID:** No hardware RAID. All five bays are independent JBOD volumes. Software RAID compatible (Disk Utility, Storage Spaces, SoftRAID).

**Power:** Internal — AC 100–240V, 50-60Hz; Output 150W

**Operating Environment:** 5°C–70°C; 10%–80% RH

**Physical:** 10.5 × 5.0 × 7.25 inches

**Compatible Systems:** Any USB or Thunderbolt 3/4 host

**In the Box:** Mobius Pro 5C, USB C-C cable, USB C-A cable, power cable, key

**Warranty:** 1 year (repair/replacement)

**Status:** Discontinued

**Note:** The HUB port on the Pro 5C runs at **5 Gbps** (USB 3.2 Gen 1), which is half the speed of the MAIN port and slower than the HUB port on the Mobius Pro 2C (which is 10 Gbps).`
    },
    {
      id: "mobius_pro_5c_ports",
      title: "MAIN Port vs HUB Port — Speed & Compatibility Differences",
      category: "Connection",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c main port", "hub port", "5gbps hub", "10gbps main", "usb-c ports", "which port", "thunderbolt 3 port", "usb only hub", "15w hub power", "connect computer"],
      issue: "mobius_pro_5c_ports",
      response: `The Mobius Pro 5C has two USB-C ports with different speeds and capabilities:

**MAIN Port (connect to your computer)**
• USB-C, USB 3.2 Gen 2 — up to **10 Gbps**
• Compatible with USB hosts AND Thunderbolt 3/4 hosts
• Always use this port for the upstream connection to your computer

**HUB Port (for additional devices)**
• USB-C, USB 3.2 Gen 1 — up to **5 Gbps**
• Compatible with **USB devices only** — Thunderbolt 3/4 devices cannot be connected here
• Provides **15W** of bus power for connected USB drives or devices
• Use for daisy-chaining additional Mobius Pro 5C units or other USB devices

**Key difference from Mobius Pro 2C:**
The Pro 5C's HUB port runs at 5 Gbps (Gen 1), not 10 Gbps (Gen 2). If you chain a high-speed USB device from the HUB port, it will be limited to 5 Gbps.

**Quick rule:**
• Computer → MAIN port (TB3/4 or USB OK)
• Downstream devices → HUB port (USB only, 5 Gbps max)`
    },
    {
      id: "mobius_pro_5c_thunderbolt",
      title: "Thunderbolt 3/4 Compatibility & Daisy-Chaining",
      category: "Compatibility",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c thunderbolt", "thunderbolt 3", "thunderbolt 4", "tb3", "tb4", "thunderbolt 2", "tb2 adapter", "daisy chain", "6 devices", "hub port tb3", "chain"],
      issue: "mobius_pro_5c_thunderbolt",
      response: `**Thunderbolt 3 / 4 on MAIN port — Compatible ✓**
Connect the Mobius Pro 5C's MAIN port to a Thunderbolt 3 or Thunderbolt 4 host. It will operate at USB 3.2 Gen 2 speeds (up to 10 Gbps).

**Thunderbolt 3/4 on HUB port — Not compatible ✗**
The HUB port supports USB devices only. To daisy-chain with other TB3/4 devices:
• Place the Mobius Pro 5C at the **end** of the Thunderbolt chain
• Connect the MAIN port to the upstream Thunderbolt device
• Additional USB devices can then connect to the HUB port

**Thunderbolt 2 — Not compatible ✗**
The Mobius Pro 5C is not compatible with Thunderbolt 2 using an adapter of any make or model.

**Daisy-chaining works from USB or TB3/4:**
Up to **6 devices total** can be connected in a chain. A Thunderbolt 3/4 host is not required for daisy-chaining — it also works from a USB host.`
    },
    {
      id: "mobius_pro_5c_no_raid",
      title: "Does the Mobius Pro 5C Support RAID?",
      category: "Overview",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c raid", "no hardware raid", "software raid", "softraid", "disk utility", "storage spaces", "jbod", "5 independent drives", "configure raid"],
      issue: "mobius_pro_5c_no_raid",
      response: `**The Mobius Pro 5C does not include a hardware RAID controller.**

All five drive bays operate as **independent JBOD volumes** — each drive mounts separately on your computer.

**Software RAID is supported** using any of these applications:
• **Mac:** Disk Utility (built-in, free)
• **Windows 10+:** Storage Spaces (built-in, free)
• **Cross-platform:** SoftRAID (third-party, paid)

Software RAID is managed by the OS or application rather than dedicated hardware in the enclosure.

**SoftRAID bundle:**
If you purchased the Mobius Pro 5C with SoftRAID pre-included, do not use standard OS formatting tools for drive setup. Instead, use SoftRAID to initialize and create the volume. Video instructions: https://tinyurl.com/setup-softraid

This is shared with the Mobius 5-Bay Thunderbolt 2 in having no hardware RAID. If you need hardware RAID in a multi-bay enclosure, refer to the Mobius 2C RAID (current product).`
    },
    {
      id: "mobius_pro_5c_drive_install",
      title: "Inserting & Removing Drives (Trayless Lever Design)",
      category: "Setup",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c insert drive", "remove drive", "trayless", "lever", "drive bay", "install hard drive", "key lock", "3.5 inch", "legent card reader", "seated connector"],
      issue: "mobius_pro_5c_drive_install",
      response: `The Mobius Pro 5C uses a **trayless lever design** — no screwdrivers or drive trays are needed.

**Inserting a drive:**
1. Gently pull the lever to open the bay
2. Slide the drive in and push it all the way into the bay until you feel it seated firmly into the connector
3. Release the lever

**Removing a drive:**
1. Pull the lever to open the bay
2. Slide the drive out

**Compatible drives:** 3.5-inch SATA HDD. The Mobius Pro 5C also supports **Legent card readers** in any drive bay — useful for media professionals who need to read cards from a desktop enclosure.

**Key lock:**
Use the included key to lock the door if desired, preventing accidental or unauthorized drive removal.`
    },
    {
      id: "mobius_pro_5c_leds",
      title: "LED Indicators — Drive Status",
      category: "Overview",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c led", "d1 d2 d3 d4 d5 led", "blue led", "solid blue", "blinking blue", "empty bay led", "sleep led", "activity led", "drive status"],
      issue: "mobius_pro_5c_leds",
      response: `The Mobius Pro 5C has individual **D1–D5 LEDs** for each of the five drive bays.

**D1–D5 LED States:**

| State | LED |
|---|---|
| Empty bay | Off |
| Drive installed, powered & ready | Solid Blue |
| Read/Write activity | Blinking Blue |
| Sleep / Ejected in OS | Off |

**Key notes:**
• All LEDs are **OFF** when the unit is not connected to a computer
• An empty bay and a sleeping/ejected drive look the same (both off) — use OS disk management to distinguish
• There is no error/red LED indicator on the Pro 5C — drive health monitoring requires OS-level tools or SoftRAID

**Comparison:** Unlike the Mobius Pro 2C which has a white Power LED plus blue/red D1-D2 per-bay LEDs, the Pro 5C uses blue-only per-bay LEDs with no separate power LED state indicated.`
    },
    {
      id: "mobius_pro_5c_sleep_eject",
      title: "Sleep Mode & Safely Ejecting Drives",
      category: "Overview",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c sleep", "eject drives", "safely remove", "data corruption", "spin down", "drag to trash", "power management"],
      issue: "mobius_pro_5c_sleep_eject",
      response: `**Sleep Mode**
The Mobius Pro 5C has no independent sleep timer. If there is no HDD activity, the computer may put it to sleep (LEDs off, drives spin down) based on your computer's energy saver settings. The Mobius wakes automatically when accessed.

**Safe Ejection**
Always eject before disconnecting to prevent data corruption.

**Mac:** Close all windows and applications accessing the drive. Drag the drive icon to the Trash/Eject icon. The activity LED will cycle on/off and the HDD will spin down.

**Windows:** Close all applications accessing the Mobius. Click "Eject Hardware" (Safely Remove Hardware) in the system tray and select the drive. The activity LED will cycle on/off and the drive will spin down.`
    },
    {
      id: "mobius_pro_5c_warranty",
      title: "Warranty & Discontinuation Info",
      category: "Warranty",
      products: ["legacy_mobius_pro_5c"],
      keywords: ["mobius pro 5c warranty", "1 year warranty", "one year", "discontinued", "repair replacement", "rma", "support"],
      issue: "mobius_pro_5c_warranty",
      response: `**Warranty:**
The Mobius Pro 5C includes a **1-Year Repair/Replacement Warranty** from the date of purchase. Non-transferable, limited to the original purchaser.

**⚠️ Note:** The Mobius Pro 5C carries only a **1-year warranty** — the shortest warranty of any Oyen Digital legacy product. For comparison:
• Mobius Pro 2C — 3 years
• Mobius 5-Bay Thunderbolt 2 — 2 years (3 with pre-installed drives)
• Most MiniPro RAID products — 2 years

**Discontinuation:**
The Mobius Pro 5C has been discontinued.

**Support contact:** support@oyendigital.com`
    },

    // ===== PS5 INTERNAL SSD UPGRADE =====
    {
      id: "ps5_upgrade_overview",
      title: "Product Overview — Dash Pro PS5 Internal SSD",
      category: "Overview",
      products: ["legacy_ps5_upgrade"],
      keywords: ["ps5 ssd", "ps5 upgrade", "ps5 internal ssd", "dash pro ps5", "ps5-2280", "m.2 nvme", "pcie gen 4", "heatsink", "tlc nand", "4tb ps5", "8tb ps5", "playstation 5 storage", "sony ps5 m.2"],
      issue: "ps5_upgrade_overview",
      response: `The Oyen Digital Dash Pro PS5 SSD is an NVMe M.2 internal storage upgrade for the Sony PlayStation 5 console. It fits the PS5's M.2 expansion slot and includes a factory-installed CNC aluminum heatsink with thermal compound — required by Sony for PS5 M.2 installation.

**Key Specifications:**
• **Interface:** PCIe Gen 4 NVMe
• **Form Factor:** M.2 2280
• **NAND Type:** TLC (Triple-Level Cell) Flash
• **Capacities:** 4TB and 8TB
• **Heatsink:** Factory-installed CNC aluminum with quality thermal compound
• **Warranty:** 3 years

**What this product does:**
Expands the PS5's internal game storage beyond the built-in 825GB drive. Games stored on this SSD load and perform at full PS5 speed.

**Status:** Out of stock / discontinued

**Note:** The specs field on the product page was unpopulated. Performance figures (exact MB/s read/write) are not available from archived sources. Oyen Digital stated read/write speed exceeds Sony's performance requirement for PS5 M.2 SSDs.`
    },
    {
      id: "ps5_upgrade_install",
      title: "How to Install the SSD in Your PS5",
      category: "Setup",
      products: ["legacy_ps5_upgrade"],
      keywords: ["ps5 ssd install", "install m.2 ps5", "ps5 m.2 slot", "how to install", "ps5 ssd installation guide", "heatsink required", "ps5 expansion slot", "video tutorial"],
      issue: "ps5_upgrade_install",
      response: `Installation requires opening the PS5 console and inserting the M.2 SSD into Sony's built-in expansion slot. The Oyen Digital Dash Pro ships with the heatsink pre-installed, so no assembly of the heatsink is needed before installation.

**Official installation resources (provided by Oyen Digital):**

📄 **Written instructions:** https://tinyurl.com/PS5MEM

🎬 **Video tutorial:** https://youtu.be/b1vF42QfmTk

**General process (consult Sony's PS5 guide for exact steps):**
1. Power down the PS5 completely and unplug from power
2. Remove the PS5 side panel to access the M.2 expansion slot
3. Remove the M.2 slot cover screw/spacer for the 2280 form factor position
4. Insert the Dash Pro SSD at an angle into the M.2 slot, then press down and secure with the standoff screw
5. Reassemble the PS5
6. On first boot with the new SSD, the PS5 will prompt you to format it — follow on-screen instructions

**Important:** The PS5 requires that any M.2 SSD installed in its expansion slot be covered with a heatsink. The Dash Pro ships with one pre-installed, so this requirement is already met.`
    },
    {
      id: "ps5_upgrade_heatsink",
      title: "About the Factory-Installed Heatsink",
      category: "Overview",
      products: ["legacy_ps5_upgrade"],
      keywords: ["ps5 heatsink", "factory installed heatsink", "thermal compound", "aluminum heatsink", "cnc heatsink", "heatsink required ps5", "heat dissipation ps5"],
      issue: "ps5_upgrade_heatsink",
      response: `**The Dash Pro PS5 SSD ships with a heatsink already installed** — no user assembly required.

**Heatsink specs:**
• Material: CNC machined high-grade aluminum
• Thermal interface: Quality thermal compound applied at the factory
• Purpose: Efficient heat transfer from the NVMe SSD during sustained PS5 use

**Why a heatsink is required:**
Sony's official PS5 M.2 expansion slot guidelines require that any installed SSD be covered by a heatsink to ensure proper thermal management inside the console. Some third-party SSDs are sold without heatsinks, requiring the user to source and attach one separately before installation.

The Dash Pro eliminates this step — the heatsink is CNC machined aluminum with thermal compound already applied, ready to install directly.`
    },
    {
      id: "ps5_upgrade_compatibility",
      title: "PS5 Compatibility — Which Consoles & Requirements",
      category: "Compatibility",
      products: ["legacy_ps5_upgrade"],
      keywords: ["ps5 compatibility", "playstation 5 compatible", "ps5 model", "pcie gen 4 requirement", "ps5 digital edition", "m.2 2280 ps5", "sony requirement", "ps5 ssd requirement"],
      issue: "ps5_upgrade_compatibility",
      response: `**Compatible with:** Sony PlayStation 5 (all models — disc edition and Digital Edition) that have the M.2 expansion slot.

**Requirements met by the Dash Pro:**
• **Interface:** PCIe Gen 4 NVMe — Sony specifies PCIe Gen 4 for full performance (Gen 3 is technically supported but runs at reduced speed)
• **Form factor:** M.2 2280 — fits the PS5's 2280 standoff position
• **Heatsink:** Factory-installed — Sony requires M.2 SSDs to have a heatsink; this is pre-installed
• **Performance:** Oyen Digital states read/write speeds exceed Sony's minimum performance requirements for PS5

**Not compatible with:**
• PS4 or PS4 Pro (different storage architecture — no M.2 slot)
• PS5 as an external USB drive (this is an internal M.2 upgrade, not an external drive)

**Note:** This SSD can also be used in PCs and laptops with PCIe Gen 4 M.2 2280 slots, though the product was marketed specifically for PS5 use.`
    },
    {
      id: "ps5_upgrade_warranty",
      title: "Warranty & Availability",
      category: "Warranty",
      products: ["legacy_ps5_upgrade"],
      keywords: ["ps5 ssd warranty", "3 year warranty", "out of stock", "discontinued", "ps5 upgrade warranty", "repair replacement"],
      issue: "ps5_upgrade_warranty",
      response: `**Warranty:**
The Dash Pro PS5 Internal SSD includes a **3-Year Warranty** provided by Oyen Digital. Non-transferable, limited to the original purchaser.

**Availability:**
The Dash Pro PS5 SSD (SKU: PS5-2280) is currently out of stock / discontinued. No named replacement was listed.

**Support contact:** support@oyendigital.com`
    },

    // ===== MINIPRO FOR NINTENDO WII U =====
    {
      id: "wii_u_overview",
      title: "Product Overview — MiniPro for Nintendo Wii U",
      category: "Overview",
      products: ["legacy_wii_u"],
      keywords: ["minipro wii u", "wii u external drive", "wii u hard drive", "nintendo wii u storage", "wii u usb drive", "oyen digital wii u", "wii u external storage expand"],
      issue: "wii_u_overview",
      response: `The Oyen Digital MiniPro for Nintendo Wii U is a 2.5-inch portable hard drive enclosure bundled and pre-configured for use with the Nintendo Wii U console. It is based on the MiniPro eSATA/USB enclosure, featuring a USB-C data/power port and an eSATA port.

**Important:** When used with the Wii U, only the USB connection is used. The eSATA port is not used.

**Key characteristics:**
• Connects to the Wii U via USB (using a USB-C to dual USB-A cable)
• Bus-powered from the Wii U's two USB ports, or from an optional AC power adapter
• Formatted by the Wii U on first use — **after formatting, the drive cannot be used with a PC or Mac**
• Stores additional Wii U games, downloadable content, and save data

**Status:** Discontinued`
    },
    {
      id: "wii_u_setup",
      title: "Setting Up the MiniPro with Your Wii U (Step-by-Step)",
      category: "Setup",
      products: ["legacy_wii_u"],
      keywords: ["wii u setup", "minipro wii u setup", "connect wii u drive", "wii u format usb", "blue icon wii u", "wii u usb storage setup", "format wii u hard drive"],
      issue: "wii_u_setup",
      response: `**Step-by-step setup:**

1. **Turn off the Wii U** before connecting the drive

2. **Connect the cable** to the USB-C port on the MiniPro. Connect the other end into **both USB ports** on the Wii U (the included cable has a dual USB-A connector to supply sufficient bus power)
   - If using the optional AC power adapter instead, connect it to the MiniPro's power input — in that case, only one USB port on the Wii U is needed
   - **Note:** The eSATA port on the MiniPro is not used with the Wii U

3. **Turn on the MiniPro**, then **turn on the Wii U**. After a short wait, the Wii U will prompt you to format the USB device

4. **Select "Format"** when prompted
   - ⚠️ **After formatting for the Wii U, the drive cannot be used with a PC or Mac**

5. Formatting completes and you are returned to the Wii U Menu. **A blue icon in the lower-left corner** of the menu confirms the drive is set up and ready for use

**More information:** Nintendo's official external storage guide:
https://en-americas-support.nintendo.com/app/answers/detail/a_id/1585`
    },
    {
      id: "wii_u_power",
      title: "Power Options — Dual USB vs. AC Adapter",
      category: "Setup",
      products: ["legacy_wii_u"],
      keywords: ["wii u drive power", "dual usb cable", "ac adapter wii u", "y cable wii u", "both usb ports wii u", "minipro power wii u"],
      issue: "wii_u_power",
      response: `The MiniPro for Wii U can be powered two ways:

**Option 1 — Dual USB bus power (default)**
Connect the included cable's USB-C end to the MiniPro and plug **both** USB-A connectors into the Wii U's USB ports. Both ports together supply enough power for the drive.

**Option 2 — AC power adapter**
Connect the optional AC power adapter to the MiniPro's power input. In this mode, only **one** USB port on the Wii U is needed (for data only).

**Which to use:**
The dual-USB cable is the simplest setup and requires no additional accessories. The AC adapter is useful if you want to keep one Wii U USB port free for another device, or if you experience any power-related issues with bus power alone.

**Note:** The eSATA port on the MiniPro is not used with the Wii U — do not connect it.`
    },
    {
      id: "wii_u_formatting",
      title: "Formatting & PC/Mac Compatibility After Wii U Setup",
      category: "Setup",
      products: ["legacy_wii_u"],
      keywords: ["wii u format drive", "wii u usb format", "cannot use with pc", "wii u drive pc compatible", "reformat wii u drive", "wii u proprietary format"],
      issue: "wii_u_formatting",
      response: `**The Wii U formats the drive in its own proprietary format.** Once formatted for the Wii U, the drive cannot be read by a PC or Mac without reformatting — and reformatting would erase all Wii U game data.

**What happens during setup:**
On first connection, the Wii U detects the unformatted drive and prompts you to format it. Selecting "Format" converts the drive to Wii U's format. This is a one-way operation — the drive becomes dedicated to the Wii U.

**Can I reuse the drive with a PC later?**
Yes, but only by reformatting it (NTFS, exFAT, etc.), which will erase all Wii U content. The physical drive and enclosure are standard hardware — only the data format is Wii U-specific.

**Confirmation the drive is ready:**
After formatting, a blue icon in the lower-left corner of the Wii U home menu confirms the drive is active and in use.`
    },

    // ===== U32 SHADOW FOR XBOX ONE =====
    {
      id: "xbox_overview",
      title: "Product Overview — U32 Shadow for Xbox One",
      category: "Overview",
      products: ["legacy_xbox"],
      keywords: ["u32 shadow xbox", "xbox one external ssd", "xbox one external drive", "u32 shadow specs", "usb-c xbox", "4tb xbox ssd", "xbox storage expand", "u32-c-ss-4t-xb"],
      issue: "xbox_overview",
      response: `The U32 Shadow for Xbox One is a portable USB-C external SSD designed for Xbox One users who want faster game load times than a conventional hard drive can provide. The SSD uses 3D NAND Flash memory and an aluminum housing for heat dissipation and durability.

**Key Specifications:**
• **Interface:** USB-C (up to 575 MB/s)
• **Memory:** 3D NAND Flash SSD
• **Capacity:** 4TB
• **Shock resistance:** 1500G operating shock
• **Dimensions:** 4.9 × 2.9 × 0.48 inches
• **Weight:** 8 oz.
• **Compatible with:** Xbox One, Xbox One S, Xbox One X
• **Certifications:** CE, FCC
• **Warranty:** 3 years

**Performance benefit:**
Oyen Digital states the SSD delivers load times up to 60% faster than a conventional hard drive for the Xbox One, with speeds over 400 MB/s sustained. The maximum rated speed is 575 MB/s via USB-C.

**Status:** Discontinued`
    },
    {
      id: "xbox_connecting",
      title: "Connecting the U32 Shadow to Xbox One",
      category: "Setup",
      products: ["legacy_xbox"],
      keywords: ["xbox one connect external drive", "u32 shadow connect xbox", "plug in xbox drive", "xbox usb port", "recognized xbox", "external storage xbox one setup"],
      issue: "xbox_connecting",
      response: `Connecting the U32 Shadow to an Xbox One is straightforward — no formatting or setup wizard is required on the drive itself.

**Steps:**
1. Connect the U32 Shadow to a USB port on your Xbox One console
2. The Xbox One will recognize the external drive automatically and make it ready for use

The Xbox One will format the drive for its use on first connection if it hasn't been used with an Xbox One before. Follow any on-screen prompts.

**Note:** The U32 Shadow uses a USB-C connector. Use the included USB-C cable, or a USB-C to USB-A cable if connecting to the Xbox One's standard USB-A ports.`
    },
    {
      id: "xbox_managing_storage",
      title: "Managing Games & Setting Default Download Location",
      category: "Setup",
      products: ["legacy_xbox"],
      keywords: ["xbox one manage storage", "move games xbox", "copy games xbox", "default download location xbox", "install here by default", "xbox storage settings", "view contents xbox"],
      issue: "xbox_managing_storage",
      response: `**Viewing and managing content on the drive:**
1. Go to **Settings > System > Storage**
2. Select the storage device and choose **View Contents**
3. Highlight a game or app and press the **Menu button (≡)** on your controller
4. Select **Manage Game** to move or copy content between drives

**Setting the U32 Shadow as the default download location:**
1. Go to **Settings > System > Storage**
2. Select the external drive
3. Choose **"Install Here by Default"**

Once set, all future game installs and downloads will go to the U32 Shadow automatically instead of the Xbox's internal drive.`
    },
    {
      id: "xbox_troubleshooting",
      title: "Troubleshooting — Drive Not Recognized or Disconnecting",
      category: "Troubleshooting",
      products: ["legacy_xbox"],
      keywords: ["xbox one drive not recognized", "u32 shadow not working xbox", "xbox external drive disconnects", "xbox storage troubleshoot", "power options xbox storage", "xbox system update storage"],
      issue: "xbox_troubleshooting",
      response: `If the U32 Shadow is not being recognized by the Xbox One or is behaving unexpectedly, try the following steps in order:

1. **Try a different USB port** on the Xbox One — some USB ports may have power or compatibility differences

2. **Power cycle the Xbox** — turn off the console and disconnect the power cable for one full minute, then reconnect and try again

3. **Disable the storage power-off setting** — this is a common cause of drives appearing to disconnect or not wake properly:
   Settings > Power & Startup > Power Options > **Uncheck** "When Xbox is off, turn off storage"

4. **Update the Xbox One system software** — verify the console has the most recent system update installed

5. **Verify Xbox Live account login** — ensure the Xbox One is signed in to your Xbox Live account, as some storage features require it

If issues persist after these steps, contact Oyen Digital support at support@oyendigital.com`
    },
    // ===== U35 BOLT+ USER MANUAL =====
    {
      id: "u35_overview",
      title: "U35 Bolt+ — Product Overview & Specifications",
      category: "Overview",
      products: ["U35 Bolt+", "User Guides"],
      keywords: ["u35 bolt+ specs", "u35 bolt+ overview", "u35 bolt+ specifications", "u35 bolt plus specs", "u35 bolt plus overview", "u35 dimensions", "u35 weight", "u35 bolt interface", "u35 pcie gen 5", "u35 tlc nand", "u35 bolt manual"],
      issue: "u35_overview",
      response: `**U35 Bolt+ — Product Overview**

The U35 Bolt+ is a high-performance portable USB4 SSD featuring a PCIe Gen 5 x4 NVMe controller inside an aluminum core with silicone rubber sleeve for heat management and drop protection.

**Interface & Performance:**
- **Port:** USB Type-C (USB4 80Gbps)
- **PCIe Technology:** Gen 5.0 x4

| Host Connection | Max Speed |
|---|---|
| USB4 80G / Thunderbolt 5 | up to 6000 MB/s |
| USB4 / Thunderbolt 4 | up to 3800 MB/s |
| Thunderbolt 3 (Apple Silicon Mac) | up to 2800 MB/s |
| Thunderbolt 3 (Intel Mac) | up to 1000 MB/s |

**Specifications:**
- **Internal Storage:** Triple Level Cell (TLC) NAND Flash
- **Housing:** Aluminum Core & Silicone Inlay (sleeve)
- **Dimensions:** 4.5 × 2.7 × 0.85 inches (with sleeve)
- **Operating Temperature:** 32°F ~ 180°F

**Compatible Platforms:**
- Mac OS 11 or higher
- Windows, Android, Chrome, Linux

**In the Box:** U35 Bolt+, USB-C (USB4 80Gbps) cable, silicone sleeve

**Warranty:** 3 Years (see Warranty entry for details)
**Support:** info@oyendigital.com`
    },
    {
      id: "u35_connecting",
      title: "U35 Bolt+ — Connecting to Your Computer",
      category: "Setup",
      products: ["U35 Bolt+", "User Guides"],
      keywords: ["u35 bolt+ connect", "u35 bolt+ setup", "u35 bolt+ cable", "u35 plug in", "u35 usb-c port", "u35 thunderbolt connect", "u35 bolt plus connect", "how to connect u35"],
      issue: "u35_connecting",
      response: `**Connecting the U35 Bolt+**

1. Connect the **included USB-C cable** to the USB-C port on the U35 Bolt+
2. Connect the other end to a **USB-C or Thunderbolt port** on your host computer
3. The drive will appear on your desktop (Mac) or in File Explorer (Windows) and is ready to use

**Performance Note:**
Speed depends on the capability of your host port. For maximum performance, use a **Thunderbolt 5** or **USB4 80Gbps** port with the included cable (or a certified Thunderbolt 5 cable).

See the Specifications entry for a full breakdown of speeds by port type.

**Important — USB 3.0 Type-A ports:**
The U35 Bolt+ will **not receive enough power** from a USB 3.0 Type-A port to operate effectively. Only connect to **USB-C host ports** (USB 3.2, USB4, or Thunderbolt).

**Thunderbolt compatibility:**
The U35 Bolt+ is compatible with **Thunderbolt 3, 4, and 5** ports using the included cable. It is **not compatible** with legacy Thunderbolt 1 or 2 found on 2015 and earlier Mac computers.`
    },
    {
      id: "u35_backup_software",
      title: "U35 Bolt+ — Recommended Backup Software",
      category: "Software",
      products: ["U35 Bolt+", "User Guides"],
      keywords: ["u35 bolt+ backup", "u35 backup software", "u35 time machine", "u35 carbon copy cloner", "u35 windows backup", "u35 bolt plus backup", "backup u35"],
      issue: "u35_backup_software",
      response: `**U35 Bolt+ — Recommended Backup Software**

The U35 Bolt+ does not include pre-installed backup software. Oyen Digital recommends the following apps:

**Mac:**
- **Time Machine** — Built into macOS: https://support.apple.com/en-us/104984
- **Carbon Copy Cloner** — Third-party bootable backup: www.bombich.com

**Windows:**
- **Windows Backup** — Built into Windows: https://bit.ly/3AaGx8e

All three options support full or scheduled backups to an external drive.`
    },
    {
      id: "u35_ejecting",
      title: "U35 Bolt+ — How to Safely Eject",
      category: "Setup",
      products: ["U35 Bolt+", "User Guides"],
      keywords: ["u35 eject", "u35 bolt+ eject", "safely remove u35", "unmount u35", "disconnect u35", "eject u35 mac", "eject u35 windows"],
      issue: "u35_ejecting",
      response: `**How to Safely Eject the U35 Bolt+**

Always eject the drive before physically disconnecting it to prevent data corruption.

**Mac:**
1. Close all applications that are accessing the drive
2. Drag the drive icon to the **Trash/Eject** icon in the Dock
3. Once the disk icon disappears from the desktop, you may safely disconnect the drive

**Windows:**
1. Close all applications that are accessing the drive
2. Click the **"Eject Hardware"** (Safely Remove Hardware) icon in the system tray
3. Highlight the drive and wait a few seconds until the system prompts **"You may safely remove this device"**

⚠️ Never disconnect the drive during active file transfers.`
    },
    {
      id: "u35_warranty",
      title: "U35 Bolt+ — Warranty Information",
      category: "Warranty",
      products: ["U35 Bolt+", "User Guides"],
      keywords: ["u35 bolt+ warranty", "u35 warranty", "u35 bolt plus warranty", "u35 3 year warranty", "u35 rma", "u35 repair replacement", "u35 warranty service"],
      issue: "u35_warranty",
      response: `**U35 Bolt+ — Warranty**

The U35 Bolt+ includes a **3-Year repair/replacement warranty** provided by Oyen Digital.

- **Non-transferable** — limited to the original purchaser
- **Full warranty policy:**
- **Technical support:** info@oyendigital.com`
    },
    {
      id: "u35_thunderbolt_compat",
      title: "U35 Bolt+ — Thunderbolt & USB-C Port Compatibility",
      category: "Connectivity",
      products: ["U35 Bolt+", "User Guides"],
      keywords: ["u35 thunderbolt compatible", "u35 thunderbolt 3", "u35 thunderbolt 4", "u35 thunderbolt 5", "u35 usb-a compatible", "u35 usb 3.0 type-a", "u35 old mac thunderbolt", "u35 2015 mac", "u35 tb1 tb2", "u35 bolt plus thunderbolt"],
      issue: "u35_thunderbolt_compat",
      response: `**U35 Bolt+ — Port Compatibility**

**Thunderbolt:**
- ✅ **Thunderbolt 3, 4, 5** — fully compatible using the included cable
- ❌ **Thunderbolt 1 or 2** — not compatible (found on 2015 and earlier Mac computers)

**USB-C (USB4):**
- ✅ **USB4 80Gbps** — maximum speed (up to 6000 MB/s)
- ✅ **USB4 40Gbps / USB 3.2** — compatible, speed limited to port capability
- ❌ **USB 3.0 Type-A** — the U35 Bolt+ will **not receive enough power** from a Type-A port to operate effectively. Only use USB-C host ports.

**Performance by Port:**
| Port | Max Speed |
|---|---|
| Thunderbolt 5 / USB4 80G | 6000 MB/s |
| Thunderbolt 4 / USB4 40G | 3800 MB/s |
| Thunderbolt 3 (Apple Silicon) | 2800 MB/s |
| Thunderbolt 3 (Intel Mac) | 1000 MB/s |

To accurately measure drive speed, Oyen Digital recommends: **AJA System Test** — https://aja.com/products/aja-system-test`
    },

    // ===== HDX PRO C USER MANUAL =====
    {
      id: "hdx_pro_c_overview",
      title: "HDX Pro C — Product Overview & Specifications",
      category: "Overview",
      products: ["HDX Pro C", "User Guides"],
      keywords: ["hdx pro c specs", "hdx pro c overview", "hdx pro c specifications", "hdx specifications", "hdx pro c chipset", "hdx pro c size", "hdx pro c power", "hdx pro c manual", "hdx pro c dimensions", "hdx pro c asmedia"],
      issue: "hdx_pro_c_overview",
      response: `**HDX Pro C — Product Overview**

The HDX Pro C is a desktop 3.5" HDD enclosure with a USB-C interface, aluminum housing, internal fan, and a built-in HUB port for daisy-chaining additional devices.

**Specifications:**
| | |
|---|---|
| **Supports** | 3.5 inch HDD SATA |
| **Interface** | USB-C (10 Gbps) |
| **Materials** | Aluminum |
| **Chipset** | ASMedia 235CM & Via VL822 |
| **Power** | Input: 90–264 VAC / Output: 36W |
| **Size** | 8.25 × 6.5 × 1.5 Inches |
| **Operating Temp** | 0°C ~ 70°C |
| **Compatible OS** | Windows, Mac OS, Linux |

**Front Panel Indicators:**
- **Power LED** — White
- **Activity LED** — Blue

**Ports (Rear Panel):**
- **MAIN USB-C** — connects to host computer
- **HUB USB-C** — connects to additional USB devices (10W bus power available)
- **ON/OFF switch**
- **FAN**
- **AC IN** (90–264 VAC)

**Warranty:** 4 Years (see Warranty entry for details)
**Support:** info@oyendigital.com`
    },
    {
      id: "hdx_pro_c_connecting",
      title: "HDX Pro C — Connections & Setup",
      category: "Setup",
      products: ["HDX Pro C", "User Guides"],
      keywords: ["hdx pro c connect", "hdx pro c setup", "hdx pro c usb-c", "hdx main port", "hdx hub port", "hdx daisy chain", "hdx chain devices", "hdx pro c plug in", "connect hdx pro c", "hdx pro c turn on"],
      issue: "hdx_pro_c_connecting",
      response: `**HDX Pro C — Connections**

**Basic Setup:**
1. Connect the USB-C cable to the **MAIN port** on the rear of the HDX Pro C
2. Connect the other end of the cable to your **host computer or device**
3. Turn on the **power switch** on the rear panel
4. The drive will mount to your computer automatically

**Daisy-Chaining Additional Devices (Optional):**
- Connect additional HDX Pro C units or other USB devices to the **HUB port** on the rear
- Up to **6 devices can be connected in a chain**
- The HUB port provides **10W of bus power** for connected devices

**LED Indicators:**
- **White LED** = Power on
- **Blue LED** = Drive activity

**Note:** Always use the MAIN USB-C port for the connection to your computer. The HUB port is for downstream devices only.`
    },
    {
      id: "hdx_pro_c_formatting",
      title: "HDX Pro C — Formatting for Mac or Windows",
      category: "Setup",
      products: ["HDX Pro C", "User Guides"],
      keywords: ["hdx pro c format", "hdx format windows", "hdx format mac", "hdx pro c reformat", "hdx windows formatter", "oyendigital formatter hdx", "hdx hfs+ format", "format hdx for windows", "hdx pro c hfs"],
      issue: "hdx_pro_c_formatting",
      response: `**HDX Pro C — Formatting**

**Mac Users:**
The HDX Pro C ships formatted as **HFS+** for macOS. Mac users can connect the drive and it will be immediately ready to use — no reformatting needed.

**Windows Users:**
Windows users must reformat the drive. Oyen Digital provides a free formatting app at <a href="https://oyendigital.com/formatter" target="_blank" rel="noopener">oyendigital.com/formatter</a>:

2. Open the app
3. Select the **Oyen HDX Pro C** from the Device list
4. Click **Start** to format

The formatter will prepare the drive for use with Windows.

**Cross-Platform (Mac + Windows):**
If you need to use the drive on both operating systems, format as **exFAT** using Disk Utility (Mac) or Disk Management (Windows). Note that exFAT does not support journaling or TRIM.`
    },
    {
      id: "hdx_pro_c_backup_software",
      title: "HDX Pro C — Recommended Backup Software",
      category: "Software",
      products: ["HDX Pro C", "User Guides"],
      keywords: ["hdx pro c backup", "hdx backup software", "hdx time machine", "hdx carbon copy cloner", "hdx windows backup", "backup hdx pro c", "hdx pro c software"],
      issue: "hdx_pro_c_backup_software",
      response: `**HDX Pro C — Recommended Backup Software**

The HDX Pro C does not include pre-installed backup software. Oyen Digital recommends the following:

**Mac:**
- **Time Machine** — Built into macOS: https://support.apple.com/en-us/HT201250
- **Carbon Copy Cloner** — Third-party bootable backup: www.bombich.com

**Windows:**
- **Windows Backup** — Built into Windows: https://bit.ly/3AaGx8e

All options support full or scheduled backups to an external drive.`
    },
    {
      id: "hdx_pro_c_ejecting",
      title: "HDX Pro C — How to Safely Eject",
      category: "Setup",
      products: ["HDX Pro C", "User Guides"],
      keywords: ["hdx pro c eject", "safely remove hdx", "unmount hdx", "disconnect hdx pro c", "eject hdx mac", "eject hdx windows", "hdx eject"],
      issue: "hdx_pro_c_ejecting",
      response: `**How to Safely Eject the HDX Pro C**

Always eject the drive before physically disconnecting it to prevent data corruption.

**Windows:**
1. Close all applications that are accessing the drive
2. Click the **"Eject Hardware"** (Safely Remove Hardware) icon in the system tray
3. Highlight the drive and wait a few seconds until the system prompts **"You may safely remove this device"**

**Mac:**
1. Close all applications that are accessing the drive
2. Drag the drive icon to the **Trash/Eject** icon in the Dock
3. Once the disk icon disappears from the desktop, you may safely disconnect the drive

⚠️ Never turn off the power switch or disconnect the cable during active file transfers.`
    },
    {
      id: "hdx_pro_c_warranty",
      title: "HDX Pro C — Warranty & Support",
      category: "Warranty",
      products: ["HDX Pro C", "User Guides"],
      keywords: ["hdx pro c warranty", "hdx warranty", "hdx 4 year warranty", "hdx pro c rma", "hdx repair replacement", "hdx warranty service", "hdx pro c support"],
      issue: "hdx_pro_c_warranty",
      response: `**HDX Pro C — Warranty & Support**

The HDX Pro C includes a **4-Year repair/replacement warranty** provided by Oyen Digital.

- **Non-transferable** — limited to the original purchaser
- **Full warranty policy:**
- **Technical support:** info@oyendigital.com`

    },

    {
      id: "xbox_warranty",
      title: "Warranty & Availability",
      category: "Warranty",
      products: ["legacy_xbox"],
      keywords: ["u32 shadow xbox warranty", "3 year warranty", "xbox ssd warranty", "discontinued xbox drive", "rma xbox"],
      issue: "xbox_warranty",
      response: `**Warranty:**
The U32 Shadow for Xbox One includes a **3-Year Factory Warranty** from the date of purchase. Non-transferable, limited to the original purchaser.

**Availability:**
The U32 Shadow for Xbox One (SKU: U32-C-SS-4T-XB) has been discontinued.

**Support contact:** support@oyendigital.com`
    },
];
